/**
 * Snuzz Creator Marketplace
 * Shopify Liquid Section + Supabase (client-side)
 */
(function () {
  'use strict';

  const CREATOR_USER_TITLE_MAX_LENGTH = 40;

  const roots = document.querySelectorAll('[data-creator-marketplace]');
  if (!roots.length) return;

  scrubSensitiveUrlParams();
  roots.forEach(initRoot);

  function scrubSensitiveUrlParams() {
    try {
      const url = new URL(window.location.href);
      const sensitive = ['password', 'email', 'passwd', 'pwd', 'token'];
      let changed = false;
      sensitive.forEach(function (key) {
        if (url.searchParams.has(key)) {
          url.searchParams.delete(key);
          changed = true;
        }
      });
      if (changed) {
        const clean = url.pathname + (url.search || '') + url.hash;
        window.history.replaceState({}, document.title, clean);
      }
    } catch (_e) {
      /* ignore */
    }
  }

  function initRoot(root) {
    const config = {
      supabaseUrl: root.dataset.supabaseUrl,
      supabaseAnonKey: root.dataset.supabaseAnonKey,
      marketplaceVariantId: root.dataset.marketplaceVariantId,
      currency: root.dataset.currency || 'EUR',
      mode: root.dataset.mode || 'portal',
      creatorSlug: root.dataset.creatorSlug || '',
      shopifyCustomerId: root.dataset.shopifyCustomerId || '',
      mockupTshirtUrl: root.dataset.mockupTshirtUrl || '',
      creatorBaseTag: root.dataset.creatorBaseTag || 'creator-base',
      minMarkup: parseFloat(root.dataset.minMarkup || '0'),
      maxMarkup: parseFloat(root.dataset.maxMarkup || '50'),
      ownListingCommissionRate: parseFloat(root.dataset.ownCommissionRate || '70'),
      allowedListingModes: root.dataset.allowedListingModes || 'both',
      shopDomain: root.dataset.shopDomain || '',
      creatorShopSubdomainBase: root.dataset.creatorShopSubdomainBase || '',
      creatorShopFallbackPath: root.dataset.creatorShopFallbackPath || '/pages/creator-shop',
      printArea: {
        x: parseFloat(root.dataset.printX || '28'),
        y: parseFloat(root.dataset.printY || '22'),
        width: parseFloat(root.dataset.printWidth || '44'),
        height: parseFloat(root.dataset.printHeight || '48'),
        width_cm: parseFloat(root.dataset.printWidthCm || '30'),
        height_cm: parseFloat(root.dataset.printHeightCm || '40'),
      },
      printMinDpi: parseInt(root.dataset.printMinDpi || '150', 10) || 150,
      loginRequired: root.dataset.loginRequired !== 'false',
      previewCreatorName: root.dataset.previewCreatorName || 'Theme-Vorschau Creator',
      previewCreatorSlug: root.dataset.previewCreatorSlug || 'theme-vorschau',
      previewCreatorId: '00000000-0000-4000-8000-000000000001',
    };

    bindRootTabClicks(root);

    if (!config.supabaseUrl || !config.supabaseAnonKey) {
      showMessage(root, 'Supabase ist nicht konfiguriert. Bitte Theme-Einstellungen prüfen.', 'error');
      return;
    }

    loadSupabase(config.supabaseUrl, config.supabaseAnonKey)
      .then(function (client) {
        return createApp(root, client, config).init();
      })
      .catch(function (err) {
        const message = err && err.message ? err.message : String(err);
        showMessage(root, 'Supabase konnte nicht geladen werden: ' + message, 'error');
        console.error('[creator-marketplace] init failed:', err);
      });
  }

  function bindRootTabClicks(root) {
    if (root.dataset.tabClicksBound) return;
    root.dataset.tabClicksBound = '1';

    root.addEventListener('click', function (e) {
      const tab = e.target.closest('[data-tab]');
      if (!tab || !tab.closest('[data-tab-group]')) return;
      const group = tab.closest('[data-tab-group]');
      if (group && tab.dataset.tab) {
        toggleTabGroup(root, group.dataset.tabGroup, tab.dataset.tab);
      }
    });
  }

  function loadSupabase(url, key) {
    return new Promise(function (resolve, reject) {
      if (window.supabase && window.supabase.createClient) {
        resolve(window.supabase.createClient(url, key));
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2/dist/umd/supabase.min.js';
      script.onload = function () {
        if (!window.supabase) {
          reject(new Error('Supabase SDK nicht verfügbar'));
          return;
        }
        resolve(window.supabase.createClient(url, key));
      };
      script.onerror = function () {
        reject(new Error('Supabase SDK konnte nicht geladen werden'));
      };
      document.head.appendChild(script);
    });
  }

  function createApp(root, client, config) {
    let creator = null;

    function isShopifyCustomerLoggedIn() {
      return !!config.shopifyCustomerId;
    }

    function isPreviewMode() {
      return !config.loginRequired && !isShopifyCustomerLoggedIn();
    }

    function buildPreviewCreator() {
      return {
        id: config.previewCreatorId,
        display_name: config.previewCreatorName,
        slug: config.previewCreatorSlug,
        status: 'approved',
        email: 'preview@theme-editor.local',
        bio: 'Fake-Profil nur für Theme-Editor-Vorschau.',
        shopify_collection_handle: config.previewCreatorSlug,
      };
    }

    async function renderPortalPreviewWithoutLogin() {
      const authEl = root.querySelector('[data-panel="auth"]');
      const dashboardEl = root.querySelector('[data-panel="dashboard"]');

      creator = buildPreviewCreator();
      clearMessage(root);

      if (authEl) authEl.classList.add('creator-marketplace__hidden');
      if (dashboardEl) dashboardEl.classList.remove('creator-marketplace__hidden');
      toggleTabGroup(root, 'dashboard', 'products');

      renderCreatorStatus(root, creator, config);
      const statusEl = root.querySelector('[data-creator-status]');
      if (statusEl) {
        statusEl.insertAdjacentHTML(
          'afterbegin',
          '<p class="creator-marketplace__hint">Vorschau mit Fake-Profil — Konfigurator testbar, Speichern erfordert Shopify-Login.</p>',
        );
      }
      renderPromotionsFromData(root, [], 3, 0, 100);
      renderStatsFromData(root, {
        stats: {
          available_earnings: 42.5,
          reserved_earnings: 18,
          pending_payout_earnings: 0,
          paid_earnings: 128,
          total_gross: 890,
          total_sales: 7,
          sales_this_month: 2,
          earnings_this_month: 12.5,
          avg_earnings_per_sale: 6.07,
          cancelled_sales: 0,
        },
        monthly_earnings: [
          { month: '2026-01', earnings: 22 },
          { month: '2026-02', earnings: 35 },
          { month: '2026-03', earnings: 18 },
          { month: '2026-04', earnings: 41 },
          { month: '2026-05', earnings: 28 },
          { month: '2026-06', earnings: 12.5 },
        ],
        active_payout_request: null,
        min_payout_amount: 10,
      });
      root._creatorProducts = [];
      renderProductsGridFromData(root, []);

      const salesTable = root.querySelector('[data-sales-table] tbody');
      if (salesTable) {
        salesTable.innerHTML =
          '<tr><td>#PREVIEW-1001</td><td>Beispiel-Artikel</td><td>24,90 €</td><td>5,00 €</td><td>offen</td></tr>';
      }
      const payoutsTable = root.querySelector('[data-payouts-table] tbody');
      if (payoutsTable) {
        payoutsTable.innerHTML =
          '<tr><td>42,50 €</td><td>ausstehend</td><td>—</td></tr>';
      }

      setupListingTypeTabs(root, config);
      setupOwnProductForm(root, config);
      initRichTextEditors(root);
      showProductsListView(root);

      try {
        prefetchConfigurator(root, client, config, creator);
      } catch (_prefetchErr) {
        /* optional */
      }
    }

    function shopifyPayload() {
      return config.shopifyCustomerId
        ? { shopify_customer_id: parseInt(config.shopifyCustomerId, 10) }
        : {};
    }

    async function loadDashboardData() {
      if (!isShopifyCustomerLoggedIn()) {
        throw new Error('Nicht autorisiert');
      }

      const { data, error } = await client.functions.invoke('creator-dashboard', {
        body: shopifyPayload(),
      });

      if (error) {
        const detail = await readFunctionError(error);
        if (detail) throw new Error(detail);
        if (data && (data.error || data.success === false)) {
          throw new Error(data.error || 'Dashboard konnte nicht geladen werden');
        }
        throw new Error(error.message || 'Dashboard konnte nicht geladen werden');
      }

      if (!data || !data.success) {
        throw new Error((data && data.error) || 'Dashboard konnte nicht geladen werden');
      }

      return data;
    }

    function isCreatorAccessDeniedMessage(message) {
      const text = String(message || '').toLowerCase();
      return (
        text.includes('creator-zugang') ||
        text.includes('kein creator') ||
        text.includes('nicht autorisiert') ||
        text.includes('creator-profil nicht gefunden')
      );
    }

    function showShopifyAuthPanel(root, activeAuthTab) {
      const authEl = root.querySelector('[data-panel="auth"]');
      const deniedEl = root.querySelector('[data-creator-access-denied]');
      const authWrap = root.querySelector('[data-creator-shopify-auth-wrap]');
      if (authEl) authEl.classList.remove('creator-marketplace__hidden');
      if (deniedEl) deniedEl.classList.add('creator-marketplace__hidden');
      if (authWrap) authWrap.classList.remove('creator-marketplace__hidden');
      toggleTabGroup(root, 'auth', activeAuthTab || 'auth-login');
    }

    function showNonCreatorState(root, message) {
      const authEl = root.querySelector('[data-panel="auth"]');
      const dashboardEl = root.querySelector('[data-panel="dashboard"]');
      const deniedEl = root.querySelector('[data-creator-access-denied]');
      const authWrap = root.querySelector('[data-creator-shopify-auth-wrap]');
      const msgEl = root.querySelector('[data-access-denied-message]');

      creator = null;
      if (!config.loginRequired) {
        renderPortalPreviewWithoutLogin();
        showMessage(root, message || 'Kein Creator-Zugang.', 'info');
        return;
      }
      if (authEl) authEl.classList.remove('creator-marketplace__hidden');
      if (dashboardEl) dashboardEl.classList.add('creator-marketplace__hidden');
      if (authWrap) authWrap.classList.add('creator-marketplace__hidden');
      if (deniedEl) deniedEl.classList.remove('creator-marketplace__hidden');
      if (msgEl) msgEl.textContent = message || 'Kein Creator-Zugang.';
      showMessage(root, message || 'Kein Creator-Zugang.', 'error');
    }

    async function renderPortal() {
      const authEl = root.querySelector('[data-panel="auth"]');
      const dashboardEl = root.querySelector('[data-panel="dashboard"]');

      if (!isShopifyCustomerLoggedIn()) {
        if (!config.loginRequired) {
          renderPortalPreviewWithoutLogin();
          return;
        }
        showShopifyAuthPanel(root);
        if (dashboardEl) dashboardEl.classList.add('creator-marketplace__hidden');
        return;
      }

      try {
        const dashboard = await loadDashboardData();
        creator = dashboard.creator;
        if (!creator) {
          showNonCreatorState(root, 'Creator-Profil nicht gefunden. Bitte als Creator registrieren.');
          return;
        }

        if (authEl) authEl.classList.add('creator-marketplace__hidden');
        if (dashboardEl) dashboardEl.classList.remove('creator-marketplace__hidden');
        toggleTabGroup(root, 'dashboard', 'products');

        renderCreatorStatus(root, creator, config);
        renderStatsFromData(root, dashboard);
        root._creatorProducts = dashboard.products || [];
        renderProductsGridFromData(root, dashboard.products || []);
        renderSalesTableFromData(root, dashboard.sales || []);
        renderPayoutsTableFromData(root, dashboard.payouts || []);
        renderPromotionsFromData(
          root,
          dashboard.coupons || [],
          dashboard.max_coupons || 3,
          dashboard.coupon_liability,
          dashboard.max_coupon_deficit,
        );
        setupListingTypeTabs(root, config);
        setupOwnProductForm(root, config);
        showProductsListView(root);

        try {
          await syncProductFormMode(root, client, config, creator);
        } catch (_syncErr) {
          /* Formular-Reset darf Dashboard nicht blockieren */
        }

        try {
          prefetchConfigurator(root, client, config, creator);
        } catch (_prefetchErr) {
          /* Prefetch optional */
        }
      } catch (err) {
        const message = err.message || 'Dashboard Fehler';
        if (isCreatorAccessDeniedMessage(message)) {
          showNonCreatorState(root, message);
        } else {
          if (dashboardEl) dashboardEl.classList.remove('creator-marketplace__hidden');
          if (authEl) authEl.classList.add('creator-marketplace__hidden');
          showMessage(root, message, 'error');
          if (creator) {
            renderProductsGridFromData(root, root._creatorProducts || []);
          }
        }
      }
    }

    async function renderMarketplace() {
      const grid = root.querySelector('[data-marketplace-grid]');
      if (!grid) return;

      grid.innerHTML = '<p>Lade Produkte…</p>';

      const { data: products, error } = await client
        .from('creator_products')
        .select('*, creators!inner(display_name, slug, status)')
        .eq('status', 'published')
        .eq('creators.status', 'approved')
        .order('created_at', { ascending: false });

      if (error) {
        grid.innerHTML = '<p class="creator-marketplace__message creator-marketplace__message--error">Fehler beim Laden.</p>';
        return;
      }

      if (!products.length) {
        grid.innerHTML = '<p>Noch keine Creator-Produkte verfügbar.</p>';
        return;
      }

      grid.innerHTML = products.map(renderProductCard).join('');
      bindAddToCart(root, config, products);
    }

    async function renderCreatorShop(slug) {
      const header = root.querySelector('[data-creator-header]');
      const grid = root.querySelector('[data-marketplace-grid]');
      if (!grid) return;

      const { data: creatorData, error: creatorError } = await client
        .from('creators')
        .select('*')
        .eq('slug', slug)
        .eq('status', 'approved')
        .maybeSingle();

      if (creatorError || !creatorData) {
        grid.innerHTML = '<p>Creator nicht gefunden.</p>';
        return;
      }

      if (header) {
        header.innerHTML =
          '<div class="creator-marketplace__creator-header">' +
          (creatorData.avatar_url
            ? '<img class="creator-marketplace__avatar" src="' + escapeHtml(creatorData.avatar_url) + '" alt="">'
            : '') +
          '<div><h2>' +
          escapeHtml(creatorData.display_name) +
          '</h2>' +
          (creatorData.bio ? '<p>' + escapeHtml(creatorData.bio) + '</p>' : '') +
          '</div></div>';
      }

      const { data: products, error } = await client
        .from('creator_products')
        .select('*')
        .eq('creator_id', creatorData.id)
        .eq('status', 'published')
        .order('created_at', { ascending: false });

      if (error || !products.length) {
        grid.innerHTML = '<p>Dieser Creator hat noch keine Produkte.</p>';
        return;
      }

      const enriched = products.map(function (p) {
        return Object.assign({}, p, { creators: creatorData });
      });

      grid.innerHTML = enriched.map(renderProductCard).join('');
      bindAddToCart(root, config, enriched);
    }

    function bindForms() {
      const productForm = root.querySelector('[data-form="product"]');
      const profileForm = root.querySelector('[data-form="profile"]');
      const creatorRegisterForm = root.querySelector('[data-form="creator-register"]');

      if (creatorRegisterForm && config.mode === 'portal') {
        creatorRegisterForm.addEventListener('submit', async function (e) {
          e.preventDefault();
          clearMessage(root);

          const displayName = creatorRegisterForm.querySelector('[name="display_name"]').value.trim();
          const email = creatorRegisterForm.querySelector('[name="email"]').value.trim();
          const password = creatorRegisterForm.querySelector('[name="password"]').value;
          const submitBtn = creatorRegisterForm.querySelector('[type="submit"]');

          if (!email.includes('@')) {
            showMessage(root, 'Bitte eine gültige E-Mail-Adresse eingeben.', 'error');
            return;
          }

          if (submitBtn) submitBtn.disabled = true;

          try {
            const { data, error } = await client.functions.invoke('register-creator', {
              body: { display_name: displayName, email: email, password: password },
            });

            if (error) {
              const detail = await readFunctionError(error);
              throw new Error(detail || error.message || 'Registrierung fehlgeschlagen');
            }

            if (!data || !data.success) {
              throw new Error((data && data.error) || 'Registrierung fehlgeschlagen');
            }

            creatorRegisterForm.reset();
            showMessage(root, data.message || 'Creator-Account angelegt. Bitte jetzt einloggen.', 'success');
            showShopifyAuthPanel(root, 'auth-login');
          } catch (registerErr) {
            showMessage(root, registerErr.message || 'Registrierung fehlgeschlagen', 'error');
          } finally {
            if (submitBtn) submitBtn.disabled = false;
          }
        });
      }

      if (profileForm) {
        profileForm.addEventListener('submit', async function (e) {
          e.preventDefault();
          if (!creator) return;
          clearMessage(root);

          const bio = profileForm.querySelector('[name="bio"]').value.trim();
          const displayName = profileForm.querySelector('[name="display_name"]').value.trim();
          const submitBtn = profileForm.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.disabled = true;

          try {
            const { data, error } = await client.functions.invoke('update-creator-profile', {
              body: Object.assign({
                display_name: displayName,
                bio: bio,
              }, shopifyPayload()),
            });

            if (error) {
              const detail = await readFunctionError(error);
              throw new Error(detail || error.message || 'Profil konnte nicht gespeichert werden');
            }

            if (!data || !data.success) {
              throw new Error((data && data.error) || 'Profil konnte nicht gespeichert werden');
            }

            showMessage(root, 'Profil gespeichert.', 'success');
            if (root._creatorReloadPortal) await root._creatorReloadPortal();
          } catch (profileErr) {
            showMessage(root, profileErr.message || 'Profil konnte nicht gespeichert werden', 'error');
          } finally {
            if (submitBtn) submitBtn.disabled = false;
          }
        });
      }

      const couponForm = root.querySelector('[data-form="coupon"]');
      if (couponForm && !couponForm.dataset.couponBound) {
        couponForm.dataset.couponBound = '1';
        const typeSelect = couponForm.querySelector('[data-coupon-type]');
        const cancelBtn = couponForm.querySelector('[data-coupon-cancel]');

        if (typeSelect) {
          typeSelect.addEventListener('change', function () {
            syncCouponFormLabels(couponForm);
          });
        }

        const valueInput = couponForm.querySelector('[data-coupon-value]');
        if (valueInput) {
          valueInput.addEventListener('input', function () {
            enforceCouponValueInput(couponForm);
          });
        }

        if (cancelBtn) {
          cancelBtn.addEventListener('click', function () {
            clearCouponFeedback(root);
            resetCouponForm(couponForm);
          });
        }

        ensureCouponFormDefaults(couponForm);
        syncCouponFormLabels(couponForm);

        couponForm.addEventListener('submit', async function (e) {
          e.preventDefault();
          if (!creator) {
            showCouponFormFeedback(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          clearCouponFormFeedback(root);

          const couponIdInput = couponForm.querySelector('[data-coupon-id]');
          const codeInput = couponForm.querySelector('[data-coupon-code]');
          const valueInput = couponForm.querySelector('[data-coupon-value]');
          const startsInput = couponForm.querySelector('[data-coupon-starts-at]');
          const endsInput = couponForm.querySelector('[data-coupon-ends-at]');
          const submitBtn = couponForm.querySelector('[data-coupon-submit]');
          const editingId = couponIdInput ? couponIdInput.value.trim() : '';
          const isUpdate = Boolean(editingId);
          const code = codeInput ? codeInput.value.trim() : '';
          const discountType = typeSelect ? typeSelect.value : 'percent';
          const discountValue = parseCouponDiscountValue(discountType, valueInput ? valueInput.value : '');
          const startsAt = startsInput ? localDatetimeToIso(startsInput.value) : '';
          const endsAt = endsInput && endsInput.value
            ? localDatetimeToIso(endsInput.value)
            : '';

          if (!isUpdate && !code) {
            showCouponFormFeedback(root, 'Bitte einen Gutscheincode eingeben', 'error');
            return;
          }

          if (!startsAt) {
            showCouponFormFeedback(root, 'Bitte ein Startdatum eingeben', 'error');
            return;
          }

          if (discountType === 'percent' && !Number.isInteger(discountValue)) {
            showCouponFormFeedback(root, 'Prozent-Rabatt nur als ganze Zahl (1–20)', 'error');
            return;
          }

          if (submitBtn) submitBtn.disabled = true;

          try {
            const payload = Object.assign({
              action: isUpdate ? 'update' : 'create',
              discount_type: discountType,
              discount_value: discountValue,
              starts_at: startsAt,
            }, shopifyPayload());

            if (endsAt) {
              payload.ends_at = endsAt;
            }

            payload.product_id = getCouponFormProductId(couponForm);

            if (isUpdate) {
              payload.coupon_id = editingId;
            } else {
              payload.code = code;
            }

            const { data, error } = await client.functions.invoke('manage-creator-coupon', {
              body: payload,
            });

            if (error) {
              const detail = await readFunctionError(error);
              throw new Error(detail || error.message || 'Coupon konnte nicht gespeichert werden');
            }

            if (!data || !data.success) {
              throw new Error((data && data.error) || 'Coupon konnte nicht gespeichert werden');
            }

            resetCouponForm(couponForm);
            showCouponFormFeedback(root, isUpdate ? 'Gutschein aktualisiert.' : 'Gutschein angelegt.', 'success');
            if (root._creatorReloadPortal) await root._creatorReloadPortal();
          } catch (couponErr) {
            showCouponFormFeedback(root, couponErr.message || 'Coupon konnte nicht gespeichert werden', 'error');
          } finally {
            if (submitBtn) submitBtn.disabled = false;
          }
        });
      }

      if (root.dataset.actionClicksBound) return;
      root.dataset.actionClicksBound = '1';

      root.addEventListener('click', async function (e) {
        const editCouponBtn = e.target.closest('[data-edit-coupon]');
        if (editCouponBtn) {
          e.preventDefault();
          const couponId = editCouponBtn.getAttribute('data-edit-coupon');
          const coupons = root._creatorCoupons || [];
          const coupon = coupons.find(function (item) { return item.id === couponId; });
          if (!coupon) {
            showCouponListFeedback(root, 'Coupon nicht gefunden', 'error');
            return;
          }
          clearCouponFeedback(root);
          const form = root.querySelector('[data-form="coupon"]');
          if (form) {
            fillCouponFormForEdit(form, coupon);
            form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          return;
        }

        const deactivateCouponBtn = e.target.closest('[data-deactivate-coupon]');
        if (deactivateCouponBtn) {
          e.preventDefault();
          if (!creator) {
            showCouponListFeedback(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          const couponId = deactivateCouponBtn.getAttribute('data-deactivate-coupon');
          if (!couponId) return;
          if (!window.confirm('Gutschein deaktivieren? Er kann danach nicht mehr eingelöst werden, lässt sich aber reaktivieren.')) {
            return;
          }

          deactivateCouponBtn.disabled = true;
          clearCouponListFeedback(root);

          try {
            const { data, error } = await client.functions.invoke('manage-creator-coupon', {
              body: Object.assign({
                action: 'deactivate',
                coupon_id: couponId,
              }, shopifyPayload()),
            });

            if (error) {
              const detail = await readFunctionError(error);
              throw new Error(detail || error.message || 'Coupon konnte nicht deaktiviert werden');
            }

            if (!data || !data.success) {
              throw new Error((data && data.error) || 'Coupon konnte nicht deaktiviert werden');
            }

            showCouponListFeedback(root, 'Gutschein deaktiviert.', 'success');
            if (root._creatorReloadPortal) await root._creatorReloadPortal();
          } catch (deactivateCouponErr) {
            showCouponListFeedback(root, deactivateCouponErr.message || 'Coupon konnte nicht deaktiviert werden', 'error');
            deactivateCouponBtn.disabled = false;
          }
          return;
        }

        const reactivateCouponBtn = e.target.closest('[data-reactivate-coupon]');
        if (reactivateCouponBtn) {
          e.preventDefault();
          if (!creator) {
            showCouponListFeedback(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          const couponId = reactivateCouponBtn.getAttribute('data-reactivate-coupon');
          if (!couponId) return;

          reactivateCouponBtn.disabled = true;
          clearCouponListFeedback(root);

          try {
            const { data, error } = await client.functions.invoke('manage-creator-coupon', {
              body: Object.assign({
                action: 'reactivate',
                coupon_id: couponId,
              }, shopifyPayload()),
            });

            if (error) {
              const detail = await readFunctionError(error);
              throw new Error(detail || error.message || 'Coupon konnte nicht reaktiviert werden');
            }

            if (!data || !data.success) {
              throw new Error((data && data.error) || 'Coupon konnte nicht reaktiviert werden');
            }

            showCouponListFeedback(root, 'Gutschein reaktiviert.', 'success');
            if (root._creatorReloadPortal) await root._creatorReloadPortal();
          } catch (reactivateCouponErr) {
            showCouponListFeedback(root, reactivateCouponErr.message || 'Coupon konnte nicht reaktiviert werden', 'error');
            reactivateCouponBtn.disabled = false;
          }
          return;
        }

        const deleteCouponBtn = e.target.closest('[data-delete-coupon]');
        if (deleteCouponBtn) {
          e.preventDefault();
          if (!creator) {
            showCouponListFeedback(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          const couponId = deleteCouponBtn.getAttribute('data-delete-coupon');
          if (!couponId) return;
          if (!window.confirm('Gutschein endgültig löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.')) {
            return;
          }

          deleteCouponBtn.disabled = true;
          clearCouponListFeedback(root);

          try {
            const { data, error } = await client.functions.invoke('manage-creator-coupon', {
              body: Object.assign({
                action: 'delete',
                coupon_id: couponId,
              }, shopifyPayload()),
            });

            if (error) {
              const detail = await readFunctionError(error);
              throw new Error(detail || error.message || 'Coupon konnte nicht gelöscht werden');
            }

            if (!data || !data.success) {
              throw new Error((data && data.error) || 'Coupon konnte nicht gelöscht werden');
            }

            showCouponListFeedback(root, 'Gutschein gelöscht.', 'success');
            if (root._creatorReloadPortal) await root._creatorReloadPortal();
          } catch (deleteCouponErr) {
            showCouponListFeedback(root, deleteCouponErr.message || 'Coupon konnte nicht gelöscht werden', 'error');
            deleteCouponBtn.disabled = false;
          }
          return;
        }

        const listingTab = e.target.closest('[data-listing-tab]');
        if (listingTab) {
          e.preventDefault();
          try {
            switchListingType(root, listingTab.dataset.listingTab, config);
          } catch (listingErr) {
            showMessage(root, listingErr.message || 'Listing-Typ konnte nicht gewechselt werden', 'error');
            console.error('[creator-marketplace] switchListingType failed:', listingErr);
          }
          return;
        }

        const editBtn = e.target.closest('[data-edit-product]');
        if (editBtn) {
          e.preventDefault();
          if (!creator) {
            showMessage(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          const productId = editBtn.dataset.editProduct;
          const products = root._creatorProducts || [];
          const product = products.find(function (p) { return p.id === productId; });
          if (product) {
            openProductStudio(root, client, config, creator, product);
          }
          return;
        }

        const newProductBtn = e.target.closest('[data-new-product]');
        if (newProductBtn) {
          e.preventDefault();
          if (!creator) {
            showMessage(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          openProductStudio(root, client, config, creator, null);
          return;
        }

        const studioBackBtn = e.target.closest('[data-studio-back]');
        if (studioBackBtn) {
          e.preventDefault();
          if (!creator) {
            showProductsListView(root);
            return;
          }
          closeProductStudio(root, client, config, creator);
          return;
        }

        const offlineBtn = e.target.closest('[data-offline-product]');
        if (offlineBtn) {
          e.preventDefault();
          if (!creator) {
            showMessage(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          const productId = offlineBtn.dataset.offlineProduct;
          if (productId) {
            manageProductAction(root, client, productId, 'offline', shopifyPayload);
          }
          return;
        }

        const deleteBtn = e.target.closest('[data-delete-product]');
        if (deleteBtn) {
          e.preventDefault();
          if (!creator) {
            showMessage(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          const productId = deleteBtn.dataset.deleteProduct;
          const title = deleteBtn.dataset.deleteTitle || '';
          if (productId) openDeleteModal(root, productId, title);
          return;
        }

        const showCreatorRegisterBtn = e.target.closest('[data-show-creator-register]');
        if (showCreatorRegisterBtn) {
          e.preventDefault();
          showShopifyAuthPanel(root, 'auth-register');
          return;
        }

        const copyShopUrlBtn = e.target.closest('[data-copy-shop-url]');
        if (copyShopUrlBtn) {
          e.preventDefault();
          const url = copyShopUrlBtn.dataset.copyUrl;
          if (url) {
            copyTextToClipboard(url).then(function () {
              showMessage(root, 'Shop-Link kopiert!', 'success');
            }).catch(function () {
              showMessage(root, 'Kopieren fehlgeschlagen', 'error');
            });
          }
          return;
        }

        const copyCouponBtn = e.target.closest('[data-copy-coupon-code]');
        if (copyCouponBtn) {
          e.preventDefault();
          const code = copyCouponBtn.getAttribute('data-copy-text');
          if (!code) return;
          copyTextToClipboard(code).then(function () {
            showCouponCardFeedback(copyCouponBtn, 'Code „' + code + '“ kopiert.', 'success');
          }).catch(function () {
            showCouponCardFeedback(copyCouponBtn, 'Kopieren fehlgeschlagen', 'error');
          });
          return;
        }

        const modalClose = e.target.closest('[data-modal-close], [data-modal-cancel]');
        if (modalClose) {
          e.preventDefault();
          closeDeleteModal(root);
          return;
        }

        const deleteConfirm = e.target.closest('[data-delete-confirm]');
        if (deleteConfirm && creator) {
          e.preventDefault();
          const productId = root.dataset.pendingDeleteProduct;
          if (productId) {
            closeDeleteModal(root);
            manageProductAction(root, client, productId, 'delete', shopifyPayload);
          }
          return;
        }

        const payoutBtn = e.target.closest('[data-request-payout]');
        if (payoutBtn && !payoutBtn.disabled) {
          e.preventDefault();
          clearMessage(root);
          const feedback = root.querySelector('[data-payout-request-feedback]');
          if (feedback) {
            feedback.textContent = '';
            feedback.className = 'creator-marketplace__form-feedback';
          }

          payoutBtn.disabled = true;
          const originalLabel = payoutBtn.textContent;
          payoutBtn.textContent = 'Wird beantragt…';

          try {
            const { data, error } = await client.functions.invoke('request-payout', {
              body: shopifyPayload(),
            });

            let response = data;
            if (error) {
              const detail = await readFunctionError(error);
              if (detail) throw new Error(detail);
              if (data && (data.error || data.success === false)) response = data;
              else throw new Error(error.message || 'Auszahlung fehlgeschlagen');
            }

            if (!response || response.success === false) {
              throw new Error((response && response.error) || 'Auszahlung fehlgeschlagen');
            }

            showMessage(root, response.message || 'Auszahlung beantragt.', 'success');
            if (root._creatorReloadPortal) await root._creatorReloadPortal();
          } catch (payoutErr) {
            const msg = payoutErr && payoutErr.message ? payoutErr.message : 'Auszahlung fehlgeschlagen';
            showMessage(root, msg, 'error');
            if (feedback) {
              feedback.textContent = msg;
              feedback.classList.add('is-error');
            }
            payoutBtn.disabled = false;
            payoutBtn.textContent = originalLabel;
          }
          return;
        }

        const generateDescBtn = e.target.closest('[data-generate-description]');
        if (generateDescBtn) {
          e.preventDefault();
          await handleGenerateDescription(root, client, config, shopifyPayload, generateDescBtn);
          return;
        }

        const syncBtn = e.target.closest('[data-sync-product]');
        if (!syncBtn || !creator) return;

        e.preventDefault();
        const productId = syncBtn.dataset.syncProduct;
        if (!productId) return;

        syncBtn.disabled = true;
        syncBtn.textContent = 'Sync…';
        clearMessage(root);

        try {
          const { data, error } = await client.functions.invoke('sync-shopify-product', {
            body: Object.assign({ product_id: productId }, shopifyPayload()),
          });

          let response = data;
          if (error) {
            const detail = await readFunctionError(error);
            if (detail) throw new Error(detail);
            if (data && (data.error || data.success === false)) {
              response = data;
            } else {
              throw new Error(error.message || 'Edge Function Fehler');
            }
          }

          if (!response || response.success === false) {
            const msg = response && response.error ? response.error : 'Shopify-Sync fehlgeschlagen';
            showMessage(root, msg, 'error');
            return;
          }

          showMessage(root, 'Produkt erfolgreich mit Shopify synchronisiert.', 'success');
          await renderPortal();
        } catch (err) {
          const msg = err && err.message ? err.message : 'Shopify-Sync fehlgeschlagen';
          showMessage(root, msg, 'error');
        } finally {
          syncBtn.disabled = false;
          syncBtn.textContent = 'Erneut syncen';
        }
      });

      root.addEventListener('keydown', async function (e) {
        if (e.key !== 'Enter') return;
        const promptInput = e.target.closest('[data-description-ai-prompt]');
        if (!promptInput) return;
        e.preventDefault();
        const field = promptInput.closest('.creator-marketplace__field');
        const generateBtn = field ? field.querySelector('[data-generate-description]') : null;
        if (generateBtn) {
          await handleGenerateDescription(root, client, config, shopifyPayload, generateBtn);
        }
      });

      if (productForm && !productForm.dataset.configuratorBound) {
        productForm.dataset.configuratorBound = '1';
        productForm.addEventListener('submit', async function (e) {
          e.preventDefault();
          if (!creator) {
            showMessage(root, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
            return;
          }
          await submitProductForm(root, client, config, productForm, shopifyPayload, creator);
        });
      }
    }

    return {
      init: async function () {
        try {
          if (!config.creatorSlug) {
            const params = new URLSearchParams(window.location.search);
            config.creatorSlug = params.get('creator') || '';
          }

          // Veraltete Supabase-Sessions entfernen — Portal-Auth läuft nur über Shopify.
          // Sonst wird bei API-Aufrufen fälschlich das erste Creator-JWT verwendet.
          if (config.mode === 'portal') {
            try {
              await client.auth.signOut();
            } catch (_signOutErr) {
              /* ignore */
            }
          }

          bindTabs(root);
          bindForms();
          root._creatorReloadPortal = renderPortal;

          if (config.mode === 'portal') {
            await renderPortal();
          } else if (config.mode === 'marketplace') {
            await renderMarketplace();
          } else if (config.mode === 'creator-shop') {
            await renderCreatorShop(config.creatorSlug);
          }
        } catch (err) {
          const message = err && err.message ? err.message : 'Unbekannter Initialisierungsfehler';
          showMessage(root, 'Portal-Initialisierung fehlgeschlagen: ' + message, 'error');
          console.error('[creator-marketplace] portal init failed:', err);
        }
      },
    };
  }

  function bindTabs(root) {
    root.querySelectorAll('[data-tab-group]').forEach(function (group) {
      const groupName = group.dataset.tabGroup;
      const activeTab = group.querySelector('[data-tab].is-active');
      if (groupName && activeTab && activeTab.dataset.tab) {
        toggleTabGroup(root, groupName, activeTab.dataset.tab);
      }
    });
  }

  function toggleTabGroup(root, groupName, activeTab) {
    const group = root.querySelector('[data-tab-group="' + groupName + '"]');
    if (!group) return;

    group.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.dataset.tab === activeTab);
    });

    const panelContainer = root.querySelector('[data-tab-panels="' + groupName + '"]');
    if (!panelContainer) return;

    panelContainer.querySelectorAll('.creator-marketplace__panel[data-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.dataset.panel === activeTab);
    });

    if (activeTab === 'promotions') {
      clearCouponFeedback(root);
      const couponForm = root.querySelector('[data-form="coupon"]');
      if (couponForm) {
        ensureCouponFormDefaults(couponForm);
      }
    }
  }

  function isGenericVariantTitle(title) {
    return /^default\s*title$/i.test(String(title || '').trim());
  }

  function formatVariantDisplayTitle(variant) {
    if (!variant) return '';
    const trimmed = String(variant.title || '').trim();
    if (trimmed && !isGenericVariantTitle(trimmed)) return trimmed;
    const parts = [variant.option1, variant.option2, variant.option3]
      .map(function (v) { return String(v || '').trim(); })
      .filter(function (v) { return v && !isGenericVariantTitle(v); });
    return parts.join(' / ');
  }

  function buildCreatorShopUrl(creator, config) {
    const origin = window.location.origin;
    const subdomainBase = (config.creatorShopSubdomainBase || '').trim()
      .replace(/^https?:\/\//i, '')
      .replace(/\/$/, '');

    if (subdomainBase) {
      return 'https://' + creator.slug + '.' + subdomainBase;
    }

    if (creator.shopify_collection_handle) {
      return origin + '/collections/' + encodeURIComponent(creator.shopify_collection_handle);
    }

    const path = config.creatorShopFallbackPath || '/pages/creator-shop';
    const normalizedPath = path.startsWith('/') ? path : '/' + path;
    return origin + normalizedPath + '?creator=' + encodeURIComponent(creator.slug);
  }

  function getCreatorShopUrlLabel(url, config) {
    if (config.creatorShopSubdomainBase) {
      return url.replace(/^https?:\/\//i, '');
    }
    return url.replace(window.location.origin, '') || url;
  }

  function renderCreatorStatus(root, creator, config) {
    const el = root.querySelector('[data-creator-status]');
    const profileForm = root.querySelector('[data-form="profile"]');
    if (!el) return;

    const statusLabels = {
      pending: 'Wartet auf Freigabe',
      approved: 'Aktiv',
      rejected: 'Abgelehnt',
      suspended: 'Gesperrt',
    };

    const shopUrl = buildCreatorShopUrl(creator, config);
    const shopLabel = getCreatorShopUrlLabel(shopUrl, config);
    const urlType = config.creatorShopSubdomainBase
      ? 'Deine Creator-Subdomain'
      : creator.shopify_collection_handle
        ? 'Deine Shop-Kollektion'
        : 'Dein Creator-Shop';

    const shopCard =
      '<div class="creator-marketplace__shop-card">' +
      '<div class="creator-marketplace__shop-card-label">' + escapeHtml(urlType) + '</div>' +
      '<a class="creator-marketplace__shop-card-url" href="' + escapeHtml(shopUrl) + '" target="_blank" rel="noopener">' +
      escapeHtml(shopLabel) +
      '</a>' +
      '<div class="creator-marketplace__shop-card-actions">' +
      '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small creator-marketplace__btn--secondary" data-copy-shop-url data-copy-url="' +
      escapeHtml(shopUrl) + '">Link kopieren</button>' +
      '<a class="creator-marketplace__btn creator-marketplace__btn--small" href="' + escapeHtml(shopUrl) + '" target="_blank" rel="noopener">Shop öffnen</a>' +
      '</div></div>';

    el.innerHTML =
      '<p><strong>Status:</strong> <span class="creator-marketplace__badge">' +
      (statusLabels[creator.status] || creator.status) +
      '</span></p>' +
      shopCard;

    if (profileForm) {
      profileForm.querySelector('[name="display_name"]').value = creator.display_name || '';
      profileForm.querySelector('[name="bio"]').value = creator.bio || '';
    }
  }

  function formatPayoutStatusLabel(status) {
    const labels = {
      reserved: 'Ausstehend',
      available: 'Auszahlbar',
      pending: 'Angefragt',
      paid: 'Ausgezahlt',
      cancelled: 'Storniert',
    };
    return labels[status] || status;
  }

  function formatPayoutRequestStatusLabel(status) {
    const labels = {
      pending: 'Angefragt',
      processing: 'In Bearbeitung',
      completed: 'Abgeschlossen',
      failed: 'Fehlgeschlagen',
    };
    return labels[status] || status;
  }

  function payoutStatusBadge(status) {
    const modifier = status ? ' creator-marketplace__badge--' + status : '';
    return (
      '<span class="creator-marketplace__badge' + modifier + '">' +
      escapeHtml(formatPayoutStatusLabel(status)) +
      '</span>'
    );
  }

  function formatMonthLabel(monthKey) {
    if (!monthKey) return '';
    const parts = monthKey.split('-');
    if (parts.length !== 2) return monthKey;
    const date = new Date(Number(parts[0]), Number(parts[1]) - 1, 1);
    return date.toLocaleDateString('de-DE', { month: 'short', year: '2-digit' });
  }

  function renderMonthlyChart(monthlyEarnings) {
    const rows = monthlyEarnings || [];
    if (!rows.length) return '';

    const max = Math.max.apply(
      null,
      rows.map(function (r) { return Number(r.earnings) || 0; }).concat([1])
    );

    const bars = rows.map(function (row) {
      const value = Number(row.earnings) || 0;
      const height = Math.max(8, Math.round((value / max) * 100));
      return (
        '<div class="creator-marketplace__chart-bar" title="' + formatMoney(value) + '">' +
        '<div class="creator-marketplace__chart-bar-fill" style="height:' + height + '%"></div>' +
        '<span class="creator-marketplace__chart-bar-label">' + escapeHtml(formatMonthLabel(row.month)) + '</span>' +
        '</div>'
      );
    }).join('');

    return (
      '<div class="creator-marketplace__chart">' +
      '<div class="creator-marketplace__chart-title">Provisionen (6 Monate)</div>' +
      '<div class="creator-marketplace__chart-bars">' + bars + '</div>' +
      '</div>'
    );
  }

  function renderStatsFromData(root, dashboard) {
    const statsEl = root.querySelector('[data-stats]');
    if (!statsEl) return;

    const data = dashboard && dashboard.stats ? dashboard.stats : dashboard;
    const monthly = dashboard && dashboard.monthly_earnings ? dashboard.monthly_earnings : [];
    const activePayout = dashboard && dashboard.active_payout_request;
    const minAmount = dashboard && dashboard.min_payout_amount ? dashboard.min_payout_amount : 10;
    const available = Number(data ? data.available_earnings : 0) || 0;
    const hasActiveRequest = Boolean(activePayout);
    const canRequest = available >= minAmount && !hasActiveRequest;

    let payoutBtnLabel = 'Auszahlung beantragen';
    let payoutBtnDisabled = !canRequest;
    let payoutHint = 'Mindestbetrag: ' + formatMoney(minAmount) + ' · Nach Versand + 14 Tage Widerrufsfrist';

    if (hasActiveRequest) {
      payoutBtnLabel = 'Anfrage läuft (' + formatMoney(activePayout.amount) + ')';
      payoutBtnDisabled = true;
      payoutHint = 'Deine Auszahlungsanfrage wird bearbeitet.';
    } else if (available > 0 && available < minAmount) {
      payoutHint = 'Noch ' + formatMoney(minAmount - available) + ' bis zum Mindestbetrag von ' + formatMoney(minAmount);
    }

    statsEl.innerHTML =
      '<div class="creator-marketplace__stats-dashboard">' +
      '<div class="creator-marketplace__stats-hero">' +
      '<div class="creator-marketplace__stats-hero-main">' +
      '<span class="creator-marketplace__stats-hero-label">Jetzt auszahlbar</span>' +
      '<div class="creator-marketplace__stats-hero-value">' + formatMoney(available) + '</div>' +
      '<p class="creator-marketplace__stats-hero-hint">' + escapeHtml(payoutHint) + '</p>' +
      '</div>' +
      '<div class="creator-marketplace__stats-hero-action">' +
      '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--payout" data-request-payout' +
      (payoutBtnDisabled ? ' disabled' : '') + '>' + escapeHtml(payoutBtnLabel) + '</button>' +
      '</div>' +
      '</div>' +
      '<div class="creator-marketplace__stats">' +
      statCard(formatMoney(data ? data.reserved_earnings : 0), 'Ausstehend', 'Wartet auf Versand + Widerrufsfrist', 'reserved') +
      statCard(formatMoney(data ? data.pending_payout_earnings : 0), 'In Bearbeitung', 'Auszahlung angefragt', 'pending') +
      statCard(formatMoney(data ? data.paid_earnings : 0), 'Ausgezahlt', 'Bereits überwiesen', 'paid') +
      statCard(String(data ? data.total_sales : 0), 'Verkäufe', 'Gesamt (ohne Stornos)', 'sales') +
      statCard(formatMoney(data ? data.total_gross : 0), 'Umsatz', 'Bruttoumsatz deiner Artikel', 'gross') +
      statCard(formatMoney(data ? data.earnings_this_month : 0), 'Diesen Monat', String(data ? data.sales_this_month : 0) + ' Verkäufe', 'month') +
      '</div>' +
      renderMonthlyChart(monthly) +
      '</div>';
  }

  function formatListingTypeLabel(listingType) {
    return listingType === 'own' ? 'Eigenes Produkt' : 'Dropshipping';
  }

  function formatProductStatusLabel(status) {
    const labels = {
      published: 'Online',
      draft: 'Offline',
      pending: 'Zur Freigabe',
      rejected: 'Abgelehnt',
      archived: 'Archiviert',
    };
    return labels[status] || status;
  }

  var CREATOR_TITLE_SEPARATOR = ' | ';

  function splitProductTitleParts(title) {
    var normalized = String(title || '').trim();
    var separator = normalized.indexOf(CREATOR_TITLE_SEPARATOR) !== -1
      ? CREATOR_TITLE_SEPARATOR
      : ' — ';

    return normalized
      .split(separator)
      .map(function (p) { return p.trim(); })
      .filter(function (p) { return p && !isGenericVariantTitle(p); });
  }

  function parseProductTitle(title) {
    var parts = splitProductTitleParts(title);
    var usesPipeFormat = String(title || '').indexOf(CREATOR_TITLE_SEPARATOR) !== -1;

    if (usesPipeFormat && parts.length >= 3) {
      return {
        creatorName: parts[0],
        userTitle: parts[1],
        productTitle: parts[2],
      };
    }

    if (parts.length >= 2) {
      return {
        creatorName: '',
        userTitle: parts[0],
        productTitle: parts[1],
      };
    }

    return {
      creatorName: '',
      userTitle: parts[0] || '',
      productTitle: '',
    };
  }

  function cleanProductDisplayTitle(title) {
    var parsed = parseProductTitle(title);
    return [parsed.creatorName, parsed.userTitle, parsed.productTitle]
      .filter(Boolean)
      .join(CREATOR_TITLE_SEPARATOR);
  }

  function getArticleTitleFromProducts(products) {
    if (!products.length) return '';
    return cleanProductDisplayTitle(products[0].title);
  }

  function groupProductsForDisplay(products) {
    const map = {};
    const groups = [];
    products.forEach(function (p) {
      const key = p.shopify_product_id
        ? 'shopify:' + p.shopify_product_id
        : 'row:' + p.id;
      if (!map[key]) {
        map[key] = { key: key, products: [] };
        groups.push(map[key]);
      }
      map[key].products.push(p);
    });
    return groups;
  }

  function getGroupPriceRange(products) {
    const prices = products.map(function (p) { return Number(p.price); });
    const min = Math.min.apply(null, prices);
    const max = Math.max.apply(null, prices);
    return min === max ? formatMoney(min) : formatMoney(min) + ' – ' + formatMoney(max);
  }

  function getProductGroupImageUrl(products) {
    if (!products || !products.length) return '';
    const imageUrls = {};
    for (let i = 0; i < products.length; i++) {
      const url = products[i].image_url;
      if (url) imageUrls[url] = (imageUrls[url] || 0) + 1;
    }
    const imageKeys = Object.keys(imageUrls);
    if (imageKeys.length === 1) return imageKeys[0];
    if (imageKeys.length > 1) {
      let bestUrl = imageKeys[0];
      let bestCount = imageUrls[bestUrl];
      for (let j = 1; j < imageKeys.length; j++) {
        if (imageUrls[imageKeys[j]] > bestCount) {
          bestUrl = imageKeys[j];
          bestCount = imageUrls[imageKeys[j]];
        }
      }
      return bestUrl;
    }
    for (let k = 0; k < products.length; k++) {
      if (products[k].preview_url) return products[k].preview_url;
    }
    return products[0].design_url || '';
  }

  function openDeleteModal(root, productId, title) {
    root.dataset.pendingDeleteProduct = productId;
    const modal = root.querySelector('[data-delete-modal]');
    const titleEl = root.querySelector('[data-delete-modal-product]');
    if (titleEl) titleEl.textContent = title || '';
    if (modal) {
      modal.classList.remove('creator-marketplace__hidden');
      modal.setAttribute('aria-hidden', 'false');
    }
  }

  function closeDeleteModal(root) {
    delete root.dataset.pendingDeleteProduct;
    const modal = root.querySelector('[data-delete-modal]');
    if (modal) {
      modal.classList.add('creator-marketplace__hidden');
      modal.setAttribute('aria-hidden', 'true');
    }
  }

  async function manageProductAction(root, client, productId, action, shopifyPayloadFn) {
    clearMessage(root);
    try {
      const { data, error } = await client.functions.invoke('manage-shopify-product', {
        body: Object.assign({ product_id: productId, action: action }, shopifyPayloadFn()),
      });

      let response = data;
      if (error) {
        const detail = await readFunctionError(error);
        if (detail) throw new Error(detail);
        if (data && (data.error || data.success === false)) response = data;
        else throw new Error(error.message || 'Aktion fehlgeschlagen');
      }

      if (!response || response.success === false) {
        throw new Error((response && response.error) || 'Aktion fehlgeschlagen');
      }

      showMessage(root, response.message || 'Erfolgreich', 'success');
      if (root._creatorReloadPortal) await root._creatorReloadPortal();
    } catch (err) {
      showMessage(root, err.message || 'Fehler', 'error');
    }
  }

  function renderNewProductCard() {
    return (
      '<button type="button" class="creator-marketplace__product-card creator-marketplace__product-card--new" data-new-product>' +
      '<span class="creator-marketplace__product-card-new-icon" aria-hidden="true">+</span>' +
      '<span class="creator-marketplace__product-card-new-label">Neues Produkt anlegen</span>' +
      '<span class="creator-marketplace__hint">Motiv hochladen & Artikel wählen</span>' +
      '</button>'
    );
  }

  function showProductsListView(root) {
    const listView = root.querySelector('[data-products-list-view]');
    const studioView = root.querySelector('[data-product-studio-view]');
    if (listView) listView.classList.remove('creator-marketplace__hidden');
    if (studioView) studioView.classList.add('creator-marketplace__hidden');
  }

  function showProductStudioView(root) {
    const listView = root.querySelector('[data-products-list-view]');
    const studioView = root.querySelector('[data-product-studio-view]');
    if (listView) listView.classList.add('creator-marketplace__hidden');
    if (studioView) studioView.classList.remove('creator-marketplace__hidden');
  }

  function setStudioHeader(root, title, subtitle) {
    const titleEl = root.querySelector('[data-studio-title]');
    const subtitleEl = root.querySelector('[data-studio-subtitle]');
    if (titleEl) titleEl.textContent = title;
    if (subtitleEl && subtitle) subtitleEl.textContent = subtitle;
  }

  async function ensureConfiguratorReady(root, client, config, creator) {
    if (root._configuratorReady) return;
    await setupProductConfigurator(root, client, config, creator);
    root._configuratorReady = true;
  }

  function prefetchConfigurator(root, client, config, creator) {
    if (root._configuratorReady || root._configuratorPrefetching) return;
    root._configuratorPrefetching = true;
    ensureConfiguratorReady(root, client, config, creator)
      .catch(function () { root._configuratorPrefetching = false; });
  }

  async function openProductStudio(root, client, config, creator, product) {
    await ensureConfiguratorReady(root, client, config, creator);
    showProductStudioView(root);
    if (product) {
      const related = (root._creatorProducts || []).filter(function (p) {
        return product.shopify_product_id && p.shopify_product_id === product.shopify_product_id;
      });
      const titleProducts = related.length ? related : [product];
      setStudioHeader(root, 'Artikel bearbeiten', getArticleTitleFromProducts(titleProducts));
      await populateProductFormForEdit(root, client, config, creator, product, related);
    } else {
      setStudioHeader(
        root,
        'Neues Produkt anlegen',
        'Design Studio — Motiv hochladen, positionieren und Artikel auswählen.',
      );
      await resetProductFormForCreate(root, client, config, creator);
    }
    const studioView = root.querySelector('[data-product-studio-view]');
    if (studioView) studioView.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  async function closeProductStudio(root, client, config, creator) {
    await resetProductFormForCreate(root, client, config, creator);
    showProductsListView(root);
  }

  function renderProductsGridFromData(root, data) {
    const grid = root.querySelector('[data-products-grid]');
    if (!grid) return;

    const groups = data.length ? groupProductsForDisplay(data) : [];
    const cardsHtml = groups.map(function (group) {
      const products = group.products;
      const rep = products[0];
      const title = getArticleTitleFromProducts(products);
      const listingType = rep.listing_type || 'dropship';
      const imageUrl = getProductGroupImageUrl(products);
      const variantCount = products.length;
      const variantLabel = variantCount === 1 ? '1 Variante' : variantCount + ' Varianten';
      const stockLabel = listingType === 'own' ? String(rep.inventory_quantity) + ' im Lager' : 'Shop-Lager';
      const statusClass = rep.status === 'published' ? 'is-online' : 'is-offline';
      const canOffline = rep.status === 'published';
      const syncHint = rep.shopify_sync_status === 'failed'
        ? '<span class="creator-marketplace__product-sync is-error" title="' + escapeHtml(rep.shopify_sync_error || '') + '">Sync fehlgeschlagen</span>'
        : rep.shopify_sync_status === 'synced'
          ? '<span class="creator-marketplace__product-sync is-ok">Shopify ✓</span>'
          : '';

      return (
        '<article class="creator-marketplace__product-card">' +
        (imageUrl
          ? '<img class="creator-marketplace__product-card-image" src="' + escapeHtml(imageUrl) + '" alt="">'
          : '<div class="creator-marketplace__product-card-image creator-marketplace__product-card-placeholder"></div>') +
        '<div class="creator-marketplace__product-card-body">' +
        '<div class="creator-marketplace__product-card-top">' +
        '<span class="creator-marketplace__badge">' + escapeHtml(formatListingTypeLabel(listingType)) + '</span>' +
        '<span class="creator-marketplace__product-status ' + statusClass + '">' + escapeHtml(formatProductStatusLabel(rep.status)) + '</span>' +
        '</div>' +
        '<h3 class="creator-marketplace__product-card-title">' + escapeHtml(title) + '</h3>' +
        '<p class="creator-marketplace__product-card-meta">' +
        escapeHtml(variantLabel) + ' · ' + getGroupPriceRange(products) + ' · ' + escapeHtml(stockLabel) +
        '</p>' +
        syncHint +
        '<div class="creator-marketplace__product-card-actions">' +
        '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small" data-edit-product="' + escapeHtml(rep.id) + '">Bearbeiten</button>' +
        (canOffline
          ? '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small creator-marketplace__btn--secondary" data-offline-product="' + escapeHtml(rep.id) + '">Offline</button>'
          : '') +
        (rep.shopify_sync_status === 'failed'
          ? '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small creator-marketplace__btn--secondary" data-sync-product="' + escapeHtml(rep.id) + '">Sync</button>'
          : '') +
        '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small creator-marketplace__btn--danger" data-delete-product="' +
        escapeHtml(rep.id) + '" data-delete-title="' + escapeHtml(title) + '">Löschen</button>' +
        '</div></div></article>'
      );
    }).join('');

    grid.innerHTML = renderNewProductCard() + cardsHtml;
  }

  function renderSalesTableFromData(root, data) {
    const table = root.querySelector('[data-sales-table] tbody');
    if (!table) return;

    if (!data.length) {
      table.innerHTML = '<tr><td colspan="5">Noch keine Verkäufe</td></tr>';
      return;
    }

    table.innerHTML = data.map(function (s) {
      const statusHint = s.payout_status === 'reserved' && s.available_at
        ? ' <span class="creator-marketplace__hint-inline">ab ' + new Date(s.available_at).toLocaleDateString('de-DE') + '</span>'
        : '';
      return (
        '<tr class="' + (s.payout_status === 'cancelled' ? 'is-cancelled' : '') + '">' +
        '<td>' + escapeHtml(s.shopify_order_name || String(s.shopify_order_id)) + '</td>' +
        '<td>' + escapeHtml(s.product_title) + '</td>' +
        '<td>' + formatMoney(s.gross_amount) + '</td>' +
        '<td>' + formatMoney(s.creator_earnings) + '</td>' +
        '<td>' + payoutStatusBadge(s.payout_status) + statusHint + '</td></tr>'
      );
    }).join('');
  }

  function formatCouponDiscount(coupon) {
    if (!coupon) return '—';
    const value = Number(coupon.discount_value) || 0;
    if (coupon.discount_type === 'fixed') return formatMoney(value);
    return Math.round(value) + ' %';
  }

  function isCouponActive(coupon) {
    return !coupon || coupon.status !== 'disabled';
  }

  function getCouponEligibleProducts(products) {
    return (products || []).filter(function (product) {
      return product.status === 'published' && product.shopify_product_id;
    });
  }

  function getCouponProductChoices(products) {
    return groupProductsForDisplay(getCouponEligibleProducts(products)).map(function (group) {
      const rep = group.products[0];
      const parsed = parseProductTitle(rep.title);
      const title = parsed.userTitle || cleanProductDisplayTitle(rep.title);
      const subtitleParts = [parsed.productTitle].filter(Boolean);
      const variantCount = group.products.length;
      if (variantCount > 1) {
        subtitleParts.push(variantCount + ' Varianten');
      }
      return {
        id: rep.id,
        shopifyProductId: rep.shopify_product_id,
        title: title,
        subtitle: subtitleParts.join(' · '),
        variantCount: variantCount,
        imageUrl: getProductGroupImageUrl(group.products),
      };
    });
  }

  function resolveCouponScopeProductId(productId, products) {
    if (!productId) return '';
    const groups = groupProductsForDisplay(getCouponEligibleProducts(products));
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      if (group.products.some(function (product) { return product.id === productId; })) {
        return group.products[0].id;
      }
    }
    return productId;
  }

  function getCouponScopeLabelForProductId(productId, products) {
    if (!productId) return 'gesamte Kollektion';
    const groups = groupProductsForDisplay(getCouponEligibleProducts(products));
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      if (group.products.some(function (product) { return product.id === productId; })) {
        const parsed = parseProductTitle(group.products[0].title);
        return parsed.userTitle || cleanProductDisplayTitle(group.products[0].title);
      }
    }
    return '1 Produkt';
  }

  function formatCouponScopeLabel(coupon, products) {
    if (!coupon || !coupon.product_id) {
      return 'Gilt für: gesamte Kollektion';
    }
    return 'Gilt für: ' + getCouponScopeLabelForProductId(coupon.product_id, products);
  }

  function getCouponFormProductId(form) {
    if (!form) return null;
    const input = form.querySelector('[data-coupon-product-id]');
    return input && input.value ? input.value : null;
  }

  function setCouponScopeSelection(form, productId) {
    if (!form) return;
    const hiddenInput = form.querySelector('[data-coupon-product-id]');
    const scopeRoot = form.querySelector('[data-coupon-scope]');
    if (!hiddenInput || !scopeRoot) return;

    const normalizedId = productId || '';
    hiddenInput.value = normalizedId;

    scopeRoot.querySelectorAll('[data-coupon-scope-option]').forEach(function (option) {
      const optionValue = option.getAttribute('data-coupon-scope-value') || '';
      const selected = optionValue === normalizedId;
      option.classList.toggle('is-selected', selected);
      const radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = selected;
    });
  }

  function bindCouponScopePicker(form) {
    if (!form || form.dataset.couponScopeBound === '1') return;
    form.dataset.couponScopeBound = '1';

    form.addEventListener('change', function (event) {
      const radio = event.target;
      if (!radio.matches('input[type="radio"]') || !radio.closest('[data-coupon-scope]')) return;
      setCouponScopeSelection(form, radio.value);
    });

    form.addEventListener('click', function (event) {
      const option = event.target.closest('[data-coupon-scope-option]');
      if (!option || !form.contains(option)) return;
      const value = option.getAttribute('data-coupon-scope-value') || '';
      const radio = option.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.checked = true;
      setCouponScopeSelection(form, value);
    });
  }

  function syncCouponScopePicker(form, products, selectedProductId) {
    if (!form) return;
    bindCouponScopePicker(form);

    const optionsEl = form.querySelector('[data-coupon-scope-options]');
    const hintEl = form.querySelector('[data-coupon-scope-hint]');
    const hiddenInput = form.querySelector('[data-coupon-product-id]');
    if (!optionsEl || !hiddenInput) return;

    const choices = getCouponProductChoices(products);
    const currentSelection = resolveCouponScopeProductId(
      selectedProductId != null ? selectedProductId : hiddenInput.value,
      products,
    );

    const scopeName = 'coupon_scope_' + (form.getAttribute('data-form') || 'coupon');
    const collectionOption =
      '<label class="creator-marketplace__coupon-scope-option' + (currentSelection ? '' : ' is-selected') + '" data-coupon-scope-value="">' +
      '<input type="radio" name="' + escapeHtml(scopeName) + '" value=""' + (currentSelection ? '' : ' checked') + '>' +
      '<span class="creator-marketplace__coupon-scope-icon" aria-hidden="true">∞</span>' +
      '<span class="creator-marketplace__coupon-scope-text">' +
      '<strong>Gesamte Kollektion</strong>' +
      '<span>Alle veröffentlichten Produkte</span>' +
      '</span>' +
      '</label>';

    const productOptions = choices.map(function (choice) {
      const selected = currentSelection === choice.id;
      const thumb = choice.imageUrl
        ? '<img class="creator-marketplace__coupon-scope-thumb" src="' + escapeHtml(choice.imageUrl) + '" alt="">'
        : '<span class="creator-marketplace__coupon-scope-thumb creator-marketplace__coupon-scope-thumb--placeholder" aria-hidden="true"></span>';
      return (
        '<label class="creator-marketplace__coupon-scope-option' + (selected ? ' is-selected' : '') + '" data-coupon-scope-value="' + escapeHtml(choice.id) + '">' +
        '<input type="radio" name="' + escapeHtml(scopeName) + '" value="' + escapeHtml(choice.id) + '"' + (selected ? ' checked' : '') + '>' +
        thumb +
        '<span class="creator-marketplace__coupon-scope-text">' +
        '<strong>' + escapeHtml(choice.title) + '</strong>' +
        (choice.subtitle ? '<span>' + escapeHtml(choice.subtitle) + '</span>' : '') +
        '</span>' +
        '</label>'
      );
    });

    optionsEl.innerHTML = collectionOption + productOptions.join('');

    if (!choices.length) {
      optionsEl.insertAdjacentHTML(
        'beforeend',
        '<p class="creator-marketplace__coupon-scope-empty">Noch keine veröffentlichten Einzelprodukte — der Gutschein gilt für die Kollektion, sobald Produkte online sind.</p>',
      );
    }

    setCouponScopeSelection(form, currentSelection);

    if (hintEl) {
      hintEl.textContent = choices.length
        ? 'Standard: gesamte Kollektion. Optional genau ein Artikel (alle Farbvarianten inklusive).'
        : 'Standard: gesamte Kollektion. Optional nur ein veröffentlichtes Produkt.';
    }
  }

  function formatCouponDate(iso) {
    if (!iso) return '—';
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  function localDatetimeToIso(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toISOString();
  }

  function getLocalDatetimeInputValue(date) {
    const value = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(value.getTime())) return '';
    const pad = function (num) { return String(num).padStart(2, '0'); };
    return value.getFullYear() + '-' + pad(value.getMonth() + 1) + '-' + pad(value.getDate()) +
      'T' + pad(value.getHours()) + ':' + pad(value.getMinutes());
  }

  function isoToLocalDatetimeInput(iso) {
    if (!iso) return '';
    return getLocalDatetimeInputValue(new Date(iso));
  }

  function isCouponFormEditing(form) {
    if (!form) return false;
    const couponIdInput = form.querySelector('[data-coupon-id]');
    return Boolean(couponIdInput && couponIdInput.value.trim());
  }

  function ensureCouponFormDefaults(form) {
    if (!form || isCouponFormEditing(form)) return;

    const startsInput = form.querySelector('[data-coupon-starts-at]');
    const endsInput = form.querySelector('[data-coupon-ends-at]');

    if (startsInput) {
      startsInput.value = getLocalDatetimeInputValue(new Date());
    }

    if (endsInput) {
      endsInput.removeAttribute('required');
      endsInput.required = false;
    }
  }

  function parseCouponDiscountValue(discountType, rawValue) {
    if (discountType === 'percent') {
      const parsed = parseInt(String(rawValue), 10);
      return Number.isFinite(parsed) ? parsed : NaN;
    }
    return parseFloat(rawValue);
  }

  function enforceCouponValueInput(form) {
    if (!form) return;
    const typeSelect = form.querySelector('[data-coupon-type]');
    const valueInput = form.querySelector('[data-coupon-value]');
    if (!typeSelect || !valueInput || typeSelect.value !== 'percent' || !valueInput.value) return;
    const normalized = String(parseInt(valueInput.value, 10));
    if (normalized !== 'NaN' && valueInput.value !== normalized) {
      valueInput.value = normalized;
    }
  }

  function resetCouponForm(form) {
    if (!form) return;
    form.reset();
    const couponIdInput = form.querySelector('[data-coupon-id]');
    const titleEl = form.querySelector('[data-coupon-form-title]');
    const codeField = form.querySelector('[data-coupon-code-field]');
    const codeInput = form.querySelector('[data-coupon-code]');
    const endsInput = form.querySelector('[data-coupon-ends-at]');
    const submitBtn = form.querySelector('[data-coupon-submit]');
    const cancelBtn = form.querySelector('[data-coupon-cancel]');

    if (couponIdInput) couponIdInput.value = '';
    if (titleEl) titleEl.textContent = 'Neuer Gutschein';
    if (codeField) codeField.hidden = false;
    if (codeInput) codeInput.disabled = false;
    if (endsInput) endsInput.value = '';
    if (submitBtn) submitBtn.textContent = 'Gutschein anlegen';
    if (cancelBtn) cancelBtn.hidden = true;
    ensureCouponFormDefaults(form);
    syncCouponFormLabels(form);
    const portalRoot = form.closest('[data-creator-marketplace]');
    syncCouponScopePicker(form, portalRoot && portalRoot._creatorProducts ? portalRoot._creatorProducts : [], '');
  }

  function fillCouponFormForEdit(form, coupon) {
    if (!form || !coupon) return;
    const couponIdInput = form.querySelector('[data-coupon-id]');
    const titleEl = form.querySelector('[data-coupon-form-title]');
    const codeField = form.querySelector('[data-coupon-code-field]');
    const codeInput = form.querySelector('[data-coupon-code]');
    const typeSelect = form.querySelector('[data-coupon-type]');
    const valueInput = form.querySelector('[data-coupon-value]');
    const startsInput = form.querySelector('[data-coupon-starts-at]');
    const endsInput = form.querySelector('[data-coupon-ends-at]');
    const submitBtn = form.querySelector('[data-coupon-submit]');
    const cancelBtn = form.querySelector('[data-coupon-cancel]');
    const portalRoot = form.closest('[data-creator-marketplace]');
    const products = portalRoot && portalRoot._creatorProducts ? portalRoot._creatorProducts : [];

    if (couponIdInput) couponIdInput.value = coupon.id || '';
    if (titleEl) titleEl.textContent = 'Gutschein bearbeiten';
    if (codeField) codeField.hidden = false;
    if (codeInput) {
      codeInput.value = coupon.code || '';
      codeInput.disabled = true;
    }
    if (typeSelect) typeSelect.value = coupon.discount_type || 'percent';
    if (valueInput) valueInput.value = coupon.discount_value != null ? String(coupon.discount_value) : '';
    if (startsInput) startsInput.value = isoToLocalDatetimeInput(coupon.starts_at);
    if (endsInput) endsInput.value = isoToLocalDatetimeInput(coupon.ends_at);
    syncCouponScopePicker(form, products, coupon.product_id || '');
    if (submitBtn) submitBtn.textContent = 'Änderungen speichern';
    if (cancelBtn) cancelBtn.hidden = false;
    syncCouponFormLabels(form);
  }

  function syncCouponFormLabels(form) {
    if (!form) return;
    const typeSelect = form.querySelector('[data-coupon-type]');
    const valueLabel = form.querySelector('[data-coupon-value-label]');
    const valueInput = form.querySelector('[data-coupon-value]');
    const isFixed = typeSelect && typeSelect.value === 'fixed';
    if (valueLabel) valueLabel.textContent = isFixed ? 'Rabatt (€)' : 'Rabatt (%)';
    if (valueInput) {
      valueInput.placeholder = isFixed ? '5.00' : '10';
      valueInput.min = isFixed ? '0.01' : '1';
      valueInput.step = isFixed ? '0.01' : '1';
      valueInput.max = isFixed ? '5' : '20';
      if (!isFixed && valueInput.value) {
        enforceCouponValueInput(form);
      }
    }
  }

  function renderPromotionsFromData(root, coupons, maxCoupons, couponLiability, maxCouponDeficit) {
    const listEl = root.querySelector('[data-coupons-list]');
    const form = root.querySelector('[data-form="coupon"]');
    const slotsEl = root.querySelector('[data-coupon-slots]');
    const liabilityEl = root.querySelector('[data-coupon-liability]');
    const submitBtn = root.querySelector('[data-coupon-submit]');
    const rows = coupons || [];
    const activeRows = rows.filter(isCouponActive);
    const max = Number(maxCoupons) || 3;
    const liability = Number(couponLiability) || 0;
    const deficitMax = Number(maxCouponDeficit) || 100;
    const remaining = Math.max(0, max - activeRows.length);
    const deficitRemaining = Math.max(0, deficitMax - liability);

    root._creatorCoupons = rows;
    root._maxCreatorCoupons = max;

    if (slotsEl) {
      slotsEl.textContent = activeRows.length + ' / ' + max + ' Coupons aktiv';
    }

    if (liabilityEl) {
      liabilityEl.textContent =
        'Coupon-Puffer: ' + formatMoney(liability) + ' von ' + formatMoney(deficitMax) +
        ' verbraucht · noch ' + formatMoney(deficitRemaining) + ' möglich';
    }

    if (submitBtn) {
      const editingId = form && form.querySelector('[data-coupon-id]')
        ? form.querySelector('[data-coupon-id]').value.trim()
        : '';
      submitBtn.disabled = !editingId && (remaining <= 0 || deficitRemaining <= 0);
    }

    if (form) {
      const editingId = form.querySelector('[data-coupon-id]')
        ? form.querySelector('[data-coupon-id]').value.trim()
        : '';
      if (!editingId) {
        ensureCouponFormDefaults(form);
      }
      syncCouponFormLabels(form);
      if (!editingId) {
        syncCouponScopePicker(form, root._creatorProducts || []);
      }
    }

    if (!listEl) return;

    if (!rows.length) {
      listEl.innerHTML =
        '<div class="creator-marketplace__coupon-empty">' +
        '<p><strong>Noch keine Gutscheine</strong></p>' +
        '<p class="creator-marketplace__hint">Lege einen Code an — für deine ganze Kollektion oder ein einzelnes Produkt. Rabattkosten werden von deiner Provision abgezogen.</p>' +
        '</div>';
      return;
    }

    const products = root._creatorProducts || [];

    listEl.innerHTML = rows.map(function (coupon) {
      const active = isCouponActive(coupon);
      const actionButtons = active
        ? '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small" data-edit-coupon="' + escapeHtml(coupon.id) + '">Bearbeiten</button>' +
          '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small creator-marketplace__btn--secondary" data-deactivate-coupon="' + escapeHtml(coupon.id) + '">Deaktivieren</button>' +
          '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small creator-marketplace__btn--danger" data-delete-coupon="' + escapeHtml(coupon.id) + '">Löschen</button>'
        : '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small" data-reactivate-coupon="' + escapeHtml(coupon.id) + '">Reaktivieren</button>' +
          '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small creator-marketplace__btn--danger" data-delete-coupon="' + escapeHtml(coupon.id) + '">Löschen</button>';

      return (
        '<article class="creator-marketplace__coupon-card' + (active ? '' : ' is-inactive') + '">' +
        '<div class="creator-marketplace__coupon-card-head">' +
        '<div class="creator-marketplace__coupon-code-row">' +
        '<strong class="creator-marketplace__coupon-code">' + escapeHtml(coupon.code) + '</strong>' +
        (active
          ? '<button type="button" class="creator-marketplace__coupon-copy" data-copy-coupon-code data-copy-text="' + escapeHtml(coupon.code) + '" title="Code kopieren" aria-label="Gutscheincode kopieren">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
            '<rect x="9" y="9" width="11" height="11" rx="2" stroke="currentColor" stroke-width="1.8"/>' +
            '<path d="M7 15H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="1.8"/>' +
            '</svg>' +
            '</button>'
          : '') +
        '</div>' +
        '<span class="creator-marketplace__badge ' + (active ? 'creator-marketplace__badge--published' : 'creator-marketplace__badge--inactive') + '">' +
        (active ? 'Aktiv' : 'Inaktiv') +
        '</span>' +
        '</div>' +
        '<div class="creator-marketplace__coupon-card-discount">' +
        '<span>' + escapeHtml(coupon.discount_type === 'fixed' ? 'Festbetrag' : 'Prozent') + '</span>' +
        '<strong>' + escapeHtml(formatCouponDiscount(coupon)) + '</strong>' +
        '</div>' +
        '<p class="creator-marketplace__hint creator-marketplace__coupon-card-scope">' +
        escapeHtml(formatCouponScopeLabel(coupon, products)) +
        '</p>' +
        '<p class="creator-marketplace__hint creator-marketplace__coupon-card-dates">' +
        'Gültig ab ' + escapeHtml(formatCouponDate(coupon.starts_at)) +
        (coupon.ends_at
          ? ' bis ' + escapeHtml(formatCouponDate(coupon.ends_at))
          : ' · kein Enddatum') +
        '</p>' +
        (coupon.creator_tag
          ? '<p class="creator-marketplace__hint creator-marketplace__coupon-card-tag">Tag: ' + escapeHtml(coupon.creator_tag) + '</p>'
          : '') +
        '<p class="creator-marketplace__hint">Eingelöst: ' + String(coupon.usage_count || 0) + '× · Kosten von deiner Provision</p>' +
        '<div class="creator-marketplace__coupon-card-actions">' +
        actionButtons +
        '</div>' +
        '</article>'
      );
    }).join('');
  }

  function renderPayoutsTableFromData(root, data) {
    const table = root.querySelector('[data-payouts-table] tbody');
    if (!table) return;

    if (!data.length) {
      table.innerHTML = '<tr><td colspan="3">Noch keine Auszahlungen</td></tr>';
      return;
    }

    table.innerHTML = data.map(function (p) {
      return (
        '<tr><td>' + formatMoney(p.amount) + '</td>' +
        '<td>' + payoutStatusBadge(p.status === 'completed' ? 'paid' : p.status === 'pending' || p.status === 'processing' ? 'pending' : p.status) +
        ' <span class="creator-marketplace__hint-inline">' + escapeHtml(formatPayoutRequestStatusLabel(p.status)) + '</span></td>' +
        '<td>' + new Date(p.created_at).toLocaleDateString('de-DE') + '</td></tr>'
      );
    }).join('');
  }

  async function renderStats(root, client, creatorId) {
    const statsEl = root.querySelector('[data-stats]');
    if (!statsEl) return;

    const { data, error } = await client
      .from('creator_dashboard_stats')
      .select('*')
      .eq('creator_id', creatorId)
      .maybeSingle();

    if (error) {
      statsEl.innerHTML = '';
      return;
    }

    renderStatsFromData(root, { stats: data, monthly_earnings: [], min_payout_amount: 10 });
  }

  function formatProductShopifyCell(product) {
    const shopifyStatus =
      product.shopify_sync_status === 'synced'
        ? '✓ Shopify'
        : product.shopify_sync_status === 'failed'
          ? '✗ Fehler'
          : '…';
    const retryBtn =
      product.shopify_sync_status === 'failed'
        ? ' <button type="button" class="creator-marketplace__btn creator-marketplace__btn--small" data-sync-product="' +
          escapeHtml(product.id) +
          '">Erneut syncen</button>'
        : '';

    return shopifyStatus + retryBtn;
  }

  function statCard(value, label, hint, modifier) {
    const mod = modifier ? ' creator-marketplace__stat--' + modifier : '';
    const hintHtml = hint
      ? '<div class="creator-marketplace__stat-hint">' + escapeHtml(hint) + '</div>'
      : '';
    return (
      '<div class="creator-marketplace__stat' + mod + '">' +
      '<div class="creator-marketplace__stat-value">' + value + '</div>' +
      '<div class="creator-marketplace__stat-label">' + escapeHtml(label) + '</div>' +
      hintHtml +
      '</div>'
    );
  }

  async function renderProductsTable(root, client, creatorId) {
    const { data, error } = await client
      .from('creator_products')
      .select('*')
      .eq('creator_id', creatorId)
      .is('deleted_at', null)
      .order('created_at', { ascending: false });

    if (error) {
      const grid = root.querySelector('[data-products-grid]');
      if (grid) grid.innerHTML = '<p class="creator-marketplace__hint">Fehler beim Laden</p>';
      return;
    }

    root._creatorProducts = data || [];
    renderProductsGridFromData(root, data || []);
  }

  async function renderSalesTable(root, client, creatorId) {
    const table = root.querySelector('[data-sales-table] tbody');
    if (!table) return;

    const { data, error } = await client
      .from('sales')
      .select('*')
      .eq('creator_id', creatorId)
      .order('created_at', { ascending: false })
      .limit(20);

    if (error || !data.length) {
      table.innerHTML = '<tr><td colspan="5">Noch keine Verkäufe</td></tr>';
      return;
    }

    renderSalesTableFromData(root, data);
  }

  async function renderPayoutsTable(root, client, creatorId) {
    const table = root.querySelector('[data-payouts-table] tbody');
    if (!table) return;

    const { data, error } = await client
      .from('payouts')
      .select('*')
      .eq('creator_id', creatorId)
      .order('created_at', { ascending: false })
      .limit(20);

    if (error || !data.length) {
      table.innerHTML = '<tr><td colspan="3">Noch keine Auszahlungen</td></tr>';
      return;
    }

    renderPayoutsTableFromData(root, data);
  }

  function renderProductCard(product) {
    const creator = product.creators || {};
    const productLink = product.shopify_handle
      ? '/products/' + encodeURIComponent(product.shopify_handle)
      : null;

    return (
      '<article class="creator-marketplace__card">' +
      ((product.preview_url || product.image_url)
        ? '<img class="creator-marketplace__card-image" src="' + escapeHtml(product.preview_url || product.image_url) + '" alt="">'
        : '<div class="creator-marketplace__card-image"></div>') +
      '<div class="creator-marketplace__card-body">' +
      '<p class="creator-marketplace__badge">' +
      escapeHtml(creator.display_name || '') +
      '</p>' +
      '<h3>' +
      (productLink
        ? '<a href="' + productLink + '">' + escapeHtml(cleanProductDisplayTitle(product.title)) + '</a>'
        : escapeHtml(cleanProductDisplayTitle(product.title))) +
      '</h3>' +
      '<p class="creator-marketplace__price">' +
      formatMoney(product.price) +
      '</p>' +
      '<button class="creator-marketplace__btn" data-add-to-cart="' +
      product.id +
      '">In den Warenkorb</button>' +
      '</div></article>'
    );
  }

  function bindAddToCart(root, config, products) {
    root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        const productId = btn.dataset.addToCart;
        const product = products.find(function (p) {
          return p.id === productId;
        });
        if (!product) return;

        const useShopifyVariant = product.shopify_variant_id;
        const fallbackVariantId = config.marketplaceVariantId;

        if (!useShopifyVariant && !fallbackVariantId) {
          alert('Checkout ist nicht konfiguriert.');
          return;
        }

        const cartItem = useShopifyVariant
          ? {
              id: parseInt(product.shopify_variant_id, 10),
              quantity: 1,
              properties: {
                _listing_id: product.id,
                _creator_id: product.creator_id,
                Creator: (product.creators && product.creators.display_name) || '',
              },
            }
          : {
              id: parseInt(fallbackVariantId, 10),
              quantity: Math.max(1, Math.round(parseFloat(product.price))),
              properties: {
                _listing_id: product.id,
                _creator_id: product.creator_id,
                Produkt: product.title,
                Creator: (product.creators && product.creators.display_name) || '',
              },
            };

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [cartItem] }),
          });

          if (!res.ok) throw new Error('Warenkorb-Fehler');
          window.location.href = '/cart';
        } catch (_err) {
          alert('Produkt konnte nicht in den Warenkorb gelegt werden.');
        }
      });
    });
  }

  async function readFunctionError(error) {
    try {
      if (error && error.context) {
        if (typeof error.context.json === 'function') {
          const body = await error.context.json();
          if (body && body.error) return body.error;
        }
        if (typeof error.context.text === 'function') {
          const text = await error.context.text();
          if (text) {
            try {
              const body = JSON.parse(text);
              if (body && body.error) return body.error;
            } catch (_e) {
              return text;
            }
          }
        }
      }
    } catch (_e) {
      /* ignore */
    }
    return null;
  }

  function copyTextToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        if (document.execCommand('copy')) {
          resolve();
        } else {
          reject(new Error('copy failed'));
        }
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function showFormFeedback(form, text, type) {
    hideProductSaveProgress(form);
    const el = form.querySelector('[data-product-feedback]');
    if (!el) return;
    el.hidden = false;
    el.textContent = text;
    el.className = 'creator-marketplace__form-feedback' +
      (type === 'error' ? ' is-error' : type === 'success' ? ' is-success' : '');
  }

  function hideProductSaveProgress(form) {
    if (!form) return;
    const progress = form.querySelector('[data-product-save-progress]');
    if (progress) progress.hidden = true;
    delete form._saveProgressSteps;
  }

  function showProductSaveProgress(form, steps) {
    if (!form || !steps || !steps.length) return;
    const progress = form.querySelector('[data-product-save-progress]');
    const stepsEl = form.querySelector('[data-product-save-steps]');
    const feedback = form.querySelector('[data-product-feedback]');
    if (!progress || !stepsEl) return;

    if (feedback) {
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.className = 'creator-marketplace__form-feedback';
    }

    form._saveProgressSteps = steps;
    progress.hidden = false;
    stepsEl.innerHTML = steps.map(function (step) {
      return (
        '<li class="creator-marketplace__save-progress-step is-pending" data-save-step="' + escapeHtml(step.id) + '">' +
        '<span class="creator-marketplace__save-progress-indicator" aria-hidden="true"></span>' +
        '<span class="creator-marketplace__save-progress-label">' + escapeHtml(step.label) + '</span>' +
        '<span class="creator-marketplace__save-progress-detail" data-save-step-detail></span>' +
        '</li>'
      );
    }).join('');
    setProductSaveStep(form, steps[0].id, 'active');
  }

  function setProductSaveStep(form, stepId, status, detail) {
    if (!form) return;
    const progress = form.querySelector('[data-product-save-progress]');
    if (!progress || progress.hidden) {
      const feedback = form.querySelector('[data-product-feedback]');
      if (feedback && status === 'active') {
        const step = (form._saveProgressSteps || []).find(function (entry) {
          return entry.id === stepId;
        });
        feedback.hidden = false;
        feedback.textContent = (step && step.label) || '';
        feedback.className = 'creator-marketplace__form-feedback';
      }
      return;
    }

    const order = (form._saveProgressSteps || []).map(function (entry) { return entry.id; });
    const activeIndex = order.indexOf(stepId);
    progress.querySelectorAll('[data-save-step]').forEach(function (el) {
      const id = el.getAttribute('data-save-step');
      const idx = order.indexOf(id);
      const detailEl = el.querySelector('[data-save-step-detail]');
      el.classList.remove('is-active', 'is-done', 'is-pending');

      if (status === 'done' && id === stepId) {
        el.classList.add('is-done');
        if (detailEl) detailEl.textContent = detail || '';
        return;
      }

      if (status === 'active' && id === stepId) {
        el.classList.add('is-active');
        if (detailEl) detailEl.textContent = detail || '';
        return;
      }

      if (activeIndex >= 0 && idx < activeIndex) {
        el.classList.add('is-done');
        if (detailEl) detailEl.textContent = '';
        return;
      }

      el.classList.add('is-pending');
      if (detailEl) detailEl.textContent = '';
    });
  }

  function runWithConcurrency(items, concurrency, worker) {
    if (!items.length) return Promise.resolve();
    const limit = Math.max(1, concurrency);
    let index = 0;

    function runNext() {
      const current = index;
      index += 1;
      if (current >= items.length) return Promise.resolve();
      return Promise.resolve(worker(items[current], current)).then(runNext);
    }

    const runners = [];
    for (let i = 0; i < Math.min(limit, items.length); i++) {
      runners.push(runNext());
    }
    return Promise.all(runners);
  }

  function stablePlacementSnapshot(placement) {
    return JSON.stringify(normalizePlacementMap(placement || {}));
  }

  function needsDropshipPreviewRefresh(state, editingProduct, relatedProducts, uploadedSides, groups) {
    if (uploadedSides.some(function (sideKey) {
      return !!(getDesignForSide(state, sideKey).file);
    })) {
      return true;
    }

    if (editingProduct &&
      stablePlacementSnapshot(state.placements) !== stablePlacementSnapshot(editingProduct.design_placement)) {
      return true;
    }

    const group = groups[0];
    if (!group) return false;

    const oldVariantIds = new Set((relatedProducts || []).map(function (row) {
      return Number(row.shopify_base_variant_id);
    }));

    for (let i = 0; i < group.variants.length; i++) {
      if (!oldVariantIds.has(Number(group.variants[i].shopify_variant_id))) {
        return true;
      }
    }

    return false;
  }

  function getPromotionsPanel(root) {
    return root.querySelector('[data-panel="promotions"]');
  }

  function setInlineFeedback(el, text, type) {
    if (!el) return;
    el.hidden = false;
    el.textContent = text;
    el.className = el.classList.contains('creator-marketplace__coupon-list-feedback')
      ? 'creator-marketplace__coupon-list-feedback'
      : el.classList.contains('creator-marketplace__coupon-card-feedback')
        ? 'creator-marketplace__coupon-card-feedback'
        : 'creator-marketplace__form-feedback';
    if (type === 'error') el.classList.add('is-error');
    if (type === 'success') el.classList.add('is-success');
  }

  function clearInlineFeedback(el) {
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
    el.className = el.classList.contains('creator-marketplace__coupon-list-feedback')
      ? 'creator-marketplace__coupon-list-feedback'
      : el.classList.contains('creator-marketplace__coupon-card-feedback')
        ? 'creator-marketplace__coupon-card-feedback'
        : 'creator-marketplace__form-feedback';
  }

  function showCouponFormFeedback(root, text, type) {
    const panel = getPromotionsPanel(root);
    const el = panel && panel.querySelector('[data-coupon-form-feedback]');
    clearCouponListFeedback(root);
    setInlineFeedback(el, text, type);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearCouponFormFeedback(root) {
    const panel = getPromotionsPanel(root);
    clearInlineFeedback(panel && panel.querySelector('[data-coupon-form-feedback]'));
  }

  function showCouponListFeedback(root, text, type) {
    const panel = getPromotionsPanel(root);
    const el = panel && panel.querySelector('[data-coupon-list-feedback]');
    clearCouponFormFeedback(root);
    setInlineFeedback(el, text, type);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearCouponListFeedback(root) {
    const panel = getPromotionsPanel(root);
    clearInlineFeedback(panel && panel.querySelector('[data-coupon-list-feedback]'));
  }

  function showCouponCardFeedback(button, text, type) {
    const card = button && button.closest('.creator-marketplace__coupon-card');
    if (!card) return;
    let el = card.querySelector('[data-coupon-card-feedback]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-coupon-card-feedback', '');
      el.className = 'creator-marketplace__coupon-card-feedback';
      card.appendChild(el);
    }
    setInlineFeedback(el, text, type);
    window.clearTimeout(el._couponFeedbackTimer);
    el._couponFeedbackTimer = window.setTimeout(function () {
      clearInlineFeedback(el);
    }, 2600);
  }

  function clearCouponFeedback(root) {
    clearCouponFormFeedback(root);
    clearCouponListFeedback(root);
  }

  function showMessage(root, text, type) {
    let el = root.querySelector('[data-message]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-message', '');
      root.prepend(el);
    }
    el.className = 'creator-marketplace__message creator-marketplace__message--' + type;
    el.textContent = text;
  }

  function clearMessage(root) {
    const el = root.querySelector('[data-message]');
    if (el) el.remove();
  }

  function formatMoney(amount) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(Number(amount) || 0);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function buildRichTextToolbarHtml() {
    return (
      '<div class="creator-marketplace__richtext-toolbar" role="toolbar" aria-label="Textformatierung">' +
      '<select class="creator-marketplace__richtext-select" data-richtext-format aria-label="Textstil">' +
      '<option value="p">Absatz</option>' +
      '<option value="h2">Überschrift 2</option>' +
      '<option value="h3">Überschrift 3</option>' +
      '</select>' +
      '<span class="creator-marketplace__richtext-divider" aria-hidden="true"></span>' +
      '<button type="button" class="creator-marketplace__richtext-btn" data-richtext-cmd="bold" title="Fett"><strong>B</strong></button>' +
      '<button type="button" class="creator-marketplace__richtext-btn creator-marketplace__richtext-btn--italic" data-richtext-cmd="italic" title="Kursiv">I</button>' +
      '<button type="button" class="creator-marketplace__richtext-btn creator-marketplace__richtext-btn--underline" data-richtext-cmd="underline" title="Unterstrichen"><span>U</span></button>' +
      '<span class="creator-marketplace__richtext-divider" aria-hidden="true"></span>' +
      '<button type="button" class="creator-marketplace__richtext-btn" data-richtext-cmd="justifyCenter" title="Zentriert">≡</button>' +
      '<span class="creator-marketplace__richtext-divider" aria-hidden="true"></span>' +
      '<button type="button" class="creator-marketplace__richtext-btn" data-richtext-source title="HTML-Ansicht">&lt;/&gt;</button>' +
      '</div>'
    );
  }

  function getRichTextShell(textarea) {
    return textarea ? textarea.closest('[data-rich-text-editor]') : null;
  }

  function syncRichTextFromBody(textarea) {
    const shell = getRichTextShell(textarea);
    if (!shell || shell.classList.contains('is-source-mode')) return;
    const body = shell.querySelector('[data-richtext-body]');
    if (!body) return;
    textarea.value = body.innerHTML.trim();
  }

  function syncRichTextFromSource(textarea) {
    const shell = getRichTextShell(textarea);
    if (!shell || !shell.classList.contains('is-source-mode')) return;
    const body = shell.querySelector('[data-richtext-body]');
    if (body) body.innerHTML = textarea.value;
  }

  function syncRichTextEditors(form) {
    if (!form) return;
    form.querySelectorAll('[data-rich-text]').forEach(function (textarea) {
      if (getRichTextShell(textarea)) {
        if (getRichTextShell(textarea).classList.contains('is-source-mode')) {
          syncRichTextFromSource(textarea);
        } else {
          syncRichTextFromBody(textarea);
        }
      }
    });
  }

  function setRichTextContent(textarea, html) {
    if (!textarea) return;
    const shell = getRichTextShell(textarea);
    const value = html || '';
    textarea.value = value;
    if (shell) {
      const body = shell.querySelector('[data-richtext-body]');
      if (body) body.innerHTML = value;
      shell.classList.remove('is-source-mode');
    }
  }

  function getRichTextContent(textarea) {
    if (!textarea) return '';
    const shell = getRichTextShell(textarea);
    if (shell && shell.classList.contains('is-source-mode')) {
      return textarea.value.trim();
    }
    syncRichTextFromBody(textarea);
    return textarea.value.trim();
  }

  function clearRichTextEditors(form) {
    if (!form) return;
    form.querySelectorAll('[data-rich-text]').forEach(function (textarea) {
      setRichTextContent(textarea, '');
    });
  }

  function runRichTextCommand(body, command, value) {
    body.focus();
    try {
      document.execCommand(command, false, value || null);
    } catch (_cmdErr) {
      /* ignore */
    }
  }

  function bindRichTextEditor(shell, textarea, body) {
    const formatSelect = shell.querySelector('[data-richtext-format]');
    const sourceBtn = shell.querySelector('[data-richtext-source]');

    shell.querySelectorAll('[data-richtext-cmd]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        runRichTextCommand(body, btn.dataset.richtextCmd);
        syncRichTextFromBody(textarea);
      });
    });

    if (formatSelect) {
      formatSelect.addEventListener('change', function () {
        runRichTextCommand(body, 'formatBlock', formatSelect.value);
        syncRichTextFromBody(textarea);
      });
    }

    if (sourceBtn) {
      sourceBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const isSource = shell.classList.toggle('is-source-mode');
        sourceBtn.classList.toggle('is-active', isSource);
        if (isSource) {
          syncRichTextFromBody(textarea);
        } else {
          syncRichTextFromSource(textarea);
        }
      });
    }

    body.addEventListener('input', function () {
      syncRichTextFromBody(textarea);
    });

    body.addEventListener('blur', function () {
      syncRichTextFromBody(textarea);
    });

    textarea.addEventListener('input', function () {
      if (shell.classList.contains('is-source-mode')) {
        syncRichTextFromSource(textarea);
      }
    });
  }

  function initRichTextEditor(textarea) {
    if (!textarea || textarea.dataset.richTextReady || getRichTextShell(textarea)) return;
    textarea.dataset.richTextReady = '1';

    const shell = document.createElement('div');
    shell.className = 'creator-marketplace__richtext';
    shell.setAttribute('data-rich-text-editor', '');
    shell.innerHTML = buildRichTextToolbarHtml()
      + '<div class="creator-marketplace__richtext-body" contenteditable="true" data-richtext-body data-placeholder="'
      + escapeAttr(textarea.getAttribute('placeholder') || '')
      + '"></div>';

    const parent = textarea.parentNode;
    parent.insertBefore(shell, textarea);
    shell.appendChild(textarea);
    textarea.classList.add('creator-marketplace__richtext-source');
    textarea.setAttribute('aria-hidden', 'true');
    textarea.tabIndex = -1;

    const body = shell.querySelector('[data-richtext-body]');
    if (textarea.value) body.innerHTML = textarea.value;
    bindRichTextEditor(shell, textarea, body);
  }

  function initRichTextEditors(root) {
    if (!root) return;
    root.querySelectorAll('[data-rich-text]').forEach(initRichTextEditor);
  }

  const configuratorStore = new WeakMap();
  const ownFormStore = new WeakMap();

  function getActiveListingType(root, config) {
    const mode = (config && config.allowedListingModes) || 'both';
    if (mode === 'dropship_only') return 'dropship';
    if (mode === 'own_only') return 'own';
    const activeTab = root.querySelector('[data-listing-tab].is-active');
    return activeTab ? activeTab.dataset.listingTab : 'dropship';
  }

  function switchListingType(root, listingType, config) {
    root.querySelectorAll('[data-listing-tab]').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.dataset.listingTab === listingType);
    });

    const dropshipPanel = root.querySelector('[data-dropship-panel]');
    const ownPanel = root.querySelector('[data-own-panel]');
    const hintDropship = root.querySelector('[data-listing-hint-dropship]');
    const hintOwn = root.querySelector('[data-listing-hint-own]');

    if (dropshipPanel) dropshipPanel.classList.toggle('creator-marketplace__hidden', listingType !== 'dropship');
    if (ownPanel) ownPanel.classList.toggle('creator-marketplace__hidden', listingType !== 'own');
    if (hintDropship) hintDropship.classList.toggle('creator-marketplace__hidden', listingType !== 'dropship');
    if (hintOwn) hintOwn.classList.toggle('creator-marketplace__hidden', listingType !== 'own');

    const submitBtn = root.querySelector('[data-product-submit]');
    const editingInput = root.querySelector('[data-editing-product-id]');
    if (submitBtn && (!editingInput || !editingInput.value)) {
      submitBtn.textContent = listingType === 'own' ? 'Eigenes Produkt veröffentlichen' : 'Dropshipping-Produkt veröffentlichen';
    }
  }

  function setupListingTypeTabs(root, config) {
    const mode = config.allowedListingModes || 'both';
    const listingTabs = root.querySelector('.creator-marketplace__listing-tabs');
    const dropshipTab = root.querySelector('[data-listing-tab="dropship"]');
    const ownTab = root.querySelector('[data-listing-tab="own"]');

    if (mode === 'dropship_only') {
      if (ownTab) ownTab.classList.add('creator-marketplace__hidden');
      if (listingTabs) listingTabs.classList.add('creator-marketplace__hidden');
      switchListingType(root, 'dropship', config);
    } else if (mode === 'own_only') {
      if (dropshipTab) dropshipTab.classList.add('creator-marketplace__hidden');
      if (listingTabs) listingTabs.classList.add('creator-marketplace__hidden');
      switchListingType(root, 'own', config);
    } else {
      if (dropshipTab) dropshipTab.classList.remove('creator-marketplace__hidden');
      if (ownTab) ownTab.classList.remove('creator-marketplace__hidden');
      if (listingTabs) listingTabs.classList.remove('creator-marketplace__hidden');
      switchListingType(root, getActiveListingType(root, config), config);
    }
  }

  function setupOwnProductForm(root, config) {
    const form = root.querySelector('[data-form="product"]');
    if (!form) return;

    const state = ownFormStore.get(root) || {
      imageFile: null,
      existingImageUrl: null,
    };
    ownFormStore.set(root, state);

    const upload = form.querySelector('[data-own-image-upload]');
    const status = form.querySelector('[data-own-image-status]');
    const preview = form.querySelector('[data-own-image-preview]');

    if (upload && !upload.dataset.ownBound) {
      upload.dataset.ownBound = '1';
      upload.addEventListener('change', function () {
        const file = upload.files && upload.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
          if (status) status.textContent = 'Bitte eine Bilddatei auswählen.';
          return;
        }
        state.imageFile = file;
        if (status) status.textContent = file.name;
        if (preview) {
          preview.src = URL.createObjectURL(file);
          preview.hidden = false;
        }
      });
    }

    initRichTextEditors(root);
  }

  function setProductFormEditMode(root, isEditing) {
    const listingTabs = root.querySelector('.creator-marketplace__listing-tabs');
    const selectionHint = root.querySelector('[data-selection-hint]');
    if (listingTabs) listingTabs.classList.toggle('creator-marketplace__hidden', isEditing);
    if (selectionHint) {
      selectionHint.textContent = isEditing
        ? 'Deine aktuellen Farben sind vorausgewählt — abwählen entfernt sie aus dem Shop.'
        : 'Wähle die Farben für dein Motiv — alle Größen werden automatisch mit angelegt.';
    }
  }

  async function syncProductFormMode(root, client, config, creator) {
    showProductsListView(root);
    const form = root.querySelector('[data-form="product"]');
    if (!form) return;

    const editingInput = form.querySelector('[data-editing-product-id]');
    const editingId = editingInput ? editingInput.value.trim() : '';
    if (editingId) {
      await resetProductFormForCreate(root, client, config, creator);
    }
  }

  async function resetProductFormForCreate(root, client, config, creator) {
    const form = root.querySelector('[data-form="product"]');
    if (!form) return;

    form.reset();
    clearRichTextEditors(form);
    const editingInput = form.querySelector('[data-editing-product-id]');
    if (editingInput) editingInput.value = '';

    const designLayer = form.querySelector('[data-design-layer]');
    if (designLayer) designLayer.hidden = true;
    const designStatus = form.querySelector('[data-design-status]');
    if (designStatus) designStatus.textContent = 'Motiv bereit';
    const uploadEmpty = form.querySelector('[data-upload-empty]');
    const uploadFilled = form.querySelector('[data-upload-filled]');
    if (uploadEmpty) uploadEmpty.classList.remove('creator-marketplace__hidden');
    if (uploadFilled) uploadFilled.classList.add('creator-marketplace__hidden');

    const state = configuratorStore.get(root);
    if (state) {
      state.selectedVariantKeys = {};
      state.editingRelatedProducts = null;
      state.editingShopifyProductId = null;
      state.editingBaseProductId = null;
      state.previewKey = null;
      state.designsBySide = {};
      state.designFile = null;
      state.designDataUrl = null;
      state.heroPreviewKey = null;
      state.heroPreviewKeys = {};
      state.heroPreviewSide = 'front';
      state.heroPreviewCache = {};
      state.activeSide = 'front';
      state.placements = { front: { x: 50, y: 50, scale: 1 } };
      state.placement = { x: 50, y: 50, scale: 1 };
    }

    const ownPreview = form.querySelector('[data-own-image-preview]');
    if (ownPreview) ownPreview.hidden = true;
    const ownStatus = form.querySelector('[data-own-image-status]');
    if (ownStatus) ownStatus.textContent = 'Noch kein Bild ausgewählt';

    ownFormStore.set(root, { imageFile: null, existingImageUrl: null });
    setProductFormEditMode(root, false);
    setupListingTypeTabs(root, config);

    const submitBtn = form.querySelector('[data-product-submit]');
    if (submitBtn) {
      const mode = getActiveListingType(root, config);
      submitBtn.textContent = mode === 'own'
        ? 'Eigenes Produkt veröffentlichen'
        : 'Dropshipping-Produkt veröffentlichen';
    }

    showFormFeedback(form, '', '');
    if (state && state.baseProducts.length) {
      const els = getConfiguratorEls(form);
      renderSelectionTree(state, els);
      updateSelectionSummary(state, els);
      syncPreviewFromSelection(state, els, config);
      syncDesignUploadUi(state, els, config);
    }
  }

  async function populateProductFormForEdit(root, client, config, creator, product, relatedProducts) {
    const form = root.querySelector('[data-form="product"]');
    if (!form) return;

    const listingType = product.listing_type || 'dropship';
    switchListingType(root, listingType, config);
    setProductFormEditMode(root, true);

    const editingInput = form.querySelector('[data-editing-product-id]');
    if (editingInput) editingInput.value = product.id;
    showFormFeedback(form, '', '');

    const submitBtn = form.querySelector('[data-product-submit]');
    if (submitBtn) submitBtn.textContent = 'Änderungen speichern';

    if (listingType === 'own') {
      const ownTitle = form.querySelector('[name="own_title"]');
      const ownDesc = form.querySelector('[name="own_description"]');
      const ownPrice = form.querySelector('[name="own_price"]');
      const ownInventory = form.querySelector('[data-own-inventory]');
      const statusOwn = form.querySelector('[data-status-own]');
      const state = ownFormStore.get(root) || { imageFile: null, existingImageUrl: null };

      if (ownTitle) ownTitle.value = product.title || '';
      if (ownDesc) setRichTextContent(ownDesc, product.description || '');
      if (ownPrice) ownPrice.value = product.price || '';
      if (ownInventory) ownInventory.value = product.inventory_quantity || 0;
      if (statusOwn) statusOwn.value = product.status || 'draft';

      state.imageFile = null;
      state.existingImageUrl = product.image_url || null;
      ownFormStore.set(root, state);

      const preview = form.querySelector('[data-own-image-preview]');
      const status = form.querySelector('[data-own-image-status]');
      if (preview && product.image_url) {
        preview.src = product.image_url;
        preview.hidden = false;
      }
      if (status) status.textContent = product.image_url ? 'Aktuelles Bild (neues optional)' : 'Noch kein Bild';
    } else {
      const state = configuratorStore.get(root);
      const els = getConfiguratorEls(form);

      if (state && product.shopify_base_product_id && state.baseProducts.length) {
        const base = state.baseProducts.find(function (b) {
          return b.shopify_product_id === Number(product.shopify_base_product_id);
        });
        const siblings = (relatedProducts && relatedProducts.length)
          ? relatedProducts
          : [product];
        if (base) {
          state.editingBaseProductId = Number(product.shopify_base_product_id);
          state.editingRelatedProducts = siblings;
          state.editingShopifyProductId = product.shopify_product_id;
          restoreEditColorSelection(state, base, siblings);

          let previewVariant = base.variants.find(function (v) {
            return v.shopify_variant_id === Number(product.shopify_base_variant_id);
          });
          if (!previewVariant) {
            const selectedEntry = getSelectedVariantEntries(state).find(function (entry) {
              return entry.base.id === base.id;
            });
            previewVariant = selectedEntry ? selectedEntry.variant : null;
          }
          if (!previewVariant) previewVariant = base.variants[0];

          if (previewVariant) {
            state.previewKey = variantSelectionKey(base, previewVariant);
            const heroSource = siblings.find(function (rel) { return rel.preview_url; }) || product;
            const heroVariant = base.variants.find(function (v) {
              return v.shopify_variant_id === Number(heroSource.shopify_base_variant_id);
            });
            const heroColor = heroVariant ? getVariantColorName(heroVariant, base) : '';
            if (heroColor) {
              setHeroPreviewKey(state, base, buildHeroPreviewKey(base, heroColor));
            } else {
              const colorEntries = collectSelectedColorEntries(state).filter(function (entry) {
                return getBaseProductKey(entry.base) === getBaseProductKey(base);
              });
              if (colorEntries.length) {
                setHeroPreviewKey(state, base, colorEntries[0].key);
              }
            }
            const designerVariant = getDesignerVariantForBase(state, base) || previewVariant;
            setPreviewTarget(state, base, designerVariant, els, config);
            scheduleHeroPreviewRefresh(state, els, config);
          }

          renderSelectionTree(state, els);
          updateSelectionSummary(state, els);
        }
      }

      const displayTitle = parseProductTitle(product.title).userTitle || product.title;

      const titleInput = form.querySelector('[name="title"]');
      const descInput = form.querySelector('[name="description"]');
      const markupInput = form.querySelector('[data-creator-markup]');
      const statusDropship = form.querySelector('[data-status-dropship]');

      if (titleInput) {
        titleInput.value = displayTitle || '';
        bindProductTitleCounter(form);
      }
      if (descInput) setRichTextContent(descInput, product.description || '');
      if (markupInput) markupInput.value = String(product.creator_markup || 0);
      if (statusDropship) statusDropship.value = product.status || 'draft';

      if (state) {
        state.designsBySide = {};
        if (product.design_placement) {
          state.placements = normalizePlacementMap(product.design_placement);
          state.activeSide = 'front';
          if (!state.placements[state.activeSide]) {
            const firstKey = Object.keys(state.placements)[0];
            state.activeSide = firstKey || 'front';
          }
          state.placement = state.placements[state.activeSide] || defaultPlacementPoint();

          const placementMap = state.placements;
          const designSideKeys = Object.keys(placementMap);
          for (let sideIndex = 0; sideIndex < designSideKeys.length; sideIndex++) {
            const sideKey = designSideKeys[sideIndex];
            const point = placementMap[sideKey];
            const url = (point && point.design_url) || (sideKey === 'front' ? product.design_url : null);
            if (url) {
              getDesignForSide(state, sideKey).dataUrl = await hydrateRemoteDesignForCanvas(url);
            }
          }
          if (product.design_url && !getDesignForSide(state, 'front').dataUrl) {
            getDesignForSide(state, 'front').dataUrl = await hydrateRemoteDesignForCanvas(product.design_url);
          }
        } else if (product.design_url) {
          getDesignForSide(state, 'front').dataUrl = await hydrateRemoteDesignForCanvas(product.design_url);
        }

        syncDesignUploadUi(state, els, config);
        syncPlacementControls(state, els);
      }

      if (state && state.selectedBase && state.selectedVariant) {
        renderPrintSideTabs(state, els, state.selectedBase, state.selectedVariant, config);
      }
      if (state) updatePriceBreakdown(state, els);
    }
  }

  function getConfiguratorEls(form) {
    return {
      selectionTree: form.querySelector('[data-selection-tree]'),
      selectionSummary: form.querySelector('[data-selection-summary]'),
      previewLabel: form.querySelector('[data-preview-label]'),
      mockupCanvas: form.querySelector('[data-mockup-canvas]'),
      mockupBg: form.querySelector('[data-mockup-bg]'),
      printArea: form.querySelector('[data-print-area]'),
      designLayer: form.querySelector('[data-design-layer]'),
      designImg: form.querySelector('[data-design-img]'),
      designUpload: form.querySelector('[data-design-upload]'),
      designStatus: form.querySelector('[data-design-status]'),
      designScale: form.querySelector('[data-design-scale]'),
      designWidthCm: form.querySelector('[data-design-width-cm]'),
      printAreaCmLabel: form.querySelector('[data-print-area-cm-label]'),
      designSizeReadout: form.querySelector('[data-design-size-readout]'),
      markupInput: form.querySelector('[data-creator-markup]'),
      basePriceDisplay: form.querySelector('[data-base-price-display]'),
      sideSurchargeDisplay: form.querySelector('[data-side-surcharge-display]'),
      markupDisplay: form.querySelector('[data-markup-display]'),
      finalPriceDisplay: form.querySelector('[data-final-price-display]'),
      mockupStage: form.querySelector('[data-mockup-stage]'),
      uploadZone: form.querySelector('[data-design-upload-zone]'),
      uploadEmpty: form.querySelector('[data-upload-empty]'),
      uploadFilled: form.querySelector('[data-upload-filled]'),
      uploadThumb: form.querySelector('[data-upload-thumb]'),
      uploadTrigger: form.querySelector('[data-upload-trigger]'),
      uploadReplace: form.querySelector('[data-upload-replace]'),
      uploadFilename: form.querySelector('[data-upload-filename]'),
      uploadSideLabel: form.querySelector('[data-upload-side-label]'),
      printSideTabs: form.querySelector('[data-print-side-tabs]'),
      designResize: form.querySelector('[data-design-resize]'),
      heroPreviewPicker: form.querySelector('[data-hero-preview-picker]'),
      heroPreviewGrid: form.querySelector('[data-hero-preview-grid]'),
      heroPreviewSide: form.querySelector('[data-hero-preview-side]'),
    };
  }

  function variantSelectionKey(base, variant) {
    return String(base.shopify_product_id) + '-' + String(variant.shopify_variant_id);
  }

  function getBaseProductsForSelection(state) {
    if (!state || !state.baseProducts) return [];
    if (state.editingBaseProductId) {
      return state.baseProducts.filter(function (base) {
        return Number(base.shopify_product_id) === Number(state.editingBaseProductId);
      });
    }
    return state.baseProducts;
  }

  function restoreEditColorSelection(state, base, siblings) {
    state.selectedVariantKeys = {};
    const selectedColors = {};
    (siblings || []).forEach(function (rel) {
      const variant = base.variants.find(function (v) {
        return Number(v.shopify_variant_id) === Number(rel.shopify_base_variant_id);
      });
      if (!variant) return;
      const colorName = getVariantColorName(variant, base);
      if (colorName) selectedColors[colorName] = true;
    });
    Object.keys(selectedColors).forEach(function (colorName) {
      setColorSelected(state, base, colorName, true);
    });
  }

  function ensureEditColorSelection(state, editingProduct, relatedProducts) {
    if (!state || !editingProduct || groupSelectedByBaseProduct(state).length) return;
    if (!editingProduct.shopify_base_product_id || !state.baseProducts.length) return;
    const base = state.baseProducts.find(function (b) {
      return Number(b.shopify_product_id) === Number(editingProduct.shopify_base_product_id);
    });
    if (!base) return;
    const siblings = relatedProducts && relatedProducts.length ? relatedProducts : [editingProduct];
    restoreEditColorSelection(state, base, siblings);
  }

  function getSelectedVariantEntries(state) {
    const entries = [];
    if (!state || !state.baseProducts) return entries;
    state.baseProducts.forEach(function (base) {
      base.variants.forEach(function (variant) {
        const key = variantSelectionKey(base, variant);
        if (state.selectedVariantKeys[key]) {
          entries.push({ base: base, variant: variant, key: key });
        }
      });
    });
    return entries;
  }

  function groupSelectedByBaseProduct(state) {
    const groups = [];
    const map = {};
    getSelectedVariantEntries(state).forEach(function (entry) {
      const baseId = getBaseProductKey(entry.base);
      if (!map[baseId]) {
        map[baseId] = { base: entry.base, variants: [] };
        groups.push(map[baseId]);
      }
      map[baseId].variants.push(entry.variant);
    });
    return groups;
  }

  function uniqueDescriptionStrings(values) {
    const seen = new Set();
    const result = [];
    (values || []).forEach(function (value) {
      const trimmed = String(value || '').trim();
      if (!trimmed) return;
      const key = trimmed.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      result.push(trimmed);
    });
    return result;
  }

  function buildDescriptionContext(root, fieldEl) {
    const form = root.querySelector('[data-form="product"]');
    const isOwnPanel = Boolean(fieldEl.closest('[data-own-panel]'));
    const titleInput = form
      ? (isOwnPanel ? form.querySelector('[name="own_title"]') : form.querySelector('[name="title"]'))
      : null;
    const field = fieldEl.closest('.creator-marketplace__field');
    const descTextarea = field ? field.querySelector('[data-product-description]') : null;
    const promptInput = field ? field.querySelector('[data-description-ai-prompt]') : null;
    const state = configuratorStore.get(root);
    const colors = [];
    const sizes = [];
    let baseProductName = null;

    if (state) {
      getSelectedVariantEntries(state).forEach(function (entry) {
        const color = getVariantColorName(entry.variant, entry.base);
        const size = getVariantSizeName(entry.variant, entry.base);
        if (color) colors.push(color);
        if (size) sizes.push(size);
      });

      const groups = groupSelectedByBaseProduct(state);
      if (groups.length === 1 && groups[0].base) {
        baseProductName = groups[0].base.title || groups[0].base.name || null;
      } else if (groups.length > 1) {
        baseProductName = groups
          .map(function (group) { return group.base.title || group.base.name; })
          .filter(Boolean)
          .join(', ');
      }
    }

    return {
      userTitle: titleInput ? titleInput.value.trim() : '',
      currentDescription: descTextarea ? getRichTextContent(descTextarea) : '',
      instruction: promptInput ? promptInput.value.trim() : '',
      colors: uniqueDescriptionStrings(colors),
      sizes: uniqueDescriptionStrings(sizes),
      baseProductName: baseProductName,
      descTextarea: descTextarea,
    };
  }

  async function handleGenerateDescription(root, client, config, shopifyPayloadFn, btn) {
    const field = btn.closest('.creator-marketplace__field');
    if (!field) return;

    clearMessage(root);
    const ctx = buildDescriptionContext(root, field);

    const titleError = validateProductTitle(ctx.userTitle);
    if (titleError) {
      showMessage(root, titleError, 'error');
      return;
    }

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    try {
      const { data, error } = await client.functions.invoke('generate-product-description', {
        body: Object.assign({
          user_title: ctx.userTitle,
          base_product_name: ctx.baseProductName,
          colors: ctx.colors,
          sizes: ctx.sizes,
          current_description: ctx.currentDescription || null,
          instruction: ctx.instruction || null,
        }, shopifyPayloadFn()),
      });

      if (error) {
        const detail = await readFunctionError(error);
        throw new Error(detail || error.message || 'KI-Beschreibung fehlgeschlagen');
      }

      if (!data || !data.success) {
        throw new Error((data && data.error) || 'KI-Beschreibung fehlgeschlagen');
      }

      if (ctx.descTextarea && data.description) {
        setRichTextContent(ctx.descTextarea, data.description);
      }

      showMessage(root, 'Textvorschlag erstellt.', 'success');
    } catch (descErr) {
      showMessage(root, descErr.message || 'KI-Beschreibung fehlgeschlagen', 'error');
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  function updateSelectionSummary(state, els) {
    const entries = getSelectedVariantEntries(state);
    const groups = groupSelectedByBaseProduct(state);
    const variantCount = entries.length;
    const colorCount = groups.reduce(function (sum, group) {
      return sum + countSelectedColors(state, group.base);
    }, 0);

    if (!els.selectionSummary) return;

    if (!variantCount) {
      els.selectionSummary.textContent = '0 Farben ausgewählt';
      return;
    }

    const articleLabel = groups.length === 1 ? '1 Artikel' : groups.length + ' Artikel';
    const colorLabel = colorCount === 1 ? '1 Farbe' : colorCount + ' Farben';
    const variantLabel = variantCount === 1 ? '1 Variante' : variantCount + ' Varianten';
    els.selectionSummary.textContent = articleLabel + ' · ' + colorLabel + ' · ' + variantLabel + ' (alle Größen)';
  }

  function renderSelectionTree(state, els) {
    if (!els.selectionTree) return;
    if (!state.baseProducts.length) {
      els.selectionTree.innerHTML = '<p class="creator-marketplace__hint">Keine Basisartikel verfügbar.</p>';
      return;
    }

    els.selectionTree.innerHTML = getBaseProductsForSelection(state).map(function (base) {
      const thumb = base.thumbnail_url || base.mockup_image_url || '';
      const colors = collectColorsForBase(base);
      const sizes = collectSizesForBase(base);
      const selectedColorCount = countSelectedColors(state, base);
      const allColorsSelected = colors.length > 0 && selectedColorCount === colors.length;

      const colorChipsHtml = colors.map(function (entry) {
        const selected = isColorSelected(state, base, entry.colorName);
        const hex = getVariantColorHex(entry.sampleVariant, base) || '#d1d5db';
        return (
          '<button type="button" class="creator-marketplace__color-chip' + (selected ? ' is-selected' : '') + '"' +
          ' data-color-select data-base-id="' + escapeHtml(base.id) + '" data-color-name="' + escapeHtml(entry.colorName) + '"' +
          ' aria-pressed="' + (selected ? 'true' : 'false') + '">' +
          '<span class="creator-marketplace__color-chip-swatch" style="background:' + escapeHtml(hex) + '"></span>' +
          '<span class="creator-marketplace__color-chip-label">' + escapeHtml(entry.colorName) + '</span>' +
          '</button>'
        );
      }).join('');

      const sizesLabel = sizes.length
        ? 'Größen automatisch enthalten: ' + sizes.join(' · ')
        : 'Alle verfügbaren Größen werden automatisch angelegt.';

      return (
        '<div class="creator-marketplace__selection-product" data-base-id="' + escapeHtml(base.id) + '">' +
        '<div class="creator-marketplace__selection-product-head">' +
        (thumb ? '<img src="' + escapeHtml(thumb) + '" alt="">' : '<div class="creator-marketplace__selection-product-placeholder"></div>') +
        '<div class="creator-marketplace__selection-product-info">' +
        '<strong class="creator-marketplace__selection-product-name">' + escapeHtml(base.name) + '</strong>' +
        '<span class="creator-marketplace__hint">' + formatMoney(base.base_price) + ' ab · ' + colors.length + ' Farben · ' + sizes.length + ' Größen</span>' +
        '</div>' +
        '<button type="button" class="creator-marketplace__btn creator-marketplace__btn--small creator-marketplace__btn--secondary" data-preview-target data-base-id="' +
        escapeHtml(base.id) + '">Vorschau</button>' +
        '</div>' +
        '<div class="creator-marketplace__selection-colors">' +
        '<div class="creator-marketplace__selection-colors-head">' +
        '<span class="creator-marketplace__selection-colors-label">Farbe</span>' +
        '<button type="button" class="creator-marketplace__selection-colors-toggle" data-select-all-colors data-base-id="' + escapeHtml(base.id) + '">' +
        (allColorsSelected ? 'Alle abwählen' : 'Alle Farben') +
        '</button>' +
        '</div>' +
        '<div class="creator-marketplace__color-picker">' + (colorChipsHtml || '<p class="creator-marketplace__hint">Keine Farbvarianten verfügbar.</p>') + '</div>' +
        '<p class="creator-marketplace__selection-sizes-note">' + escapeHtml(sizesLabel) + '</p>' +
        '</div>' +
        '</div>'
      );
    }).join('');
  }

  function setPreviewTarget(state, base, variant, els, config) {
    state.selectedBase = base;
    state.selectedVariant = variant;
    state.previewKey = variantSelectionKey(base, variant);
    state.effectiveBasePrice = getVariantBasePrice(base, variant);
    state.currentPrintArea = getEffectivePrintArea(base, variant, state.activeSide, config);

    const sides = getPrintSides(base, variant, config);
    if (!sides.some(function (s) { return s.key === state.activeSide; })) {
      state.activeSide = sides[0] ? sides[0].key : 'front';
    }

    applyConfiguratorMockupAsync(state, els, config, base, variant, state.activeSide);
    renderPrintSideTabs(state, els, base, variant, config);

    if (els.previewLabel) {
      const side = getSideConfig(base, variant, state.activeSide, config);
      const sideLabel = side && sides.length > 1 ? ' · ' + (side.label || side.key) : '';
      const colorName = getVariantColorName(variant, base) || formatVariantDisplayTitle(variant) || variant.title;
      els.previewLabel.textContent = base.name + ' · ' + colorName + sideLabel;
    }

    if (els.selectionTree) {
      els.selectionTree.querySelectorAll('[data-preview-target]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.baseId === base.id);
      });
    }
    syncDesignUploadUi(state, els, config);
    updatePriceBreakdown(state, els);
  }

  function syncPreviewFromSelection(state, els, config) {
    const entries = getSelectedVariantEntries(state);
    if (!entries.length) {
      state.selectedBase = state.baseProducts[0] || null;
      state.selectedVariant = state.selectedBase && state.selectedBase.variants[0] || null;
      state.previewKey = null;
      if (state.selectedBase && state.selectedVariant) {
        setPreviewTarget(state, state.selectedBase, state.selectedVariant, els, config);
      } else if (els.previewLabel) {
        els.previewLabel.textContent = 'Artikel auswählen';
      }
      return;
    }

    let target = entries.find(function (e) { return e.key === state.previewKey; });
    if (!target) target = entries[0];
    const designerVariant = getDesignerVariantForBase(state, target.base) || target.variant;
    setPreviewTarget(state, target.base, designerVariant, els, config);
  }

  function shouldStripJpegWhiteBackground(file) {
    if (!file) return false;
    const type = String(file.type || '').toLowerCase();
    const name = String(file.name || '').toLowerCase();
    return (
      type === 'image/jpeg' ||
      type === 'image/jpg' ||
      name.endsWith('.jpg') ||
      name.endsWith('.jpeg')
    );
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      const reader = new FileReader();
      reader.onload = function () { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function isNearWhitePixel(r, g, b) {
    return (
      (r === 255 && g === 255 && b === 255) ||
      (r === 246 && g === 246 && b === 246) ||
      (r >= 246 && g >= 246 && b >= 246)
    );
  }

  function stripNearWhiteFromImageData(imageData) {
    const pixels = imageData.data;
    for (let i = 0; i < pixels.length; i += 4) {
      if (isNearWhitePixel(pixels[i], pixels[i + 1], pixels[i + 2])) {
        pixels[i + 3] = 0;
      }
    }
    return imageData;
  }

  const MOCKUP_CANVAS_SIZE = 1024;

  function isStudioBackgroundPixel(r, g, b) {
    return r >= 244 && g >= 244 && b >= 244 && Math.abs(r - g) <= 2 && Math.abs(g - b) <= 2;
  }

  function computeColorLayerMaskAlpha(r, g, b, a) {
    if (a < 250) {
      return a < 6 ? 0 : a;
    }
    if (isStudioBackgroundPixel(r, g, b)) {
      const dr = r - 246;
      const dg = g - 246;
      const db = b - 246;
      const dist = Math.sqrt(dr * dr + dg * dg + db * db);
      if (dist < 5) return 0;
      if (dist < 40) return Math.round(((dist - 5) / 35) * 220);
    }
    return 255;
  }

  function computeContainBounds(img, size) {
    const iw = img.naturalWidth || img.width || size;
    const ih = img.naturalHeight || img.height || size;
    const scale = Math.min(size / iw, size / ih);
    const drawW = iw * scale;
    const drawH = ih * scale;
    return {
      size: size,
      ox: (size - drawW) / 2 / size,
      oy: (size - drawH) / 2 / size,
      dw: drawW / size,
      dh: drawH / size,
    };
  }

  function drawImageContainOnly(ctx, img, size) {
    const bounds = computeContainBounds(img, size);
    if (!img.naturalWidth && !img.width) return bounds;
    const drawW = bounds.dw * size;
    const drawH = bounds.dh * size;
    const offsetX = bounds.ox * size;
    const offsetY = bounds.oy * size;
    ctx.drawImage(img, offsetX, offsetY, drawW, drawH);
    return bounds;
  }

  function drawImageContainSquare(ctx, img, size) {
    const bounds = computeContainBounds(img, size);
    ctx.fillStyle = '#f4f4f4';
    ctx.fillRect(0, 0, size, size);
    drawImageContainOnly(ctx, img, size);
    return bounds;
  }

  async function applyHighlightLayer(ctx, highlightLayerUrl, side) {
    if (!highlightLayerUrl) return;
    ctx.save();
    ctx.globalCompositeOperation = 'multiply';
    try {
      const highlightMask = await createHighlightMaskCanvas(highlightLayerUrl, side);
      ctx.drawImage(highlightMask, 0, 0, side, side);
    } catch (maskErr) {
      const highlightImg = await loadCanvasImage(highlightLayerUrl);
      drawImageContainOnly(ctx, highlightImg, side);
    }
    ctx.restore();
  }

  function resolvePrintAreaPixels(size, printArea, drawBounds) {
    const b = drawBounds || { ox: 0, oy: 0, dw: 1, dh: 1 };
    const side = size || MOCKUP_CANVAS_SIZE;
    const area = normalizePrintArea(printArea);
    return {
      x: b.ox * side + (area.x / 100) * b.dw * side,
      y: b.oy * side + (area.y / 100) * b.dh * side,
      w: (area.width / 100) * b.dw * side,
      h: (area.height / 100) * b.dh * side,
    };
  }

  function normalizePrintArea(area, fallback) {
    const base = fallback || { x: 28, y: 22, width: 44, height: 48, width_cm: 30, height_cm: 40 };
    if (!area) return Object.assign({}, base);
    return {
      x: area.x != null ? Number(area.x) : base.x,
      y: area.y != null ? Number(area.y) : base.y,
      width: area.width != null ? Number(area.width) : base.width,
      height: area.height != null ? Number(area.height) : base.height,
      width_cm: area.width_cm != null ? Number(area.width_cm) : base.width_cm,
      height_cm: area.height_cm != null ? Number(area.height_cm) : base.height_cm,
    };
  }

  function roundCm(value) {
    return Math.round(value * 10) / 10;
  }

  function getDesignImageAspectRatio(els) {
    if (els && els.designImg && els.designImg.naturalWidth > 0 && els.designImg.naturalHeight > 0) {
      return els.designImg.naturalHeight / els.designImg.naturalWidth;
    }
    return 1;
  }

  function resolvePlacementScale(placement, printArea, imageAspect) {
    const area = normalizePrintArea(printArea);
    const aspect = imageAspect > 0 ? imageAspect : 1;
    if (placement.width_cm && area.width_cm) {
      let widthCm = Number(placement.width_cm);
      let heightCm = placement.height_cm ? Number(placement.height_cm) : widthCm * aspect;
      if (area.height_cm && heightCm > area.height_cm) {
        heightCm = area.height_cm;
        widthCm = heightCm / aspect;
      }
      if (widthCm > area.width_cm) {
        widthCm = area.width_cm;
      }
      return widthCm / area.width_cm;
    }
    return placement.scale || 1;
  }

  function syncPlacementCmFromScale(placement, printArea, imageAspect) {
    const area = normalizePrintArea(printArea);
    if (!area.width_cm) return;
    const aspect = imageAspect > 0 ? imageAspect : 1;
    const scale = resolvePlacementScale(placement, area, aspect);
    const widthCm = roundCm(scale * area.width_cm);
    placement.width_cm = widthCm;
    placement.height_cm = roundCm(widthCm * aspect);
    placement.scale = scale;
  }

  function syncPlacementScaleFromCm(placement, printArea, imageAspect) {
    const area = normalizePrintArea(printArea);
    if (!placement.width_cm || !area.width_cm) return;
    const aspect = imageAspect > 0 ? imageAspect : 1;
    let widthCm = clamp(Number(placement.width_cm), 0.5, area.width_cm);
    let heightCm = widthCm * aspect;
    if (area.height_cm && heightCm > area.height_cm) {
      heightCm = area.height_cm;
      widthCm = roundCm(heightCm / aspect);
      if (widthCm > area.width_cm) widthCm = area.width_cm;
    }
    placement.width_cm = roundCm(widthCm);
    placement.height_cm = roundCm(heightCm);
    placement.scale = widthCm / area.width_cm;
  }

  function computeDesignDrawRect(placement, printArea, drawBounds, canvasSize, imageNaturalW, imageNaturalH) {
    const area = normalizePrintArea(printArea);
    const areaRect = resolvePrintAreaPixels(canvasSize, area, drawBounds);
    const aspect = imageNaturalW > 0 ? imageNaturalH / imageNaturalW : 1;
    const scale = resolvePlacementScale(placement, area, aspect);
    const designW = areaRect.w * scale;
    const designH = designW * aspect;
    const centerX = areaRect.x + (placement.x / 100) * areaRect.w;
    const centerY = areaRect.y + (placement.y / 100) * areaRect.h;
    return {
      x: centerX - designW / 2,
      y: centerY - designH / 2,
      w: designW,
      h: designH,
      scale: scale,
      widthCm: placement.width_cm || (area.width_cm ? roundCm(scale * area.width_cm) : null),
      heightCm: placement.height_cm || (area.width_cm ? roundCm(scale * area.width_cm * aspect) : null),
    };
  }

  function getPrintAreaAspect(printArea, drawBounds, els) {
    if (els && els.printArea) {
      const rect = els.printArea.getBoundingClientRect();
      if (rect.height > 0) return rect.width / rect.height;
    }
    const area = normalizePrintArea(printArea);
    const b = drawBounds || { dw: 1, dh: 1 };
    if (area.width > 0 && area.height > 0) {
      return (area.width * b.dw) / (area.height * b.dh);
    }
    return 1;
  }

  function getMaxPlacementScale(imageAspect, printAreaAspect) {
    const aspect = imageAspect > 0 ? imageAspect : 1;
    const areaAspect = printAreaAspect > 0 ? printAreaAspect : 1;
    return Math.min(2, 1, areaAspect / aspect);
  }

  function clampPlacementToPrintArea(placement, printArea, imageAspect, els, drawBounds) {
    const areaAspect = getPrintAreaAspect(printArea, drawBounds, els);
    const aspect = imageAspect > 0 ? imageAspect : 1;
    let scale = resolvePlacementScale(placement, printArea, aspect);
    const maxScale = getMaxPlacementScale(aspect, areaAspect);
    if (scale > maxScale) {
      scale = maxScale;
      placement.scale = scale;
      delete placement.width_cm;
      delete placement.height_cm;
      syncPlacementCmFromScale(placement, printArea, aspect);
    }
    const halfW = scale * 50;
    const halfH = halfW * aspect / areaAspect;
    if (halfW < 50) {
      placement.x = clamp(placement.x, halfW, 100 - halfW);
    } else {
      placement.x = 50;
    }
    if (halfH < 50) {
      placement.y = clamp(placement.y, halfH, 100 - halfH);
    } else {
      placement.y = 50;
    }
    return placement;
  }

  function getHeroPreviewPlacementKey(state, heroSide) {
    const side = heroSide || state.heroPreviewSide || 'front';
    const placement = (state.placements && state.placements[side])
      || (state.placements && state.placements.front)
      || { x: 50, y: 50, scale: 1 };
    return [
      side,
      Math.round(placement.x * 10),
      Math.round(placement.y * 10),
      Math.round((placement.scale || 1) * 100),
      placement.width_cm || '',
    ].join(':');
  }

  function formatPrintAreaCmLabel(printArea) {
    const area = normalizePrintArea(printArea);
    if (!area.width_cm) return 'Druckbereich: —';
    if (area.height_cm) {
      return 'Druckbereich: ' + roundCm(area.width_cm) + ' × ' + roundCm(area.height_cm) + ' cm';
    }
    return 'Druckbereich: ' + roundCm(area.width_cm) + ' cm breit';
  }

  function countOpaquePixels(imageData) {
    let count = 0;
    const pixels = imageData.data;
    for (let i = 3; i < pixels.length; i += 4) {
      if (pixels[i] > 10) count++;
    }
    return count;
  }

  function buildMaskFromColorLayerImageData(imageData) {
    const pixels = imageData.data;
    for (let i = 0; i < pixels.length; i += 4) {
      const maskAlpha = computeColorLayerMaskAlpha(
        pixels[i],
        pixels[i + 1],
        pixels[i + 2],
        pixels[i + 3],
      );
      pixels[i] = 255;
      pixels[i + 1] = 255;
      pixels[i + 2] = 255;
      pixels[i + 3] = maskAlpha;
    }
    return imageData;
  }

  async function createColorLayerMaskCanvas(imageUrl, size) {
    const side = size || MOCKUP_CANVAS_SIZE;
    const img = await loadCanvasImage(imageUrl);
    const canvas = document.createElement('canvas');
    canvas.width = side;
    canvas.height = side;
    const ctx = canvas.getContext('2d');
    drawImageContainSquare(ctx, img, side);
    let imageData;
    try {
      imageData = ctx.getImageData(0, 0, side, side);
    } catch (corsErr) {
      throw new Error('Farblayer blockiert durch CORS — bitte PNG aus Theme-Assets nutzen');
    }
    buildMaskFromColorLayerImageData(imageData);
    if (countOpaquePixels(imageData) < 100) {
      throw new Error('Farblayer leer — bitte PNG mit sichtbarer Produktform hochladen');
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas;
  }

  async function createHighlightMaskCanvas(imageUrl, size) {
    const side = size || MOCKUP_CANVAS_SIZE;
    const img = await loadCanvasImage(imageUrl);
    const canvas = document.createElement('canvas');
    canvas.width = side;
    canvas.height = side;
    const ctx = canvas.getContext('2d');
    drawImageContainSquare(ctx, img, side);
    const imageData = ctx.getImageData(0, 0, side, side);
    const pixels = imageData.data;
    for (let i = 0; i < pixels.length; i += 4) {
      const maskAlpha = computeColorLayerMaskAlpha(
        pixels[i],
        pixels[i + 1],
        pixels[i + 2],
        pixels[i + 3],
      );
      if (maskAlpha < 8) {
        pixels[i + 3] = 0;
      } else {
        pixels[i + 3] = Math.min(255, Math.round(pixels[i + 3] * (maskAlpha / 255)));
      }
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas;
  }

  async function stripNearWhiteBackground(dataUrl) {
    const img = await loadCanvasImage(dataUrl);
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth || img.width;
    canvas.height = img.naturalHeight || img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    stripNearWhiteFromImageData(imageData);
    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL('image/png');
  }

  async function applyDesignToPreview(state, file, els, config) {
    const sideKey = state.activeSide || 'front';
    const design = getDesignForSide(state, sideKey);

    try {
      const resolutionError = await validateDesignResolutionForSide(state, file, config, sideKey);
      if (resolutionError) {
        if (els.designStatus) els.designStatus.textContent = resolutionError;
        if (els.designUpload) els.designUpload.value = '';
        return;
      }

      let dataUrl = await readFileAsDataUrl(file);
      if (shouldStripJpegWhiteBackground(file)) {
        dataUrl = await stripNearWhiteBackground(dataUrl);
        design.file = await dataUrlToBlob(dataUrl);
      } else {
        design.file = file;
      }
      design.dataUrl = dataUrl;
      state.heroPreviewCache = {};
      syncDesignUploadUi(state, els, config);
      syncPlacementControls(state, els);
      scheduleHeroPreviewRefresh(state, els, config);
      updatePriceBreakdown(state, els);
      if (els.designStatus && shouldStripJpegWhiteBackground(file)) {
        els.designStatus.textContent = 'Motiv bereit (weißer JPG-Hintergrund entfernt)';
      }
    } catch (processErr) {
      if (els.designStatus) {
        els.designStatus.textContent = 'Motiv konnte nicht verarbeitet werden.';
      }
      console.warn('[creator-marketplace] Motiv-Verarbeitung fehlgeschlagen:', processErr);
    }
  }

  function bindUploadZone(form, els, state, config) {
    if (!els.designUpload || els.designUpload.dataset.uploadBound) return;
    els.designUpload.dataset.uploadBound = '1';

    const openPicker = function () { els.designUpload.click(); };

    if (els.uploadTrigger) els.uploadTrigger.addEventListener('click', openPicker);
    if (els.uploadReplace) els.uploadReplace.addEventListener('click', openPicker);

    if (els.uploadZone) {
      els.uploadZone.addEventListener('click', function (e) {
        if (e.target.closest('[data-upload-replace]') || e.target.closest('[data-upload-trigger]')) return;
        if (!hasDesignForSide(state, state.activeSide)) openPicker();
      });
      els.uploadZone.addEventListener('dragover', function (e) {
        e.preventDefault();
        els.uploadZone.classList.add('is-dragover');
      });
      els.uploadZone.addEventListener('dragleave', function () {
        els.uploadZone.classList.remove('is-dragover');
      });
      els.uploadZone.addEventListener('drop', function (e) {
        e.preventDefault();
        els.uploadZone.classList.remove('is-dragover');
        const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file && file.type.startsWith('image/')) applyDesignToPreview(state, file, els, config);
      });
    }

    els.designUpload.addEventListener('change', function () {
      const file = els.designUpload.files && els.designUpload.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        if (els.designStatus) els.designStatus.textContent = 'Bitte eine Bilddatei auswählen.';
        return;
      }
      applyDesignToPreview(state, file, els, config);
    });
  }

  function readBaseProductCatalog(root) {
    const el = root.querySelector('[data-creator-base-catalog]');
    if (!el) return [];
    try {
      const parsed = JSON.parse(el.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_parseErr) {
      console.warn('[creator-marketplace] Basisartikel-Katalog konnte nicht gelesen werden');
      return [];
    }
  }

  async function fetchBaseProductsFromApi(client, config) {
    const { data, error } = await client.functions.invoke('list-creator-base-products', {
      body: { tag: config.creatorBaseTag },
    });
    if (error) {
      const detail = await readFunctionError(error);
      throw new Error(detail || error.message);
    }
    if (!data || !data.success) {
      throw new Error((data && data.error) || 'Basisartikel konnten nicht geladen werden');
    }
    return data.products || [];
  }

  async function loadBaseProducts(root, client, config) {
    const catalog = readBaseProductCatalog(root);
    if (catalog.length) {
      return { products: catalog, source: 'theme-blocks' };
    }
    const apiProducts = await fetchBaseProductsFromApi(client, config);
    return { products: apiProducts, source: 'shopify-tag' };
  }

  async function setupProductConfigurator(root, client, config, creator) {
    const form = root.querySelector('[data-form="product"]');
    if (!form) return;

    const state = configuratorStore.get(root) || {
      baseProducts: [],
      selectedBase: null,
      selectedVariant: null,
      selectedVariantKeys: {},
      previewKey: null,
      effectiveBasePrice: 0,
      designsBySide: {},
      designFile: null,
      designDataUrl: null,
      heroPreviewKey: null,
      heroPreviewKeys: {},
      heroPreviewSide: 'front',
      heroPreviewCache: {},
      activeSide: 'front',
      placements: { front: { x: 50, y: 50, scale: 1 } },
      placement: { x: 50, y: 50, scale: 1 },
      drag: null,
      resize: null,
      creator,
    };
    if (!state.selectedVariantKeys) state.selectedVariantKeys = {};
    state.creator = creator;
    configuratorStore.set(root, state);

    const els = getConfiguratorEls(form);
    if (!els.selectionTree) return;

    let shopifyProducts = [];
    let catalogSource = 'shopify-tag';
    try {
      const loaded = await loadBaseProducts(root, client, config);
      shopifyProducts = loaded.products || [];
      catalogSource = loaded.source || 'shopify-tag';
    } catch (loadErr) {
      els.selectionTree.innerHTML =
        '<p class="creator-marketplace__hint">Fehler beim Laden: ' +
        escapeHtml(loadErr.message || 'Unbekannt') +
        '</p>';
      return;
    }

    if (!shopifyProducts.length) {
      els.selectionTree.innerHTML =
        '<p class="creator-marketplace__hint">Keine Basisartikel konfiguriert. Im <strong>Theme Editor</strong> diese Section öffnen → Block <strong>Basisartikel</strong> hinzufügen → Shopify-Produkt wählen und Druckflächen einstellen.' +
        (catalogSource === 'shopify-tag'
          ? ' Alternativ: Produkte im Admin mit Tag <strong>' + escapeHtml(config.creatorBaseTag) + '</strong> versehen.'
          : '') +
        '</p>';
      return;
    }

    state.baseProducts = shopifyProducts.map(function (p) {
      return normalizeShopifyBaseProduct(p, config);
    });

    if (els.markupInput) {
      els.markupInput.min = String(config.minMarkup || 0);
      els.markupInput.max = String(config.maxMarkup || 50);
    }

    renderSelectionTree(state, els);
    updateSelectionSummary(state, els);
    syncPreviewFromSelection(state, els, config);
    bindUploadZone(form, els, state, config);
    bindProductTitleCounter(form);
    initRichTextEditors(root);

    if (!form.dataset.configuratorEventsBound) {
      form.dataset.configuratorEventsBound = '1';

      if (els.selectionTree) {
        els.selectionTree.addEventListener('click', function (e) {
          const colorBtn = e.target.closest('[data-color-select]');
          if (colorBtn) {
            e.preventDefault();
            const base = state.baseProducts.find(function (b) { return b.id === colorBtn.dataset.baseId; });
            if (!base) return;
            const colorName = colorBtn.dataset.colorName;
            const nextSelected = !isColorSelected(state, base, colorName);
            setColorSelected(state, base, colorName, nextSelected);
            syncHeroPreviewKeyForBase(state, base, colorName, nextSelected);
            if (nextSelected) {
              const sampleVariant = getVariantsForColor(base, colorName)[0];
              if (sampleVariant) state.previewKey = variantSelectionKey(base, sampleVariant);
            }
            renderSelectionTree(state, els);
            updateSelectionSummary(state, els);
            syncPreviewFromSelection(state, els, config);
            scheduleHeroPreviewRefresh(state, els, config);
            return;
          }

          const allColorsBtn = e.target.closest('[data-select-all-colors]');
          if (allColorsBtn) {
            e.preventDefault();
            const base = state.baseProducts.find(function (b) { return b.id === allColorsBtn.dataset.baseId; });
            if (!base) return;
            const colors = collectColorsForBase(base);
            const shouldSelectAll = colors.some(function (entry) {
              return !isColorSelected(state, base, entry.colorName);
            });
            colors.forEach(function (entry) {
              setColorSelected(state, base, entry.colorName, shouldSelectAll);
              syncHeroPreviewKeyForBase(state, base, entry.colorName, shouldSelectAll);
            });
            if (!shouldSelectAll) {
              setHeroPreviewKey(state, base, null);
            } else if (colors[0] && !getHeroPreviewKey(state, base)) {
              setHeroPreviewKey(state, base, buildHeroPreviewKey(base, colors[0].colorName));
            }
            if (shouldSelectAll && colors[0]) {
              state.previewKey = variantSelectionKey(base, colors[0].sampleVariant);
            }
            renderSelectionTree(state, els);
            updateSelectionSummary(state, els);
            syncPreviewFromSelection(state, els, config);
            scheduleHeroPreviewRefresh(state, els, config);
            return;
          }

          const previewBtn = e.target.closest('[data-preview-target]');
          if (!previewBtn) return;
          e.preventDefault();
          const base = state.baseProducts.find(function (b) { return b.id === previewBtn.dataset.baseId; });
          if (!base) return;
          const variant = getDesignerVariantForBase(state, base)
            || base.variants.find(function (v) {
              return state.selectedVariantKeys[variantSelectionKey(base, v)];
            })
            || base.variants[0];
          if (variant) setPreviewTarget(state, base, variant, els, config);
        });
      }

      if (els.designScale) {
        els.designScale.addEventListener('input', function () {
          const placement = getActivePlacement(state);
          placement.scale = parseInt(els.designScale.value, 10) / 100;
          delete placement.width_cm;
          delete placement.height_cm;
          clampPlacementToPrintArea(
            placement,
            state.currentPrintArea,
            getDesignImageAspectRatio(els),
            els,
          );
          setActivePlacement(state, placement);
          syncPlacementControls(state, els);
        });
        els.designScale.addEventListener('change', function () {
          scheduleHeroPreviewRefresh(state, els, config, { delay: 300 });
        });
      }

      if (els.designWidthCm) {
        els.designWidthCm.addEventListener('input', function () {
          const placement = getActivePlacement(state);
          const printArea = state.currentPrintArea;
          if (!printArea || !printArea.width_cm) return;
          placement.width_cm = parseFloat(els.designWidthCm.value);
          if (!Number.isFinite(placement.width_cm)) return;
          syncPlacementScaleFromCm(placement, printArea, getDesignImageAspectRatio(els));
          clampPlacementToPrintArea(
            placement,
            printArea,
            getDesignImageAspectRatio(els),
            els,
          );
          setActivePlacement(state, placement);
          syncPlacementControls(state, els);
        });
        els.designWidthCm.addEventListener('change', function () {
          scheduleHeroPreviewRefresh(state, els, config, { delay: 300 });
        });
      }

      if (els.designImg && !els.designImg.dataset.placementAspectBound) {
        els.designImg.dataset.placementAspectBound = '1';
        els.designImg.addEventListener('load', function () {
          syncPlacementControls(state, els);
        });
      }

      if (els.markupInput) {
        els.markupInput.addEventListener('input', function () {
          updatePriceBreakdown(state, els);
        });
      }

      if (els.printSideTabs && !els.printSideTabs.dataset.sideTabsBound) {
        els.printSideTabs.dataset.sideTabsBound = '1';
        els.printSideTabs.addEventListener('click', function (e) {
          const sideBtn = e.target.closest('[data-print-side]');
          if (!sideBtn || !state.selectedBase || !state.selectedVariant) return;
          e.preventDefault();
          state.activeSide = sideBtn.dataset.printSide;
          setPreviewTarget(state, state.selectedBase, state.selectedVariant, els, config);
        });
      }

      bindDesignDrag(form, els, state, config);
      bindDesignResize(form, els, state, config);

      if (els.heroPreviewSide && !els.heroPreviewSide.dataset.heroSideBound) {
        els.heroPreviewSide.dataset.heroSideBound = '1';
        els.heroPreviewSide.addEventListener('change', function () {
          state.heroPreviewSide = els.heroPreviewSide.value || 'front';
          state.heroPreviewCache = {};
          renderHeroPreviewPicker(state, els, config);
        });
      }

      if (els.heroPreviewGrid && !els.heroPreviewGrid.dataset.heroGridBound) {
        els.heroPreviewGrid.dataset.heroGridBound = '1';
        els.heroPreviewGrid.addEventListener('change', function (e) {
          const radio = e.target.closest('[data-hero-preview-radio]');
          if (!radio) return;
          const baseId = radio.dataset.heroBaseId;
          if (!baseId) return;
          setHeroPreviewKey(state, baseId, radio.value);
          const base = state.baseProducts.find(function (b) {
            return getBaseProductKey(b) === baseId;
          });
          if (base) {
            const variant = getDesignerVariantForBase(state, base);
            if (variant) setPreviewTarget(state, base, variant, els, config);
          }
        });
      }
    }

    syncDesignUploadUi(state, els, config);
    scheduleHeroPreviewRefresh(state, els, config);
    updatePriceBreakdown(state, els);
  }

  const PRINT_SIDE_LABELS = { front: 'Vorne', back: 'Hinten', neck: 'Nacken' };

  function getSideLabel(sideKey) {
    return PRINT_SIDE_LABELS[sideKey] || sideKey;
  }

  function ensureDesignsBySide(state) {
    if (!state.designsBySide || typeof state.designsBySide !== 'object') {
      state.designsBySide = {};
    }
    return state.designsBySide;
  }

  function getDesignForSide(state, sideKey) {
    const key = sideKey || state.activeSide || 'front';
    const designs = ensureDesignsBySide(state);
    if (!designs[key]) designs[key] = { file: null, dataUrl: null };
    return designs[key];
  }

  function hasDesignForSide(state, sideKey) {
    const design = getDesignForSide(state, sideKey);
    return !!(design.file || design.dataUrl);
  }

  function syncLegacyDesignFields(state) {
    const current = getDesignForSide(state, state.activeSide);
    state.designFile = current.file || null;
    state.designDataUrl = current.dataUrl || null;
  }

  function syncDesignUploadUi(state, els, config) {
    const sideKey = state.activeSide || 'front';
    const design = getDesignForSide(state, sideKey);
    syncLegacyDesignFields(state);

    const sideLabel = getSideLabel(sideKey);
    if (els.uploadSideLabel) {
      els.uploadSideLabel.textContent = 'Motiv für ' + sideLabel + ' hochladen';
    }

    const hasDesign = !!(design.file || design.dataUrl);
    if (els.designLayer) els.designLayer.hidden = !hasDesign;
    if (els.designImg) {
      if (hasDesign) {
        prepareImageElement(els.designImg, design.dataUrl);
        els.designImg.src = design.dataUrl;
      } else {
        els.designImg.removeAttribute('src');
      }
    }

    if (els.designStatus) {
      els.designStatus.textContent = hasDesign
        ? (design.file ? design.file.name : 'Motiv für ' + sideLabel + ' bereit')
        : 'Noch kein Motiv für ' + sideLabel;
    }

    if (els.uploadThumb) {
      if (hasDesign) els.uploadThumb.src = design.dataUrl;
      else els.uploadThumb.removeAttribute('src');
    }
    if (els.uploadFilename) {
      els.uploadFilename.textContent = design.file
        ? design.file.name
        : (hasDesign ? 'Motiv ' + sideLabel : '');
    }
    if (els.uploadEmpty) els.uploadEmpty.classList.toggle('creator-marketplace__hidden', hasDesign);
    if (els.uploadFilled) els.uploadFilled.classList.toggle('creator-marketplace__hidden', !hasDesign);
  }

  function collectUploadedDesignSides(state) {
    return ['front', 'back', 'neck'].filter(function (sideKey) {
      return hasDesignForSide(state, sideKey);
    });
  }

  function collectActiveDesignSides(state) {
    const uploaded = collectUploadedDesignSides(state);
    if (uploaded.length) return uploaded;
    const placements = ensureConfiguratorPlacements(state);
    return Object.keys(placements).filter(function (sideKey) {
      const placement = placements[sideKey];
      return placement && placement.design_url;
    });
  }

  function getPrintSideSurcharge(base, sideKey) {
    if (!base || !base.print_sides) return 0;
    const side = base.print_sides.find(function (entry) { return entry.key === sideKey; });
    const value = side && side.side_surcharge;
    return Number.isFinite(Number(value)) ? Number(value) : 0;
  }

  function calculateSideSurchargeForBase(base, activeSides) {
    return roundMoney((activeSides || []).reduce(function (sum, sideKey) {
      return sum + getPrintSideSurcharge(base, sideKey);
    }, 0));
  }

  function getSideSurchargeRangeForState(state) {
    const activeSides = collectActiveDesignSides(state);
    if (!activeSides.length) {
      return { min: 0, max: 0 };
    }

    const groups = groupSelectedByBaseProduct(state);
    const bases = groups.length
      ? groups.map(function (group) { return group.base; })
      : (state.baseProducts || []);

    if (!bases.length) {
      return { min: 0, max: 0 };
    }

    const totals = bases.map(function (base) {
      return calculateSideSurchargeForBase(base, activeSides);
    });

    return {
      min: Math.min.apply(null, totals),
      max: Math.max.apply(null, totals),
    };
  }

  function validateProductTitle(title) {
    const trimmed = String(title || '').trim();
    if (!trimmed) return 'Bitte einen Produktnamen eingeben.';
    if (trimmed.length > CREATOR_USER_TITLE_MAX_LENGTH) {
      return 'Produktname darf maximal ' + CREATOR_USER_TITLE_MAX_LENGTH + ' Zeichen haben.';
    }
    return null;
  }

  function bindProductTitleCounter(form) {
    const titleInput = form.querySelector('[data-product-title]');
    const counter = form.querySelector('[data-title-counter]');
    if (!titleInput || titleInput.dataset.titleCounterBound) return;
    titleInput.dataset.titleCounterBound = '1';

    function syncCounter() {
      if (!counter) return;
      const length = titleInput.value.length;
      counter.textContent = length + ' / ' + CREATOR_USER_TITLE_MAX_LENGTH + ' Zeichen';
    }

    titleInput.addEventListener('input', syncCounter);
    syncCounter();
  }

  function getMinPrintPixels(widthCm, heightCm, dpi) {
    const effectiveDpi = Number(dpi) || 150;
    return {
      minWidth: Math.ceil((widthCm / 2.54) * effectiveDpi),
      minHeight: Math.ceil((heightCm / 2.54) * effectiveDpi),
      dpi: effectiveDpi,
    };
  }

  function getPrintAreaForSide(state, sideKey, config) {
    const base = state.selectedBase;
    const variant = state.selectedVariant;
    const sides = getPrintSides(base, variant, config);
    const side = sides.find(function (entry) { return entry.key === sideKey; });
    return (side && side.print_area) || config.printArea;
  }

  function readImageDimensionsFromFile(file) {
    return new Promise(function (resolve, reject) {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(objectUrl);
        resolve({
          width: img.naturalWidth || img.width,
          height: img.naturalHeight || img.height,
        });
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Bild konnte nicht gelesen werden'));
      };
      img.src = objectUrl;
    });
  }

  async function validateDesignResolutionForSide(state, file, config, sideKey) {
    const printArea = getPrintAreaForSide(state, sideKey, config);
    const widthCm = Number(printArea.width_cm) || config.printArea.width_cm || 30;
    const heightCm = Number(printArea.height_cm) || config.printArea.height_cm || 40;
    const dpi = config.printMinDpi || 150;
    const mins = getMinPrintPixels(widthCm, heightCm, dpi);
    const dimensions = await readImageDimensionsFromFile(file);
    const sideLabel = PRINT_SIDE_LABELS[sideKey] || sideKey;

    if (dimensions.width < mins.minWidth || dimensions.height < mins.minHeight) {
      return sideLabel + ': Mindestens ' + mins.minWidth + '×' + mins.minHeight +
        ' px (' + dpi + ' DPI) — dein Bild hat ' + dimensions.width + '×' + dimensions.height + ' px.';
    }

    return null;
  }

  async function uploadDesignForSide(state, sideKey, creator, client, shopifyPayload, config) {
    const design = getDesignForSide(state, sideKey);
    const printArea = getPrintAreaForSide(state, sideKey, config);
    const uploadMeta = {
      side_key: sideKey,
      print_width_cm: Number(printArea.width_cm) || config.printArea.width_cm || 30,
      print_height_cm: Number(printArea.height_cm) || config.printArea.height_cm || 40,
    };

    if (design.file) {
      const filename = Date.now() + '-' + sideKey + '-' + sanitizeFilename(design.file.name);
      return uploadToCreatorStorage(client, 'design', filename, design.file, null, shopifyPayload, uploadMeta);
    }
    if (design.dataUrl) {
      if (!isDataUrl(design.dataUrl)) return design.dataUrl;
      const blob = await dataUrlToBlob(design.dataUrl);
      const filename = Date.now() + '-' + sideKey + '-design.png';
      return uploadToCreatorStorage(client, 'design', filename, blob, 'image/png', shopifyPayload, uploadMeta);
    }
    return null;
  }

  async function buildDesignPayloadForSides(state, creator, client, editingId, sideKeys, shopifyPayload, config) {
    const placements = ensureConfiguratorPlacements(state);
    const designUrls = {};

    for (let i = 0; i < sideKeys.length; i++) {
      const sideKey = sideKeys[i];
      const design = getDesignForSide(state, sideKey);
      const hasNewFile = !!design.file;
      const hasDataUrlUpload = !!(design.dataUrl && isDataUrl(design.dataUrl));
      const existingRemoteUrl = design.dataUrl && !isDataUrl(design.dataUrl) ? design.dataUrl : null;

      if (hasNewFile || hasDataUrlUpload) {
        const url = await uploadDesignForSide(state, sideKey, creator, client, shopifyPayload, config);
        if (url) {
          designUrls[sideKey] = url;
          if (!placements[sideKey]) placements[sideKey] = defaultPlacementPoint();
          placements[sideKey].design_url = url;
        }
      } else if (existingRemoteUrl) {
        designUrls[sideKey] = existingRemoteUrl;
        if (!placements[sideKey]) placements[sideKey] = defaultPlacementPoint();
        placements[sideKey].design_url = existingRemoteUrl;
      } else if (editingId && placements[sideKey] && placements[sideKey].design_url) {
        designUrls[sideKey] = placements[sideKey].design_url;
      }
    }

    const primaryUrl = designUrls.front || designUrls[Object.keys(designUrls)[0]] || null;
    const prunedPlacements = {};
    Object.keys(designUrls).forEach(function (key) {
      prunedPlacements[key] = Object.assign(
        {},
        placements[key] || defaultPlacementPoint(),
        { design_url: designUrls[key] },
      );
    });
    return {
      designUrls: designUrls,
      designUrl: primaryUrl,
      design_placement: prunedPlacements,
    };
  }

  function defaultPlacementPoint() {
    return { x: 50, y: 50, scale: 1 };
  }

  function isFlatPlacement(placement) {
    return !!(placement && Number.isFinite(placement.x));
  }

  function normalizePlacementMap(placement) {
    if (!placement) return { front: defaultPlacementPoint() };
    if (isFlatPlacement(placement)) return { front: placement };
    return placement;
  }

  function ensureConfiguratorPlacements(state) {
    if (!state.placements || typeof state.placements !== 'object') {
      state.placements = { front: defaultPlacementPoint() };
    }
    if (!state.activeSide) state.activeSide = 'front';
    return state.placements;
  }

  function getActivePlacement(state) {
    const placements = ensureConfiguratorPlacements(state);
    if (!placements[state.activeSide]) {
      placements[state.activeSide] = defaultPlacementPoint();
    }
    state.placement = placements[state.activeSide];
    return state.placement;
  }

  function setActivePlacement(state, placement) {
    const placements = ensureConfiguratorPlacements(state);
    placements[state.activeSide] = placement;
    state.placement = placement;
  }

  function getPrintSides(base, variant, config) {
    if (variant && variant.print_sides && variant.print_sides.length) return variant.print_sides;
    if (base && base.print_sides && base.print_sides.length) return base.print_sides;
    const images = (base && base.images) || [];
    const fallbackArea = (base && base.print_area) || config.printArea;
    const count = Math.max(1, Math.min(images.length || 1, 3));
    const keys = ['front', 'back', 'neck'].slice(0, count);
    return keys.map(function (key, index) {
      return {
        key: key,
        label: PRINT_SIDE_LABELS[key] || key,
        print_area: fallbackArea,
        mockup_image_url: (images[index] && images[index].url) || base.primaryImageUrl || config.mockupTshirtUrl,
        image_index: index,
      };
    });
  }

  function getSideConfig(base, variant, sideKey, config) {
    const sides = getPrintSides(base, variant, config);
    const side = sides.find(function (s) { return s.key === sideKey; }) || sides[0] || null;
    if (!side || !base || !base.print_sides || !base.print_sides.length) return side;
    const baseSide = base.print_sides.find(function (s) { return s.key === (sideKey || side.key); });
    if (!baseSide) return side;
    return Object.assign({}, baseSide, {
      mockup_image_url: side.mockup_image_url || baseSide.mockup_image_url,
      print_area: side.print_area || baseSide.print_area,
      image_index: side.image_index != null ? side.image_index : baseSide.image_index,
    });
  }

  function getEffectivePrintArea(base, variant, sideKey, config) {
    const side = getSideConfig(base, variant, sideKey, config);
    if (side && side.print_area) return normalizePrintArea(side.print_area, config.printArea);
    return normalizePrintArea(
      (variant && variant.print_area) || (base && base.print_area) || config.printArea,
      config.printArea,
    );
  }

  function getMockupUrlForSide(base, variant, sideKey, config) {
    const side = getSideConfig(base, variant, sideKey, config);
    if (side && side.mockup_image_url) return side.mockup_image_url;
    return variant.mockup_image_url
      || base.mockup_image_url
      || variant.image_url
      || base.primaryImageUrl
      || config.mockupTshirtUrl;
  }

  function isColorCompositingEnabled(base) {
    return !!(base && base.color_compositing && base.color_compositing.enabled);
  }

  const SIZE_SORT_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];

  function getColorOptionKey(base) {
    return (base && base.color_compositing && base.color_compositing.color_option) || 'option2';
  }

  function getSizeOptionKeys(base) {
    const colorKey = getColorOptionKey(base);
    return ['option1', 'option2', 'option3'].filter(function (key) {
      return key !== colorKey;
    });
  }

  function getVariantColorName(variant, base) {
    if (!variant || !base) return '';
    const optKey = getColorOptionKey(base);
    return String(variant[optKey] || variant.option2 || variant.option1 || '').trim();
  }

  function getVariantSizeName(variant, base) {
    if (!variant || !base) return '';
    const parts = getSizeOptionKeys(base)
      .map(function (key) { return String(variant[key] || '').trim(); })
      .filter(Boolean);
    return parts.join(' / ');
  }

  function sortSizeLabels(sizes) {
    return sizes.slice().sort(function (a, b) {
      const ai = SIZE_SORT_ORDER.indexOf(String(a).toUpperCase());
      const bi = SIZE_SORT_ORDER.indexOf(String(b).toUpperCase());
      if (ai >= 0 && bi >= 0) return ai - bi;
      if (ai >= 0) return -1;
      if (bi >= 0) return 1;
      return String(a).localeCompare(String(b), 'de');
    });
  }

  function collectColorsForBase(base) {
    const map = {};
    (base.variants || []).forEach(function (variant) {
      const colorName = getVariantColorName(variant, base);
      if (!colorName) return;
      if (!map[colorName]) {
        map[colorName] = {
          colorName: colorName,
          sampleVariant: variant,
        };
      }
    });
    return Object.keys(map).map(function (key) { return map[key]; });
  }

  function collectSizesForBase(base) {
    const sizes = [];
    const seen = {};
    (base.variants || []).forEach(function (variant) {
      const sizeName = getVariantSizeName(variant, base);
      if (!sizeName || seen[sizeName]) return;
      seen[sizeName] = true;
      sizes.push(sizeName);
    });
    return sortSizeLabels(sizes);
  }

  function getVariantsForColor(base, colorName) {
    return (base.variants || []).filter(function (variant) {
      return getVariantColorName(variant, base) === colorName;
    });
  }

  function isColorSelected(state, base, colorName) {
    const variants = getVariantsForColor(base, colorName);
    if (!variants.length) return false;
    return variants.every(function (variant) {
      return state.selectedVariantKeys[variantSelectionKey(base, variant)];
    });
  }

  function setColorSelected(state, base, colorName, selected) {
    getVariantsForColor(base, colorName).forEach(function (variant) {
      state.selectedVariantKeys[variantSelectionKey(base, variant)] = selected;
    });
  }

  function countSelectedColors(state, base) {
    return collectColorsForBase(base).filter(function (entry) {
      return isColorSelected(state, base, entry.colorName);
    }).length;
  }

  function guessColorHex(colorName) {
    const name = String(colorName || '').toLowerCase();
    if (!name) return '#9ca3af';
    if (name.indexOf('weiß') >= 0 || name.indexOf('weiss') >= 0 || name === 'white') return '#f4f4f4';
    if (name.indexOf('schwarz') >= 0 || name === 'black') return '#1a1a1a';
    if (name.indexOf('navy') >= 0) return '#1e3a5f';
    if (name.indexOf('rot') >= 0 || name === 'red') return '#c62828';
    if (name.indexOf('blau') >= 0 || name === 'blue') return '#2563eb';
    if (name.indexOf('grün') >= 0 || name.indexOf('gruen') >= 0 || name === 'green') return '#2e7d32';
    if (name.indexOf('gelb') >= 0 || name === 'yellow') return '#f9a825';
    if (name.indexOf('grau') >= 0 || name === 'grey' || name === 'gray') return '#6b7280';
    return '#9ca3af';
  }

  function lookupColorPreset(map, colorName) {
    if (!map || !colorName) return null;
    if (map[colorName]) return map[colorName];
    const lower = String(colorName).toLowerCase();
    const keys = Object.keys(map);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase() === lower) return map[keys[i]];
    }
    return null;
  }

  function getVariantColorHex(variant, base) {
    const colorName = getVariantColorName(variant, base);
    if (!colorName) return null;
    const map = (base.color_compositing && base.color_compositing.colors) || {};
    return lookupColorPreset(map, colorName) || guessColorHex(colorName);
  }

  function getSideLayerUrls(base, variant, sideKey, config) {
    const side = getSideConfig(base, variant, sideKey, config);
    if (!side) return { colorLayerUrl: null, highlightLayerUrl: null };
    const colorLayerUrl = side.color_layer_url || side.base_layer_url || null;
    return {
      colorLayerUrl: colorLayerUrl,
      highlightLayerUrl: side.highlight_layer_url || null,
    };
  }

  function shouldUseColorCompositing(base, variant, sideKey, config) {
    if (!isColorCompositingEnabled(base)) return false;
    const layers = getSideLayerUrls(base, variant, sideKey, config);
    return !!(layers.colorLayerUrl && getVariantColorHex(variant, base));
  }

  async function compositeColorMockupDirect(colorLayerUrl, highlightLayerUrl, colorHex, size) {
    const side = size || MOCKUP_CANVAS_SIZE;
    const maskImg = await loadCanvasImage(colorLayerUrl);
    const drawBounds = computeContainBounds(maskImg, side);

    const canvas = document.createElement('canvas');
    canvas.width = side;
    canvas.height = side;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#f4f4f4';
    ctx.fillRect(0, 0, side, side);

    const colorCanvas = document.createElement('canvas');
    colorCanvas.width = side;
    colorCanvas.height = side;
    const colorCtx = colorCanvas.getContext('2d');
    colorCtx.fillStyle = colorHex;
    colorCtx.fillRect(0, 0, side, side);
    colorCtx.globalCompositeOperation = 'destination-in';
    drawImageContainOnly(colorCtx, maskImg, side);
    ctx.drawImage(colorCanvas, 0, 0);

    await applyHighlightLayer(ctx, highlightLayerUrl, side);

    return { canvas: canvas, drawBounds: drawBounds };
  }

  async function compositeColorMockupMasked(colorLayerUrl, highlightLayerUrl, colorHex, size) {
    const side = size || MOCKUP_CANVAS_SIZE;
    const maskImg = await loadCanvasImage(colorLayerUrl);
    const drawBounds = computeContainBounds(maskImg, side);
    const maskCanvas = await createColorLayerMaskCanvas(colorLayerUrl, side);

    const canvas = document.createElement('canvas');
    canvas.width = side;
    canvas.height = side;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#f4f4f4';
    ctx.fillRect(0, 0, side, side);

    const colorCanvas = document.createElement('canvas');
    colorCanvas.width = side;
    colorCanvas.height = side;
    const colorCtx = colorCanvas.getContext('2d');
    colorCtx.fillStyle = colorHex;
    colorCtx.fillRect(0, 0, side, side);
    colorCtx.globalCompositeOperation = 'destination-in';
    colorCtx.drawImage(maskCanvas, 0, 0, side, side);
    ctx.drawImage(colorCanvas, 0, 0);

    await applyHighlightLayer(ctx, highlightLayerUrl, side);

    return { canvas: canvas, drawBounds: drawBounds };
  }

  async function compositeColorMockup(colorLayerUrl, highlightLayerUrl, colorHex, size) {
    try {
      return await compositeColorMockupDirect(colorLayerUrl, highlightLayerUrl, colorHex, size);
    } catch (directErr) {
      console.warn('[creator-marketplace] Farblayer Direct-Modus fehlgeschlagen, nutze Masken-Modus:', directErr);
      return await compositeColorMockupMasked(colorLayerUrl, highlightLayerUrl, colorHex, size);
    }
  }

  async function getMockupCanvasForSide(state, base, variant, sideKey, config) {
    const exportSide = sideKey || (state && state.activeSide) || 'front';
    const side = MOCKUP_CANVAS_SIZE;

    if (shouldUseColorCompositing(base, variant, exportSide, config)) {
      const layers = getSideLayerUrls(base, variant, exportSide, config);
      const colorHex = getVariantColorHex(variant, base);
      return compositeColorMockup(layers.colorLayerUrl, layers.highlightLayerUrl, colorHex, side);
    }

    const mockupUrl = getMockupUrlForSide(base, variant, exportSide, config);
    const mockupImage = await loadCanvasImage(mockupUrl);
    const canvas = document.createElement('canvas');
    canvas.width = side;
    canvas.height = side;
    const ctx = canvas.getContext('2d');
    const drawBounds = drawImageContainSquare(ctx, mockupImage, side);
    return { canvas: canvas, drawBounds: drawBounds };
  }

  let heroPreviewRefreshTimer = null;
  let heroPreviewRendering = false;

  function scheduleHeroPreviewRefresh(state, els, config, options) {
    if (!els || !els.heroPreviewGrid) return;
    const opts = options || {};
    const delay = opts.immediate ? 0 : (opts.delay != null ? opts.delay : 700);
    if (heroPreviewRefreshTimer) clearTimeout(heroPreviewRefreshTimer);
    heroPreviewRefreshTimer = setTimeout(function () {
      renderHeroPreviewPicker(state, els, config);
    }, delay);
  }

  function collectSelectedColorEntries(state) {
    const map = {};
    getSelectedVariantEntries(state).forEach(function (entry) {
      const colorName = getVariantColorName(entry.variant, entry.base);
      if (!colorName) return;
      const key = getBaseProductKey(entry.base) + '::' + colorName;
      if (!map[key]) {
        map[key] = {
          key: key,
          base: entry.base,
          variant: entry.variant,
          colorName: colorName,
        };
      }
    });
    return Object.keys(map).map(function (k) { return map[k]; });
  }

  function findVariantForColor(base, colorName) {
    return base.variants.find(function (v) {
      return getVariantColorName(v, base) === colorName;
    }) || base.variants[0] || null;
  }

  function getBaseProductKey(baseOrId) {
    if (baseOrId && typeof baseOrId === 'object') {
      return String(baseOrId.id || baseOrId.shopify_product_id);
    }
    return String(baseOrId);
  }

  function buildHeroPreviewKey(baseOrId, colorName) {
    return getBaseProductKey(baseOrId) + '::' + colorName;
  }

  function ensureHeroPreviewKeys(state) {
    if (!state.heroPreviewKeys || typeof state.heroPreviewKeys !== 'object') {
      state.heroPreviewKeys = {};
    }
    return state.heroPreviewKeys;
  }

  function parseHeroPreviewKey(key) {
    if (!key || String(key).indexOf('::') < 0) return null;
    const parts = String(key).split('::');
    return {
      productId: parts[0],
      colorName: parts.slice(1).join('::'),
    };
  }

  function getHeroPreviewKey(state, baseProductId) {
    const keys = ensureHeroPreviewKeys(state);
    return keys[getBaseProductKey(baseProductId)] || null;
  }

  function setHeroPreviewKey(state, baseProductId, key) {
    const keys = ensureHeroPreviewKeys(state);
    const id = getBaseProductKey(baseProductId);
    if (key) keys[id] = key;
    else delete keys[id];
  }

  function syncHeroPreviewKeyForBase(state, base, colorName, selected) {
    if (!base) return;
    const baseId = getBaseProductKey(base);
    const heroKey = getHeroPreviewKey(state, baseId);
    const parsed = parseHeroPreviewKey(heroKey);

    if (!selected) {
      if (parsed && parsed.colorName === colorName) {
        const remaining = collectSelectedColorEntries(state).filter(function (entry) {
          return getBaseProductKey(entry.base) === baseId && entry.colorName !== colorName;
        });
        if (remaining.length) {
          setHeroPreviewKey(state, baseId, remaining[0].key);
        } else {
          setHeroPreviewKey(state, baseId, null);
        }
      }
      if (!countSelectedColors(state, base)) {
        setHeroPreviewKey(state, baseId, null);
      }
      return;
    }

    if (!getHeroPreviewKey(state, baseId)) {
      setHeroPreviewKey(state, baseId, buildHeroPreviewKey(baseId, colorName));
    }
  }

  function pruneHeroPreviewKeys(state, colorEntries) {
    const keys = ensureHeroPreviewKeys(state);
    const activeBaseIds = {};
    colorEntries.forEach(function (entry) {
      activeBaseIds[getBaseProductKey(entry.base)] = true;
    });
    Object.keys(keys).forEach(function (id) {
      if (!activeBaseIds[id]) delete keys[id];
    });
  }

  function getDesignerVariantForBase(state, base) {
    if (!base) return null;
    const baseId = getBaseProductKey(base);
    const parsed = parseHeroPreviewKey(getHeroPreviewKey(state, baseId));
    if (parsed && parsed.productId === baseId) {
      const heroVariant = findVariantForColor(base, parsed.colorName);
      if (heroVariant) return heroVariant;
    }
    const entries = getSelectedVariantEntries(state).filter(function (entry) {
      return getBaseProductKey(entry.base) === baseId;
    });
    if (state.previewKey) {
      const match = entries.find(function (entry) { return entry.key === state.previewKey; });
      if (match) return match.variant;
    }
    return entries.length ? entries[0].variant : null;
  }

  function syncDesignerPreviewFromHero(state, els, config) {
    const base = state.selectedBase;
    if (!base || !els) return;
    const variant = getDesignerVariantForBase(state, base);
    if (variant) setPreviewTarget(state, base, variant, els, config);
  }

  function groupColorEntriesByBase(colorEntries) {
    const map = {};
    const order = [];
    colorEntries.forEach(function (entry) {
      const baseId = getBaseProductKey(entry.base);
      if (!map[baseId]) {
        map[baseId] = { base: entry.base, entries: [] };
        order.push(baseId);
      }
      map[baseId].entries.push(entry);
    });
    return order.map(function (id) { return map[id]; });
  }

  function ensureDefaultHeroKeysForBases(state, colorEntries) {
    pruneHeroPreviewKeys(state, colorEntries);
    const groups = groupColorEntriesByBase(colorEntries);
    groups.forEach(function (group) {
      const baseId = getBaseProductKey(group.base);
      const current = getHeroPreviewKey(state, baseId);
      const parsedCurrent = parseHeroPreviewKey(current);
      const valid = current
        && parsedCurrent
        && parsedCurrent.productId === baseId
        && group.entries.some(function (entry) { return entry.key === current; });
      if (!valid && group.entries.length) {
        setHeroPreviewKey(state, baseId, group.entries[0].key);
      }
    });
  }

  function getFeaturedColorNameForBase(state, base) {
    const baseId = getBaseProductKey(base);
    const parsed = parseHeroPreviewKey(getHeroPreviewKey(state, baseId));
    if (parsed && parsed.productId === baseId) return parsed.colorName;
    const entries = collectSelectedColorEntries(state).filter(function (entry) {
      return getBaseProductKey(entry.base) === baseId;
    });
    return entries.length ? entries[0].colorName : null;
  }

  async function renderHeroPreviewPicker(state, els, config) {
    if (!els.heroPreviewPicker || !els.heroPreviewGrid) return;
    if (heroPreviewRendering) return;
    heroPreviewRendering = true;

    const colorEntries = collectSelectedColorEntries(state);
    const hasDesign = ['front', 'back', 'neck'].some(function (side) {
      return hasDesignForSide(state, side);
    });

    if (!colorEntries.length || !hasDesign) {
      els.heroPreviewPicker.classList.add('creator-marketplace__hidden');
      els.heroPreviewGrid.innerHTML = '<p class="creator-marketplace__hint">Farben und Motiv wählen, um Startbilder zu sehen.</p>';
      heroPreviewRendering = false;
      return;
    }

    els.heroPreviewPicker.classList.remove('creator-marketplace__hidden');

    const uploadedSides = collectUploadedDesignSides(state);
    if (els.heroPreviewSide && uploadedSides.length) {
      els.heroPreviewSide.innerHTML = uploadedSides.map(function (sideKey) {
        return (
          '<option value="' + escapeHtml(sideKey) + '">' + escapeHtml(getSideLabel(sideKey)) + '</option>'
        );
      }).join('');
      if (uploadedSides.indexOf(state.heroPreviewSide) < 0) {
        state.heroPreviewSide = uploadedSides[0];
      }
      els.heroPreviewSide.value = state.heroPreviewSide;
    }

    const heroSide = state.heroPreviewSide || (els.heroPreviewSide && els.heroPreviewSide.value) || uploadedSides[0] || 'front';
    state.heroPreviewSide = heroSide;

    ensureDefaultHeroKeysForBases(state, colorEntries);

    const baseGroups = groupColorEntriesByBase(colorEntries);
    const multipleArticles = baseGroups.length > 1;

    els.heroPreviewGrid.innerHTML = baseGroups.map(function (group) {
      const baseId = getBaseProductKey(group.base);
      const selectedHeroKey = getHeroPreviewKey(state, baseId);
      const cardsHtml = group.entries.map(function (entry) {
        const hex = getVariantColorHex(entry.variant, entry.base) || '#ccc';
        const checked = selectedHeroKey === entry.key ? ' checked' : '';
        return (
          '<label class="creator-marketplace__hero-card">' +
          '<input type="radio" name="hero-preview-' + escapeHtml(baseId) + '" value="' + escapeHtml(entry.key) + '"' +
          checked + ' data-hero-preview-radio data-hero-base-id="' + escapeHtml(baseId) + '">' +
          '<span class="creator-marketplace__hero-card-swatch" style="background:' + escapeHtml(hex) + '"></span>' +
          '<span class="creator-marketplace__hero-card-thumb" data-hero-thumb="' + escapeHtml(entry.key) + '">' +
          '<span class="creator-marketplace__hero-card-loading">…</span></span>' +
          '<span class="creator-marketplace__hero-card-label">' + escapeHtml(entry.colorName) + '</span>' +
          (multipleArticles ? '' : ('<span class="creator-marketplace__hero-card-meta">' + escapeHtml(entry.base.name) + '</span>')) +
          '</label>'
        );
      }).join('');

      if (!multipleArticles) {
        return '<div class="creator-marketplace__hero-picker-colors">' + cardsHtml + '</div>';
      }

      return (
        '<div class="creator-marketplace__hero-picker-group" data-hero-picker-group="' + escapeHtml(baseId) + '">' +
        '<p class="creator-marketplace__hero-picker-group-title">' + escapeHtml(group.base.name) + '</p>' +
        '<div class="creator-marketplace__hero-picker-colors">' + cardsHtml + '</div>' +
        '</div>'
      );
    }).join('');

    const placementKey = getHeroPreviewPlacementKey(state, heroSide);

    try {
      for (let i = 0; i < colorEntries.length; i++) {
        const entry = colorEntries[i];
        const cacheKey = entry.key + '::' + placementKey;
        const thumbEl = els.heroPreviewGrid.querySelector('[data-hero-thumb="' + entry.key + '"]');
        if (!thumbEl) continue;

        try {
          let dataUrl = state.heroPreviewCache[cacheKey];
          if (!dataUrl) {
            const blob = await exportPreviewCanvas(state, entry.base, entry.variant, config, heroSide);
            dataUrl = await blobToDataUrl(blob);
            state.heroPreviewCache[cacheKey] = dataUrl;
          }
          thumbEl.innerHTML = '<img src="' + escapeHtml(dataUrl) + '" alt="">';
        } catch (_thumbErr) {
          thumbEl.innerHTML = '<span class="creator-marketplace__hero-card-loading">—</span>';
        }
      }
    } finally {
      heroPreviewRendering = false;
    }
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      const reader = new FileReader();
      reader.onload = function () { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async function hydrateRemoteDesignForCanvas(url) {
    if (!url || isDataUrl(url)) return url;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Motiv konnte nicht geladen werden');
    }
    const blob = await response.blob();
    return blobToDataUrl(blob);
  }

  function blobToBase64(blob) {
    return new Promise(function (resolve, reject) {
      const reader = new FileReader();
      reader.onload = function () {
        const result = String(reader.result || '');
        const base64 = result.includes(',') ? result.split(',')[1] : result;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  function showRenderedMockupCanvas(els, sourceCanvas) {
    if (els.mockupCanvas) {
      els.mockupCanvas.width = sourceCanvas.width;
      els.mockupCanvas.height = sourceCanvas.height;
      const ctx = els.mockupCanvas.getContext('2d');
      ctx.clearRect(0, 0, sourceCanvas.width, sourceCanvas.height);
      ctx.drawImage(sourceCanvas, 0, 0);
      els.mockupCanvas.hidden = false;
      els.mockupCanvas.removeAttribute('hidden');
      if (els.mockupBg) {
        els.mockupBg.hidden = true;
        els.mockupBg.setAttribute('hidden', '');
      }
      return true;
    }
    return false;
  }

  async function applyConfiguratorMockupAsync(state, els, config, base, variant, sideKey) {
    if (!els.mockupCanvas && !els.mockupBg) return;
    try {
      const rendered = await getMockupCanvasForSide(state, base, variant, sideKey, config);
      const canvas = rendered.canvas || rendered;
      const drawBounds = rendered.drawBounds || state.mockupDrawBounds || null;
      state.mockupDrawBounds = drawBounds;

      if (showRenderedMockupCanvas(els, canvas)) {
        state.currentMockupDataUrl = null;
      } else {
        const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
        if (els.mockupBg) {
          els.mockupBg.src = dataUrl;
          els.mockupBg.hidden = false;
        }
        state.currentMockupDataUrl = dataUrl;
      }

      const printArea = getEffectivePrintArea(base, variant, sideKey || state.activeSide, config);
      applyConfiguratorPrintArea(printArea, els, drawBounds);
      syncPlacementControls(state, els);
    } catch (mockupErr) {
      console.warn('[creator-marketplace] Mockup-Vorschau Fallback:', mockupErr);
      state.mockupDrawBounds = { ox: 0, oy: 0, dw: 1, dh: 1 };
      const mockupUrl = getMockupUrlForSide(base, variant, sideKey, config);
      if (els.mockupCanvas) els.mockupCanvas.hidden = true;
      applyConfiguratorMockup(state, els, config, mockupUrl);
      applyConfiguratorPrintArea(
        getEffectivePrintArea(base, variant, sideKey || state.activeSide, config),
        els,
        state.mockupDrawBounds,
      );
      syncPlacementControls(state, els);
    }
  }

  function renderPrintSideTabs(state, els, base, variant, config) {
    if (!els.printSideTabs) return;
    const sides = getPrintSides(base, variant, config);
    if (!sides.length) {
      els.printSideTabs.classList.add('creator-marketplace__hidden');
      els.printSideTabs.innerHTML = '';
      return;
    }

    if (!sides.some(function (s) { return s.key === state.activeSide; })) {
      state.activeSide = sides[0].key;
    }

    if (sides.length <= 1) {
      els.printSideTabs.classList.add('creator-marketplace__hidden');
      els.printSideTabs.innerHTML = '';
      return;
    }

    els.printSideTabs.classList.remove('creator-marketplace__hidden');
    els.printSideTabs.innerHTML = sides.map(function (side) {
      return (
        '<button type="button" class="creator-marketplace__print-side-tab' +
        (state.activeSide === side.key ? ' is-active' : '') +
        '" data-print-side="' + escapeHtml(side.key) + '">' +
        escapeHtml(side.label || PRINT_SIDE_LABELS[side.key] || side.key) +
        '</button>'
      );
    }).join('');
  }

  function syncPlacementControls(state, els) {
    const placement = getActivePlacement(state);
    const printArea = state.currentPrintArea || null;
    const aspect = getDesignImageAspectRatio(els);
    clampPlacementToPrintArea(placement, printArea, aspect, els);
    placement.scale = resolvePlacementScale(placement, printArea, aspect);
    syncPlacementCmFromScale(placement, printArea, aspect);

    if (els.designScale) {
      els.designScale.value = String(Math.round(placement.scale * 100));
    }
    if (els.designWidthCm && printArea && printArea.width_cm) {
      els.designWidthCm.value = placement.width_cm != null ? String(placement.width_cm) : '';
      els.designWidthCm.max = String(printArea.width_cm);
    }
    if (els.printAreaCmLabel) {
      els.printAreaCmLabel.textContent = formatPrintAreaCmLabel(printArea);
    }
    if (els.designSizeReadout) {
      els.designSizeReadout.textContent = placement.width_cm
        ? ('Motiv: ' + placement.width_cm + ' × ' + placement.height_cm + ' cm')
        : '—';
    }
    if (els.printAreaCmLabel && els.printAreaCmLabel.closest('[data-design-size-cm]')) {
      els.printAreaCmLabel.closest('[data-design-size-cm]').classList.toggle(
        'creator-marketplace__hidden',
        !(printArea && printArea.width_cm),
      );
    }
    setActivePlacement(state, placement);
    applyDesignPlacement(els, placement, placement.scale);
  }

  function normalizeShopifyBaseProduct(product, config) {
    const images = (product.images || []).map(function (img) {
      return { url: img.url, alt: img.alt };
    });
    const primaryImage = product.thumbnail_url || product.mockup_image_url || (images[0] && images[0].url) || null;
    const productPrintArea = normalizePrintArea(product.print_area || config.printArea, config.printArea);
    const productPrintSides = (product.print_sides && product.print_sides.length)
      ? product.print_sides
      : getPrintSides({ images: images, print_area: productPrintArea, primaryImageUrl: primaryImage }, null, config);

    const variants = (product.variants || []).map(function (v) {
      const displayTitle = formatVariantDisplayTitle(v) || v.title;
      const variantImages = v.image_url
        ? [{ url: v.image_url, alt: null }].concat(images.filter(function (img) { return img.url !== v.image_url; }))
        : images;
      const variantPrintSides = (v.print_sides && v.print_sides.length)
        ? v.print_sides
        : getPrintSides({
          images: variantImages,
          print_area: v.print_area || productPrintArea,
          primaryImageUrl: v.image_url || primaryImage,
        }, null, config);

      return {
        id: String(v.shopify_variant_id),
        shopify_variant_id: v.shopify_variant_id,
        title: displayTitle,
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        base_price: Number(v.base_price),
        image_url: v.image_url,
        mockup_image_url: v.mockup_image_url || primaryImage,
        print_area: v.print_area || productPrintArea,
        print_sides: variantPrintSides,
      };
    });

    return {
      id: String(product.block_id || product.shopify_product_id),
      shopify_product_id: product.shopify_product_id,
      block_id: product.block_id || null,
      shopify_gid: product.shopify_gid,
      name: product.title,
      slug: product.handle,
      description: product.description || '',
      base_price: Number(product.base_price),
      mockup_image_url: product.mockup_image_url || primaryImage,
      thumbnail_url: primaryImage,
      primaryImageUrl: primaryImage,
      images: images,
      variants: variants,
      print_area: productPrintArea,
      print_sides: productPrintSides,
      color_compositing: product.color_compositing || null,
      min_markup: config.minMarkup,
      max_markup: config.maxMarkup,
    };
  }

  function getVariantBasePrice(base, variant) {
    if (variant && variant.base_price != null) return Number(variant.base_price);
    return Number(base.base_price);
  }

  function isDataUrl(url) {
    return String(url || '').startsWith('data:');
  }

  function isCrossOriginUrl(url) {
    if (!url || isDataUrl(url)) return false;
    try {
      return new URL(url, window.location.href).origin !== window.location.origin;
    } catch (_e) {
      return false;
    }
  }

  function prepareImageElement(img, url) {
    if (isCrossOriginUrl(url)) {
      img.crossOrigin = 'anonymous';
    } else {
      img.removeAttribute('crossorigin');
    }
  }

  function loadCanvasImage(url) {
    return new Promise(function (resolve, reject) {
      const img = new Image();
      prepareImageElement(img, url);
      img.onload = function () { resolve(img); };
      img.onerror = function () {
        const fallback = new Image();
        fallback.onload = function () { resolve(fallback); };
        fallback.onerror = function () { reject(new Error('Bild konnte nicht geladen werden: ' + url)); };
        fallback.src = url;
      };
      img.src = url;
    });
  }

  function applyConfiguratorMockup(state, els, config, mockupUrl) {
    if (!mockupUrl) return;
    if (els.mockupCanvas) els.mockupCanvas.hidden = true;
    if (els.mockupBg) {
      prepareImageElement(els.mockupBg, mockupUrl);
      els.mockupBg.src = mockupUrl;
      els.mockupBg.hidden = false;
      els.mockupBg.removeAttribute('hidden');
    }
  }

  function applyConfiguratorPrintArea(printArea, els, drawBounds) {
    if (!els.printArea || !printArea) return;
    const b = drawBounds || { ox: 0, oy: 0, dw: 1, dh: 1 };
    els.printArea.style.left = ((b.ox + (printArea.x / 100) * b.dw) * 100) + '%';
    els.printArea.style.top = ((b.oy + (printArea.y / 100) * b.dh) * 100) + '%';
    els.printArea.style.width = (printArea.width * b.dw) + '%';
    els.printArea.style.height = (printArea.height * b.dh) + '%';
  }

  function applyDesignPlacement(els, placement, scaleOverride) {
    if (!els.designLayer) return;
    const scale = scaleOverride != null ? scaleOverride : (placement.scale || 1);
    els.designLayer.style.left = placement.x + '%';
    els.designLayer.style.top = placement.y + '%';
    els.designLayer.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
  }

  let configuratorScrollLockCount = 0;

  function lockConfiguratorScroll(lock) {
    if (lock) {
      configuratorScrollLockCount += 1;
      if (configuratorScrollLockCount === 1) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
      }
      return;
    }

    configuratorScrollLockCount = Math.max(0, configuratorScrollLockCount - 1);
    if (configuratorScrollLockCount === 0) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }
  }

  function bindDesignDrag(form, els, state, config) {
    if (!els.designLayer || !els.printArea || form.dataset.designDragBound) return;
    form.dataset.designDragBound = '1';

    const onMove = function (e) {
      if (!state.drag) return;
      if (e.cancelable) e.preventDefault();
      const placement = getActivePlacement(state);
      const rect = els.printArea.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const x = ((clientX - rect.left) / rect.width) * 100;
      const y = ((clientY - rect.top) / rect.height) * 100;
      placement.x = x;
      placement.y = y;
      clampPlacementToPrintArea(
        placement,
        state.currentPrintArea,
        getDesignImageAspectRatio(els),
        els,
      );
      setActivePlacement(state, placement);
      applyDesignPlacement(els, placement, placement.scale);
    };

    const endDrag = function () {
      if (state.drag) {
        syncPlacementControls(state, els);
        scheduleHeroPreviewRefresh(state, els, config, { delay: 400 });
        lockConfiguratorScroll(false);
      }
      state.drag = false;
    };

    els.designLayer.addEventListener('mousedown', function (e) {
      if (e.target.closest('[data-design-resize]')) return;
      e.preventDefault();
      state.drag = true;
      state.resize = false;
    });
    els.designLayer.addEventListener('touchstart', function (e) {
      if (e.target.closest('[data-design-resize]')) return;
      e.preventDefault();
      state.drag = true;
      state.resize = false;
      lockConfiguratorScroll(true);
    }, { passive: false });

    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);
    window.addEventListener('touchcancel', endDrag);
  }

  function bindDesignResize(form, els, state, config) {
    if (!els.designResize || !els.printArea || form.dataset.designResizeBound) return;
    form.dataset.designResizeBound = '1';

    const onResizeMove = function (e) {
      if (!state.resize) return;
      if (e.cancelable) e.preventDefault();
      const placement = getActivePlacement(state);
      const rect = els.printArea.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const centerX = rect.left + (placement.x / 100) * rect.width;
      const centerY = rect.top + (placement.y / 100) * rect.height;
      const dx = Math.abs(clientX - centerX);
      const dy = Math.abs(clientY - centerY);
      const aspect = getDesignImageAspectRatio(els);
      const scaleFromW = (2 * dx) / Math.max(rect.width, 1);
      const scaleFromH = aspect > 0 ? (2 * dy) / Math.max(rect.width * aspect, 1) : scaleFromW;
      placement.scale = clamp(Math.max(scaleFromW, scaleFromH), 0.05, 2);
      delete placement.width_cm;
      delete placement.height_cm;
      clampPlacementToPrintArea(
        placement,
        state.currentPrintArea,
        getDesignImageAspectRatio(els),
        els,
      );
      setActivePlacement(state, placement);
      syncPlacementControls(state, els);
    };

    const endResize = function () {
      if (state.resize) {
        scheduleHeroPreviewRefresh(state, els, config, { delay: 400 });
        lockConfiguratorScroll(false);
      }
      state.resize = false;
    };

    const startResize = function (e) {
      e.preventDefault();
      e.stopPropagation();
      state.resize = true;
      state.drag = false;
      lockConfiguratorScroll(true);
    };

    els.designResize.addEventListener('mousedown', startResize);
    els.designResize.addEventListener('touchstart', startResize, { passive: false });
    window.addEventListener('mousemove', onResizeMove);
    window.addEventListener('touchmove', onResizeMove, { passive: false });
    window.addEventListener('mouseup', endResize);
    window.addEventListener('touchend', endResize);
    window.addEventListener('touchcancel', endResize);
  }

  function updatePriceBreakdown(state, els) {
    const entries = getSelectedVariantEntries(state);
    const markup = els.markupInput ? parseFloat(els.markupInput.value) : 0;
    const surchargeRange = getSideSurchargeRangeForState(state);

    if (!entries.length) {
      if (els.basePriceDisplay) els.basePriceDisplay.textContent = '—';
      if (els.sideSurchargeDisplay) {
        els.sideSurchargeDisplay.textContent = surchargeRange.min === surchargeRange.max
          ? formatMoney(surchargeRange.min)
          : formatMoney(surchargeRange.min) + ' – ' + formatMoney(surchargeRange.max);
      }
      if (els.markupDisplay) els.markupDisplay.textContent = formatMoney(markup);
      if (els.finalPriceDisplay) els.finalPriceDisplay.textContent = '—';
      return;
    }

    const basePrices = entries.map(function (e) { return getVariantBasePrice(e.base, e.variant); });
    const surchargeTotals = entries.map(function (e) {
      return calculateSideSurchargeForBase(e.base, collectActiveDesignSides(state));
    });
    const minBase = Math.min.apply(null, basePrices);
    const maxBase = Math.max.apply(null, basePrices);
    const minSurcharge = Math.min.apply(null, surchargeTotals);
    const maxSurcharge = Math.max.apply(null, surchargeTotals);
    const minFinal = roundMoney(minBase + markup + minSurcharge);
    const maxFinal = roundMoney(maxBase + markup + maxSurcharge);

    if (els.basePriceDisplay) {
      els.basePriceDisplay.textContent = minBase === maxBase
        ? formatMoney(minBase)
        : formatMoney(minBase) + ' – ' + formatMoney(maxBase);
    }
    if (els.sideSurchargeDisplay) {
      els.sideSurchargeDisplay.textContent = minSurcharge === maxSurcharge
        ? formatMoney(minSurcharge)
        : formatMoney(minSurcharge) + ' – ' + formatMoney(maxSurcharge);
    }
    if (els.markupDisplay) els.markupDisplay.textContent = formatMoney(markup);
    if (els.finalPriceDisplay) {
      els.finalPriceDisplay.textContent = minFinal === maxFinal
        ? formatMoney(minFinal)
        : formatMoney(minFinal) + ' – ' + formatMoney(maxFinal);
    }
  }

  async function invokeProductFunction(client, functionName, payload) {
    const { data, error } = await client.functions.invoke(functionName, { body: payload });
    let response = data;
    if (error) {
      const detail = await readFunctionError(error);
      if (detail) throw new Error(detail);
      if (data && (data.error || data.success === false)) response = data;
      else throw new Error(error.message || 'Edge Function Fehler');
    }
    return response;
  }

  async function submitProductForm(root, client, config, productForm, shopifyPayloadFn, creator) {
    if (!creator) {
      showFormFeedback(productForm, 'Creator-Profil nicht geladen. Bitte Seite neu laden.', 'error');
      return;
    }

    if (!config.loginRequired && !config.shopifyCustomerId) {
      showFormFeedback(
        productForm,
        'Vorschau-Modus — Speichern ist nur mit aktivem Shopify-Login möglich.',
        'error',
      );
      showMessage(root, 'Vorschau-Modus — Speichern nicht möglich.', 'info');
      return;
    }

    clearMessage(root);
    syncRichTextEditors(productForm);

    if (creator.status !== 'approved') {
      const msg = 'Dein Account muss erst freigeschaltet werden. Bitte den Shop-Betreiber kontaktieren.';
      showMessage(root, msg, 'info');
      showFormFeedback(productForm, msg, 'error');
      return;
    }

    const editingId = productForm.querySelector('[data-editing-product-id]').value.trim();
    const editingProduct = editingId
      ? (root._creatorProducts || []).find(function (p) { return p.id === editingId; })
      : null;
    if (editingId && !editingProduct) {
      showFormFeedback(productForm, 'Dieser Artikel existiert nicht mehr. Bitte neu anlegen.', 'error');
      await closeProductStudio(root, client, config, creator);
      return;
    }

    const listingType = editingId
      ? (editingProduct && editingProduct.listing_type) || getActiveListingType(root, config)
      : getActiveListingType(root, config);

    const submitBtn = productForm.querySelector('[data-product-submit]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = editingId ? 'Speichern…' : 'Wird erstellt…';
    }
    hideProductSaveProgress(productForm);

    try {
      let response;
      if (listingType === 'own') {
        showProductSaveProgress(productForm, editingId
          ? [
            { id: 'upload', label: 'Daten werden vorbereitet…' },
            { id: 'shopify', label: 'Shopify wird aktualisiert…' },
          ]
          : [
            { id: 'upload', label: 'Bild wird hochgeladen…' },
            { id: 'shopify', label: 'Produkt wird erstellt…' },
          ]);
        response = await submitOwnProduct(root, client, config, productForm, shopifyPayloadFn, creator, editingId);
      } else {
        response = await submitDropshipProduct(root, client, config, productForm, shopifyPayloadFn, creator, editingId);
      }

      if (!response || response.success === false) {
        const msg = response && response.error
          ? (response.partial
            ? 'In Supabase gespeichert, Shopify-Sync fehlgeschlagen: ' + response.error
            : response.error)
          : 'Unbekannter Fehler beim Speichern';
        showMessage(root, msg, response && response.partial ? 'info' : 'error');
        showFormFeedback(productForm, msg, 'error');
        if (editingId && /nicht gefunden/i.test(msg)) {
          await closeProductStudio(root, client, config, creator);
        }
        return;
      }

      let successMsg = editingId ? 'Produkt erfolgreich aktualisiert!' : 'Produkt erfolgreich angelegt!';
      if (response && response.articles_created > 1) {
        successMsg = response.articles_created + ' Artikel erfolgreich angelegt!';
      } else if (response && response.created_count > 1 && !response.articles_created) {
        successMsg = response.created_count + ' Produkte erfolgreich angelegt!';
      }
      if (response && response.errors && response.errors.length) {
        successMsg += ' (' + response.errors.length + ' fehlgeschlagen)';
      }
      showMessage(root, successMsg, 'success');
      showFormFeedback(productForm, successMsg, 'success');

      showProductsListView(root);
      await resetProductFormForCreate(root, client, config, creator);
      if (root._creatorReloadPortal) await root._creatorReloadPortal();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Unbekannter Fehler beim Speichern';
      showMessage(root, msg, 'error');
      showFormFeedback(productForm, msg, 'error');
    } finally {
      hideProductSaveProgress(productForm);
      if (submitBtn) {
        submitBtn.disabled = false;
        const isEditing = productForm.querySelector('[data-editing-product-id]').value.trim();
        if (!isEditing) {
          submitBtn.textContent = getActiveListingType(root, config) === 'own'
            ? 'Eigenes Produkt veröffentlichen'
            : 'Dropshipping-Produkt veröffentlichen';
        } else {
          submitBtn.textContent = 'Änderungen speichern';
        }
      }
    }
  }

  async function submitOwnProduct(root, client, config, productForm, shopifyPayloadFn, creator, editingId) {
    const title = productForm.querySelector('[name="own_title"]').value.trim();
    const price = parseFloat(productForm.querySelector('[name="own_price"]').value);
    const inventory = parseInt(productForm.querySelector('[data-own-inventory]').value, 10) || 0;
    const status = productForm.querySelector('[data-status-own]').value;
    const ownDescField = productForm.querySelector('[name="own_description"]');
    const description = getRichTextContent(ownDescField);
    const ownState = ownFormStore.get(root) || { imageFile: null, existingImageUrl: null };

    const titleError = validateProductTitle(title);
    if (titleError) throw new Error(titleError);
    if (!price || price <= 0) throw new Error('Bitte einen gültigen Preis eingeben.');
    if (!editingId && !ownState.imageFile) throw new Error('Bitte ein Produktbild hochladen.');

    let imageUrl = ownState.existingImageUrl;
    if (ownState.imageFile) {
      setProductSaveStep(productForm, 'upload', 'active');
      imageUrl = await uploadToCreatorStorage(
        client,
        'image',
        Date.now() + '-' + sanitizeFilename(ownState.imageFile.name),
        ownState.imageFile,
        null,
        shopifyPayloadFn(),
      );
      setProductSaveStep(productForm, 'upload', 'done');
    } else {
      setProductSaveStep(productForm, 'upload', 'done');
    }

    const payload = Object.assign({
      title: title,
      description: description,
      price: price,
      image_url: imageUrl,
      inventory_quantity: inventory,
      status: status,
      platform_commission_rate: config.ownListingCommissionRate,
    }, shopifyPayloadFn());

    setProductSaveStep(productForm, 'shopify', 'active');
    if (editingId) {
      const response = await invokeProductFunction(client, 'update-shopify-product', Object.assign({ product_id: editingId }, payload));
      setProductSaveStep(productForm, 'shopify', 'done');
      return response;
    }

    const response = await invokeProductFunction(client, 'create-shopify-product', Object.assign({ listing_type: 'own' }, payload));
    setProductSaveStep(productForm, 'shopify', 'done');
    return response;
  }

  async function submitDropshipProduct(root, client, config, productForm, shopifyPayloadFn, creator, editingId) {
    const state = configuratorStore.get(root);
    if (!state) throw new Error('Konfigurator nicht geladen.');

    const title = productForm.querySelector('[name="title"]').value.trim();
    const titleError = validateProductTitle(title);
    if (titleError) throw new Error(titleError);

    const markupInput = productForm.querySelector('[data-creator-markup]');
    const creatorMarkup = markupInput ? parseFloat(markupInput.value) : 0;
    const minMarkup = Number(config.minMarkup || 0);
    const maxMarkup = Number(config.maxMarkup || 50);
    if (creatorMarkup < minMarkup || creatorMarkup > maxMarkup) {
      throw new Error('Provision muss zwischen ' + formatMoney(minMarkup) + ' und ' + formatMoney(maxMarkup) + ' liegen.');
    }

    const status = productForm.querySelector('[data-status-dropship]').value;
    const descField = productForm.querySelector('[name="description"]');
    const description = getRichTextContent(descField);

    let groups = groupSelectedByBaseProduct(state);
    const uploadedSides = collectUploadedDesignSides(state);

    if (editingId) {
      const editingProduct = (root._creatorProducts || []).find(function (p) {
        return p.id === editingId;
      });
      if (editingProduct) {
        const relatedProducts = (root._creatorProducts || []).filter(function (p) {
          return editingProduct.shopify_product_id && p.shopify_product_id === editingProduct.shopify_product_id;
        });
        ensureEditColorSelection(state, editingProduct, relatedProducts);
        groups = groupSelectedByBaseProduct(state);
      }
    }

    if (!editingId && !uploadedSides.length) {
      throw new Error('Bitte mindestens ein Motiv hochladen (eine Druckseite reicht).');
    }

    const shouldRefreshPreviews = editingId
      ? needsDropshipPreviewRefresh(
        state,
        (root._creatorProducts || []).find(function (p) { return p.id === editingId; }),
        (root._creatorProducts || []).filter(function (p) {
          const editingProduct = (root._creatorProducts || []).find(function (row) { return row.id === editingId; });
          return editingProduct && editingProduct.shopify_product_id && p.shopify_product_id === editingProduct.shopify_product_id;
        }),
        uploadedSides,
        groups,
      )
      : true;

    showProductSaveProgress(productForm, editingId
      ? [
        { id: 'design', label: 'Motiv wird vorbereitet…' },
        { id: 'preview', label: shouldRefreshPreviews ? 'Vorschau wird erstellt…' : 'Vorschau wird übernommen…' },
        { id: 'shopify', label: 'Shopify wird aktualisiert…' },
      ]
      : [
        { id: 'design', label: 'Motiv wird hochgeladen…' },
        { id: 'preview', label: 'Vorschau wird erstellt…' },
        { id: 'shopify', label: 'Artikel wird erstellt…' },
      ]);

    setProductSaveStep(productForm, 'design', 'active');
    const designPayload = await buildDesignPayloadForSides(
      state,
      creator,
      client,
      editingId,
      uploadedSides.length ? uploadedSides : ['front'],
      shopifyPayloadFn(),
      config,
    );
    setProductSaveStep(productForm, 'design', 'done');
    if (!editingId && !designPayload.designUrl) {
      throw new Error('Bitte mindestens ein Motiv hochladen.');
    }

    const activeDesignSides = collectActiveDesignSides(state);

    const basePayload = {
      title: title,
      description: description,
      min_markup: config.minMarkup,
      max_markup: config.maxMarkup,
      design_placement: designPayload.design_placement,
      design_url: designPayload.designUrl,
      design_urls: designPayload.designUrls,
      creator_markup: creatorMarkup,
      status: status,
    };

    if (editingId) {
      const editingProduct = (root._creatorProducts || []).find(function (p) {
        return p.id === editingId;
      });
      if (!editingProduct) {
        throw new Error('Dieser Artikel existiert nicht mehr.');
      }

      if (!groups.length) {
        throw new Error('Bitte mindestens eine Farbe auswählen.');
      }

      const relatedProducts = (root._creatorProducts || []).filter(function (p) {
        return editingProduct.shopify_product_id && p.shopify_product_id === editingProduct.shopify_product_id;
      });
      const shouldRefreshShopifyImages = shouldRefreshPreviews;
      const previewSide = state.heroPreviewSide || 'front';
      const designUrl = designPayload.designUrl || editingProduct.design_url;
      const previewCache = {};
      let featuredPreviewUrl = null;

      function findExistingProductRow(base, variant) {
        return relatedProducts.find(function (rel) {
          return Number(rel.shopify_base_variant_id) === Number(variant.shopify_variant_id)
            && Number(rel.shopify_base_product_id) === Number(base.shopify_product_id);
        }) || null;
      }

      function getExistingPreviewUrl(base, colorName) {
        for (let i = 0; i < relatedProducts.length; i++) {
          const rel = relatedProducts[i];
          const relVariant = base.variants.find(function (v) {
            return v.shopify_variant_id === Number(rel.shopify_base_variant_id);
          });
          if (!relVariant) continue;
          if (getVariantColorName(relVariant, base) !== colorName) continue;
          if (rel.preview_url) return rel.preview_url;
        }
        return null;
      }

      async function getColorPreviewUrl(base, colorName) {
        const cacheKey = String(base.shopify_product_id) + '::' + colorName + '::' + previewSide;
        if (previewCache[cacheKey]) return previewCache[cacheKey];

        if (!shouldRefreshShopifyImages) {
          const existing = getExistingPreviewUrl(base, colorName);
          previewCache[cacheKey] = existing || designUrl;
          return previewCache[cacheKey];
        }

        const sampleVariant = findVariantForColor(base, colorName);
        if (!sampleVariant) return designUrl;
        const previewBlob = await exportPreviewCanvas(state, base, sampleVariant, config, previewSide);
        const url = await uploadToCreatorStorage(
          client,
          'preview',
          Date.now() + '-' + cacheKey.replace(/[^a-zA-Z0-9_-]/g, '_') + '.jpg',
          previewBlob,
          'image/jpeg',
          shopifyPayloadFn(),
        );
        previewCache[cacheKey] = url;
        return url;
      }

      ensureDefaultHeroKeysForBases(state, collectSelectedColorEntries(state));

      const group = groups[0];
      const featuredColorName = getFeaturedColorNameForBase(state, group.base);
      const uniqueColors = [];
      const seenColors = {};
      group.variants.forEach(function (variant) {
        const colorName = getVariantColorName(variant, group.base);
        if (!colorName || seenColors[colorName]) return;
        seenColors[colorName] = true;
        uniqueColors.push(colorName);
      });

      setProductSaveStep(productForm, 'preview', 'active');
      if (shouldRefreshShopifyImages && uniqueColors.length) {
        let previewDone = 0;
        await runWithConcurrency(uniqueColors, 3, async function (colorName) {
          await getColorPreviewUrl(group.base, colorName);
          previewDone += 1;
          setProductSaveStep(
            productForm,
            'preview',
            'active',
            previewDone + ' / ' + uniqueColors.length + ' Farben',
          );
        });
      } else if (!shouldRefreshShopifyImages) {
        setProductSaveStep(productForm, 'preview', 'active', 'bestehende Vorschauen');
      }
      setProductSaveStep(productForm, 'preview', 'done');

      if (featuredColorName) {
        featuredPreviewUrl = await getColorPreviewUrl(group.base, featuredColorName);
      }

      const colorImagePlans = {};
      const dropshipVariants = [];

      for (let j = 0; j < group.variants.length; j++) {
        const variant = group.variants[j];
        const colorName = getVariantColorName(variant, group.base);
        let previewUrl = designUrl;
        const updateImage = shouldRefreshShopifyImages;

        if (colorName) {
          previewUrl = await getColorPreviewUrl(group.base, colorName);
          const shopifyColorKey = getVariantColorName(variant, group.base) || colorName;
          if (!colorImagePlans[shopifyColorKey]) {
            colorImagePlans[shopifyColorKey] = {
              color_key: shopifyColorKey,
              preview_url: previewUrl,
              update_image: updateImage,
            };
          }
        }

        if (!featuredPreviewUrl) featuredPreviewUrl = previewUrl;
        const existingRow = findExistingProductRow(group.base, variant);
        dropshipVariants.push({
          shopify_base_variant_id: variant.shopify_variant_id,
          preview_url: previewUrl,
          color_name: colorName || null,
          creator_product_id: existingRow ? existingRow.id : null,
          update_image: updateImage,
        });
      }

      setProductSaveStep(productForm, 'shopify', 'active');
      const updateResponse = await invokeProductFunction(client, 'update-shopify-product', Object.assign({
        product_id: editingId,
        shopify_base_product_id: group.base.shopify_product_id,
        dropship_variants: dropshipVariants,
        color_images: Object.keys(colorImagePlans).map(function (key) {
          return colorImagePlans[key];
        }),
        featured_preview_url: featuredPreviewUrl,
        featured_color_name: featuredColorName || null,
        color_option: (group.base.color_compositing && group.base.color_compositing.color_option) || 'option2',
        catalog_source: root.dataset.baseCatalogSource || 'shopify-tag',
        print_side_surcharge_total: calculateSideSurchargeForBase(group.base, activeDesignSides),
      }, basePayload, shopifyPayloadFn()));
      setProductSaveStep(productForm, 'shopify', 'done');
      return updateResponse;
    }

    if (!groups.length) throw new Error('Bitte mindestens einen Artikel mit einer Farbe auswählen.');

    ensureDefaultHeroKeysForBases(state, collectSelectedColorEntries(state));

    const designUrl = designPayload.designUrl;
    const previewSide = state.heroPreviewSide || 'front';

    const errors = [];
    let articlesCreated = 0;
    let variantRowsCreated = 0;
    const batchId = Date.now();

    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      setProductSaveStep(
        productForm,
        'preview',
        'active',
        'Artikel ' + (i + 1) + ' von ' + groups.length + ' (' + group.base.name + ')',
      );
      setProductSaveStep(productForm, 'shopify', 'active', group.base.name);

      const previewCache = {};
      let featuredPreviewUrl = null;

      async function getColorPreviewUrl(base, colorName) {
        const cacheKey = String(base.shopify_product_id) + '::' + colorName + '::' + previewSide;
        if (previewCache[cacheKey]) return previewCache[cacheKey];
        const sampleVariant = findVariantForColor(base, colorName);
        if (!sampleVariant) return designUrl;
        try {
          const previewBlob = await exportPreviewCanvas(state, base, sampleVariant, config, previewSide);
          const previewPath = creator.id + '/previews/' + batchId + '-' + cacheKey.replace(/[^a-zA-Z0-9_-]/g, '_') + '.jpg';
          const url = await uploadToCreatorStorage(
            client,
            'preview',
            batchId + '-' + cacheKey.replace(/[^a-zA-Z0-9_-]/g, '_') + '.jpg',
            previewBlob,
            'image/jpeg',
            shopifyPayloadFn(),
          );
          previewCache[cacheKey] = url;
          return url;
        } catch (previewErr) {
          console.warn('Vorschau für Farbe übersprungen:', previewErr);
          return designUrl;
        }
      }

      const featuredColorName = getFeaturedColorNameForBase(state, group.base);
      const uniqueCreateColors = [];
      const seenCreateColors = {};
      group.variants.forEach(function (variant) {
        const colorName = getVariantColorName(variant, group.base);
        if (!colorName || seenCreateColors[colorName]) return;
        seenCreateColors[colorName] = true;
        uniqueCreateColors.push(colorName);
      });

      let createPreviewDone = 0;
      await runWithConcurrency(uniqueCreateColors, 3, async function (colorName) {
        await getColorPreviewUrl(group.base, colorName);
        createPreviewDone += 1;
        setProductSaveStep(
          productForm,
          'preview',
          'active',
          'Artikel ' + (i + 1) + '/' + groups.length + ' · ' + createPreviewDone + '/' + uniqueCreateColors.length + ' Farben',
        );
      });

      if (featuredColorName) {
        featuredPreviewUrl = await getColorPreviewUrl(group.base, featuredColorName);
      }

      const dropshipVariants = [];
      for (let j = 0; j < group.variants.length; j++) {
        const variant = group.variants[j];
        const colorName = getVariantColorName(variant, group.base);
        let previewUrl = designUrl;
        if (colorName) {
          previewUrl = await getColorPreviewUrl(group.base, colorName);
        } else {
          try {
            const previewBlob = await exportPreviewCanvas(state, group.base, variant, config, previewSide);
            const key = variantSelectionKey(group.base, variant);
            const previewPath = creator.id + '/previews/' + batchId + '-' + key + '.jpg';
            previewUrl = await uploadToCreatorStorage(
              client,
              'preview',
              batchId + '-' + key + '.jpg',
              previewBlob,
              'image/jpeg',
              shopifyPayloadFn(),
            );
          } catch (previewErr) {
            console.warn('Vorschau für Variante übersprungen:', previewErr);
          }
        }
        if (!featuredPreviewUrl) featuredPreviewUrl = previewUrl;
        dropshipVariants.push({
          shopify_base_variant_id: variant.shopify_variant_id,
          preview_url: previewUrl,
          color_name: colorName || null,
        });
      }

      setProductSaveStep(productForm, 'preview', 'done');

      try {
        setProductSaveStep(productForm, 'shopify', 'active', group.base.name);
        const response = await invokeProductFunction(client, 'create-shopify-product', Object.assign({
          listing_type: 'dropship',
          shopify_base_product_id: group.base.shopify_product_id,
          dropship_variants: dropshipVariants,
          design_url: designUrl,
          featured_preview_url: featuredPreviewUrl,
          featured_color_name: featuredColorName || null,
          color_option: (group.base.color_compositing && group.base.color_compositing.color_option) || 'option2',
          catalog_source: root.dataset.baseCatalogSource || 'shopify-tag',
          print_side_surcharge_total: calculateSideSurchargeForBase(group.base, activeDesignSides),
        }, basePayload, shopifyPayloadFn()));

        if (response && response.success) {
          articlesCreated += response.articles_created || 1;
          variantRowsCreated += response.created_count || dropshipVariants.length;
        } else {
          errors.push((response && response.error) || 'Unbekannter Fehler');
        }
      } catch (err) {
        errors.push(err.message || 'Fehler');
      }
    }

    if (!articlesCreated) {
      throw new Error(errors[0] || 'Keine Artikel erstellt');
    }

    setProductSaveStep(productForm, 'shopify', 'done');
    return {
      success: true,
      articles_created: articlesCreated,
      created_count: variantRowsCreated,
      errors: errors,
    };
  }

  async function uploadToCreatorStorage(client, assetType, filename, fileOrBlob, contentType, shopifyPayload, extraFields) {
    const body = fileOrBlob instanceof File ? fileOrBlob : fileOrBlob;
    const type = contentType || (fileOrBlob instanceof File ? fileOrBlob.type : 'application/octet-stream');
    const dataBase64 = await blobToBase64(body);

    const { data, error } = await client.functions.invoke('upload-creator-asset', {
      body: Object.assign({
        asset_type: assetType || 'design',
        filename: filename || 'upload.bin',
        content_type: type,
        data_base64: dataBase64,
      }, shopifyPayload || {}, extraFields || {}),
    });

    if (error) {
      const detail = await readFunctionError(error);
      throw new Error('Upload fehlgeschlagen: ' + (detail || error.message));
    }
    if (!data || !data.success || !data.url) {
      throw new Error('Upload fehlgeschlagen: ' + ((data && data.error) || 'Unbekannter Fehler'));
    }
    return data.url;
  }

  async function exportPreviewCanvas(state, base, variant, config, sideKey) {
    let exportSide = sideKey || state.activeSide || 'front';
    let designDataUrl = getDesignForSide(state, exportSide).dataUrl;
    if (!designDataUrl) {
      const uploaded = collectUploadedDesignSides(state);
      if (uploaded.length) {
        exportSide = uploaded[0];
        designDataUrl = getDesignForSide(state, exportSide).dataUrl;
      }
    }
    if (!designDataUrl || !base) {
      throw new Error('Vorschau konnte nicht erstellt werden');
    }

    const placements = ensureConfiguratorPlacements(state);
    const placement = placements[exportSide] || placements.front || defaultPlacementPoint();
    const mockupResult = await getMockupCanvasForSide(state, base, variant, exportSide, config);
    const mockupCanvas = mockupResult.canvas || mockupResult;
    const drawBounds = mockupResult.drawBounds || { ox: 0, oy: 0, dw: 1, dh: 1 };
    const designImage = await loadCanvasImage(designDataUrl);

    const width = mockupCanvas.width || MOCKUP_CANVAS_SIZE;
    const height = mockupCanvas.height || MOCKUP_CANVAS_SIZE;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(mockupCanvas, 0, 0, width, height);

    const area = getEffectivePrintArea(base, variant, exportSide, config) || normalizePrintArea(null, config.printArea);
    const imageAspect = designImage.naturalWidth > 0
      ? designImage.naturalHeight / designImage.naturalWidth
      : 1;
    const clampedPlacement = Object.assign({}, placement);
    clampPlacementToPrintArea(clampedPlacement, area, imageAspect, null, drawBounds);
    const drawRect = computeDesignDrawRect(
      clampedPlacement,
      area,
      drawBounds,
      width,
      designImage.naturalWidth,
      designImage.naturalHeight,
    );

    ctx.drawImage(
      designImage,
      drawRect.x,
      drawRect.y,
      drawRect.w,
      drawRect.h,
    );

    try {
      return await new Promise(function (resolve, reject) {
        canvas.toBlob(function (b) {
          if (b) resolve(b);
          else reject(new Error('Vorschau-Export fehlgeschlagen'));
        }, 'image/jpeg', 0.92);
      });
    } catch (err) {
      if (err && (err.name === 'SecurityError' || /insecure/i.test(String(err.message)))) {
        throw new Error('Vorschau-Export blockiert (Cross-Origin Bild)');
      }
      throw err;
    }
  }

  function dataUrlToBlob(dataUrl) {
    return new Promise(function (resolve, reject) {
      try {
        const parts = dataUrl.split(',');
        const mime = parts[0].match(/:(.*?);/)[1];
        const binary = atob(parts[1]);
        const len = binary.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) arr[i] = binary.charCodeAt(i);
        resolve(new Blob([arr], { type: mime }));
      } catch (e) {
        reject(e);
      }
    });
  }

  function sanitizeFilename(name) {
    return String(name).replace(/[^a-zA-Z0-9._-]/g, '-');
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function roundMoney(value) {
    return Math.round(value * 100) / 100;
  }
})();
